import type { RecordingDetails } from "../openapi-aliases";

export const recordingBdr: RecordingDetails = {
  id: "00068000-11fb-8302-aaaa-bbbbbbbbbbbb",
  user_id: "00068000-11fb-8302-8c10-1a913601212b",
  name: "BDR work",
  date_started: "2025-02-04T09:47:56.269",
  date_ended: "2025-02-04T16:45:38.988",
  relative_path_on_disk: "recording_2025-02-04_09_47_13",
  status: {
    status: "completed",
    result: {
      startTimestamp: 1738658833,
      endTimestamp: 1738683931,
      durationSeconds: 25098,
      nodes: [
        {
          id: 82001,
          depth: 2,
          name: "reply-email",
          goal: "Draft and send a sample follow-up to Demo Contact 17 using Claude and lemlist.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 18.6,
            },
            {
              name: "app.lemlist.duration_s",
              value: 15.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00001_051.png",
                "demo_alpha_frame_00002_334.png",
                "demo_alpha_frame_00003_445.png",
              ],
            },
          ],
          coverage: [["2025-02-04T08:47:13Z", "2025-02-04T08:47:48.860Z"]],
          duration_s: 35.9,
        },
        {
          id: 82002,
          depth: 2,
          name: "close-thread",
          goal: "Review the fictional conversation in #demo-ops-24 and post a sample status update using lemlist.",
          attributes: [
            {
              name: "app.lemlist.duration_s",
              value: 7.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00004_653.png"],
            },
          ],
          coverage: [["2025-02-04T08:47:53.495Z", "2025-02-04T08:48:07.483Z"]],
          duration_s: 14.0,
        },
        {
          id: 82003,
          depth: 2,
          name: "review-calendar",
          goal: "Review a sample calendar entry for Demo Account 31 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 30.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00005_369.png",
                "demo_alpha_frame_00006_759.png",
                "demo_alpha_frame_00007_941.png",
              ],
            },
          ],
          coverage: [["2025-02-04T08:48:08.219Z", "2025-02-04T08:48:38.231Z"]],
          duration_s: 30.0,
        },
        {
          id: 82004,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-38 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 14.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00008_996.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 62",
              qualifier: "messaged",
            },
            {
              object: "Demo Item 79",
              qualifier: "navigated-to",
            },
          ],
          coverage: [["2025-02-04T08:48:38.824Z", "2025-02-04T08:48:54.003Z"]],
          duration_s: 15.2,
        },
        {
          id: 82005,
          depth: 2,
          name: "review-opportunity",
          goal: "Open the fictional record for Demo Account 45 and update its sample fields in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 309.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00009_478.png",
                "demo_alpha_frame_00010_430.png",
                "demo_alpha_frame_00011_433.png",
                "demo_alpha_frame_00012_345.png",
                "demo_alpha_frame_00013_504.png",
                "demo_alpha_frame_00014_454.png",
                "demo_alpha_frame_00015_424.png",
                "demo_alpha_frame_00016_239.png",
                "demo_alpha_frame_00017_560.png",
                "demo_alpha_frame_00018_275.png",
                "demo_alpha_frame_00019_754.png",
                "demo_alpha_frame_00020_461.png",
                "demo_alpha_frame_00021_197.png",
                "demo_alpha_frame_00022_975.png",
                "demo_alpha_frame_00023_258.png",
                "demo_alpha_frame_00024_030.png",
                "demo_alpha_frame_00025_783.png",
                "demo_alpha_frame_00026_412.png",
                "demo_alpha_frame_00027_564.png",
                "demo_alpha_frame_00028_634.png",
                "demo_alpha_frame_00029_836.png",
                "demo_alpha_frame_00030_696.png",
                "demo_alpha_frame_00031_022.png",
                "demo_alpha_frame_00032_798.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 73",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T08:48:58.096Z", "2025-02-04T08:54:10.064Z"]],
          duration_s: 312.0,
        },
        {
          id: 82006,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Slack and LinkedIn to continue Sample Workflow 52.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 15.7,
            },
            {
              name: "app.LinkedIn.duration_s",
              value: 4.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00033_582.png",
                "demo_alpha_frame_00034_604.png",
                "demo_alpha_frame_00035_883.png",
              ],
            },
          ],
          coverage: [["2025-02-04T08:54:13.177Z", "2025-02-04T08:54:33.764Z"]],
          duration_s: 20.6,
        },
        {
          id: 82007,
          depth: 2,
          name: "create-opportunity",
          goal: "Open the fictional record for Demo Account 59 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 56.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00036_444.png",
                "demo_alpha_frame_00037_000.png",
                "demo_alpha_frame_00038_624.png",
                "demo_alpha_frame_00039_308.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 95",
              qualifier: "reviewed-meetings",
            },
            {
              object: "Demo Account 15",
              qualifier: "created-opportunity",
            },
          ],
          coverage: [["2025-02-04T08:54:37.836Z", "2025-02-04T08:55:34.520Z"]],
          duration_s: 56.7,
        },
        {
          id: 82008,
          depth: 2,
          name: "filter-meetings",
          goal: "Review a sample calendar entry for Demo Account 66 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 6.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00040_014.png"],
            },
          ],
          coverage: [["2025-02-04T08:55:38.019Z", "2025-02-04T08:55:44.265Z"]],
          duration_s: 6.2,
        },
        {
          id: 82009,
          depth: 2,
          name: "review-meeting-invites",
          goal: "Review a sample calendar entry for Demo Account 73 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 16.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00041_186.png",
                "demo_alpha_frame_00042_589.png",
                "demo_alpha_frame_00043_200.png",
                "demo_alpha_frame_00044_144.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 20",
              qualifier: "reviewed-invite",
            },
            {
              object: "Sample Calendar Item 37",
              qualifier: "reviewed-invite",
            },
            {
              object: "Sample Calendar Item 54",
              qualifier: "reviewed-invite",
            },
          ],
          coverage: [["2025-02-04T08:55:45.110Z", "2025-02-04T08:56:07.250Z"]],
          duration_s: 22.1,
        },
        {
          id: 82010,
          depth: 2,
          name: "research-person",
          goal: "Complete a fictional research-person task for Demo Account 80 using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 40.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00045_986.png",
                "demo_alpha_frame_00046_515.png",
                "demo_alpha_frame_00047_414.png",
                "demo_alpha_frame_00048_182.png",
                "demo_alpha_frame_00049_927.png",
                "demo_alpha_frame_00050_862.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Account 31",
              qualifier: "researched",
            },
          ],
          coverage: [["2025-02-04T08:56:09.950Z", "2025-02-04T08:56:49.992Z"]],
          duration_s: 40.0,
        },
        {
          id: 82011,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Arc to continue Sample Workflow 87.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 30.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00051_616.png",
                "demo_alpha_frame_00052_553.png",
                "demo_alpha_frame_00053_987.png",
                "demo_alpha_frame_00054_397.png",
              ],
            },
          ],
          coverage: [["2025-02-04T08:56:51.481Z", "2025-02-04T08:57:21.708Z"]],
          duration_s: 30.2,
        },
        {
          id: 82012,
          depth: 2,
          name: "search-contact",
          goal: "Open the fictional record for Demo Account 94 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 13.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00055_872.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Account 53",
              qualifier: "searched-contact",
            },
          ],
          coverage: [["2025-02-04T08:57:26.601Z", "2025-02-04T08:57:40.152Z"]],
          duration_s: 13.6,
        },
        {
          id: 82013,
          depth: 2,
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 119.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00056_448.png",
                "demo_alpha_frame_00057_819.png",
                "demo_alpha_frame_00058_186.png",
                "demo_alpha_frame_00059_129.png",
                "demo_alpha_frame_00060_853.png",
                "demo_alpha_frame_00061_184.png",
                "demo_alpha_frame_00062_921.png",
                "demo_alpha_frame_00063_738.png",
                "demo_alpha_frame_00064_747.png",
              ],
            },
          ],
          coverage: [["2025-02-04T08:57:41.408Z", "2025-02-04T08:59:40.604Z"]],
          duration_s: 119.2,
        },
        {
          id: 82014,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Arc to continue Sample Workflow 19.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 77.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00065_355.png",
                "demo_alpha_frame_00066_358.png",
                "demo_alpha_frame_00067_048.png",
                "demo_alpha_frame_00068_799.png",
                "demo_alpha_frame_00069_559.png",
                "demo_alpha_frame_00070_501.png",
                "demo_alpha_frame_00071_682.png",
              ],
            },
          ],
          coverage: [["2025-02-04T08:59:41.488Z", "2025-02-04T09:00:58.624Z"]],
          duration_s: 77.1,
        },
        {
          id: 82015,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-26 and post a sample status update using Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 51.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00072_736.png",
                "demo_alpha_frame_00073_731.png",
                "demo_alpha_frame_00074_264.png",
                "demo_alpha_frame_00075_167.png",
                "demo_alpha_frame_00076_248.png",
                "demo_alpha_frame_00077_255.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:01:02.042Z", "2025-02-04T09:01:53.555Z"]],
          duration_s: 51.5,
        },
        {
          id: 82016,
          depth: 2,
          name: "research-person",
          goal: "Complete a fictional research-person task for Demo Account 33 using Arc and Claude.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.8,
            },
            {
              name: "app.Claude.duration_s",
              value: 3.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00078_644.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Account 97",
              qualifier: "researched",
            },
          ],
          coverage: [["2025-02-04T09:01:58.152Z", "2025-02-04T09:02:05.135Z"]],
          duration_s: 7.0,
        },
        {
          id: 82017,
          depth: 2,
          name: "manage-integrations",
          goal: "Verify the sample workspace configuration for Demo Contact 40 using Claude and Google Chrome.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 8.0,
            },
            {
              name: "app.Google Chrome.duration_s",
              value: 4.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00079_852.png", "demo_alpha_frame_00080_346.png"],
            },
          ],
          coverage: [["2025-02-04T09:02:10.220Z", "2025-02-04T09:02:22.305Z"]],
          duration_s: 12.1,
        },
        {
          id: 82018,
          depth: 2,
          name: "react-message",
          goal: "Review the fictional conversation in #demo-ops-47 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 48.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00081_941.png",
                "demo_alpha_frame_00082_122.png",
                "demo_alpha_frame_00083_700.png",
                "demo_alpha_frame_00084_794.png",
                "demo_alpha_frame_00085_772.png",
                "demo_alpha_frame_00086_076.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 22",
              qualifier: "messaged",
            },
          ],
          coverage: [["2025-02-04T09:02:27.603Z", "2025-02-04T09:03:20.997Z"]],
          duration_s: 53.4,
        },
        {
          id: 82019,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Arc to continue Sample Workflow 54.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 10.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00087_746.png"],
            },
          ],
          coverage: [["2025-02-04T09:03:26.217Z", "2025-02-04T09:03:40.256Z"]],
          duration_s: 14.0,
        },
        {
          id: 82020,
          depth: 2,
          name: "review-recording",
          goal: "Review Sample Session 61 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 30.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00088_196.png",
                "demo_alpha_frame_00089_898.png",
                "demo_alpha_frame_00090_669.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:03:43.797Z", "2025-02-04T09:04:18.276Z"]],
          duration_s: 34.5,
        },
        {
          id: 82021,
          depth: 2,
          name: "attend-call",
          goal: "Review Sample Session 68 and record a fictional outcome in Vimeo.",
          attributes: [
            {
              name: "app.Vimeo.duration_s",
              value: 785.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00091_586.png",
                "demo_alpha_frame_00092_636.png",
                "demo_alpha_frame_00093_837.png",
                "demo_alpha_frame_00094_367.png",
                "demo_alpha_frame_00095_352.png",
                "demo_alpha_frame_00096_067.png",
                "demo_alpha_frame_00097_965.png",
                "demo_alpha_frame_00098_382.png",
                "demo_alpha_frame_00099_482.png",
                "demo_alpha_frame_00100_415.png",
                "demo_alpha_frame_00101_735.png",
                "demo_alpha_frame_00102_557.png",
                "demo_alpha_frame_00103_786.png",
                "demo_alpha_frame_00104_172.png",
                "demo_alpha_frame_00105_395.png",
                "demo_alpha_frame_00106_521.png",
                "demo_alpha_frame_00107_034.png",
                "demo_alpha_frame_00108_737.png",
                "demo_alpha_frame_00109_815.png",
                "demo_alpha_frame_00110_170.png",
                "demo_alpha_frame_00111_046.png",
                "demo_alpha_frame_00112_244.png",
                "demo_alpha_frame_00113_324.png",
                "demo_alpha_frame_00114_026.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Session 55",
              qualifier: "attended-call",
            },
          ],
          coverage: [["2025-02-04T09:04:23.097Z", "2025-02-04T09:17:32.941Z"]],
          duration_s: 789.8,
        },
        {
          id: 82022,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-75 and post a sample status update using Claude and Vimeo.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 14.7,
            },
            {
              name: "app.Vimeo.duration_s",
              value: 6.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00115_440.png", "demo_alpha_frame_00116_799.png"],
            },
          ],
          coverage: [["2025-02-04T09:17:35.858Z", "2025-02-04T09:17:57.167Z"]],
          duration_s: 21.3,
        },
        {
          id: 82023,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Vimeo and Claude to continue Sample Workflow 82.",
          attributes: [
            {
              name: "app.Vimeo.duration_s",
              value: 25.5,
            },
            {
              name: "app.Claude.duration_s",
              value: 13.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00117_068.png",
                "demo_alpha_frame_00118_139.png",
                "demo_alpha_frame_00119_396.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:18:00.539Z", "2025-02-04T09:18:39.765Z"]],
          duration_s: 39.2,
        },
        {
          id: 82024,
          depth: 2,
          name: "lookup-reference",
          goal: "Review and update Sample Enablement Guide 89 with fictional onboarding details in Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 6.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00120_013.png"],
            },
          ],
          coverage: [["2025-02-04T09:18:44.804Z", "2025-02-04T09:18:53.916Z"]],
          duration_s: 9.1,
        },
        {
          id: 82025,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-96 and post a sample status update using Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 44.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00121_271.png",
                "demo_alpha_frame_00122_516.png",
                "demo_alpha_frame_00123_217.png",
                "demo_alpha_frame_00124_726.png",
                "demo_alpha_frame_00125_287.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:18:57.932Z", "2025-02-04T09:19:42.020Z"]],
          duration_s: 44.1,
        },
        {
          id: 82026,
          depth: 2,
          name: "manage-integrations",
          goal: "Verify the sample workspace configuration for Demo Contact 14 using Claude and Vimeo.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 3.9,
            },
            {
              name: "app.Vimeo.duration_s",
              value: 2.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00126_768.png"],
            },
          ],
          coverage: [["2025-02-04T09:19:46.366Z", "2025-02-04T09:19:52.427Z"]],
          duration_s: 6.1,
        },
        {
          id: 82027,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Vimeo to continue Sample Workflow 21.",
          attributes: [
            {
              name: "app.Vimeo.duration_s",
              value: 6.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00127_036.png"],
            },
          ],
          coverage: [["2025-02-04T09:19:56.452Z", "2025-02-04T09:20:02.787Z"]],
          duration_s: 6.3,
        },
        {
          id: 82028,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Claude to continue Sample Workflow 28.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 6.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00128_112.png"],
            },
          ],
          coverage: [["2025-02-04T09:20:07.900Z", "2025-02-04T09:20:14.024Z"]],
          duration_s: 6.1,
        },
        {
          id: 82029,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Vimeo to continue Sample Workflow 35.",
          attributes: [
            {
              name: "app.Vimeo.duration_s",
              value: 14.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00129_781.png"],
            },
          ],
          coverage: [["2025-02-04T09:20:16.194Z", "2025-02-04T09:20:30.295Z"]],
          duration_s: 14.1,
        },
        {
          id: 82030,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Slack to continue Sample Workflow 42.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 2.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00130_671.png"],
            },
          ],
          coverage: [["2025-02-04T09:20:35.702Z", "2025-02-04T09:20:38.190Z"]],
          duration_s: 2.5,
        },
        {
          id: 82031,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Claude to continue Sample Workflow 49.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 3.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00131_048.png"],
            },
          ],
          coverage: [["2025-02-04T09:20:43.066Z", "2025-02-04T09:20:46.709Z"]],
          duration_s: 3.6,
        },
        {
          id: 82032,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 56 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 33.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00132_626.png", "demo_alpha_frame_00133_387.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 79",
              qualifier: "searched",
            },
          ],
          coverage: [["2025-02-04T09:20:49.521Z", "2025-02-04T09:21:27.487Z"]],
          duration_s: 38.0,
        },
        {
          id: 82033,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Vimeo to continue Sample Workflow 63.",
          attributes: [
            {
              name: "app.Vimeo.duration_s",
              value: 5.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00134_996.png", "demo_alpha_frame_00135_436.png"],
            },
          ],
          coverage: [["2025-02-04T09:21:29.440Z", "2025-02-04T09:21:35.253Z"]],
          duration_s: 5.8,
        },
        {
          id: 82034,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Claude to continue Sample Workflow 70.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 13.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00136_503.png"],
            },
          ],
          coverage: [["2025-02-04T09:21:37.483Z", "2025-02-04T09:21:50.537Z"]],
          duration_s: 13.1,
        },
        {
          id: 82035,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Vimeo to continue Sample Workflow 77.",
          attributes: [
            {
              name: "app.Vimeo.duration_s",
              value: 62.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00137_870.png",
                "demo_alpha_frame_00138_543.png",
                "demo_alpha_frame_00139_933.png",
                "demo_alpha_frame_00140_939.png",
                "demo_alpha_frame_00141_578.png",
                "demo_alpha_frame_00142_970.png",
                "demo_alpha_frame_00143_319.png",
                "demo_alpha_frame_00144_523.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:21:52.796Z", "2025-02-04T09:22:54.903Z"]],
          duration_s: 62.1,
        },
        {
          id: 82036,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Claude to continue Sample Workflow 84.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 8.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00145_565.png"],
            },
          ],
          coverage: [["2025-02-04T09:22:59.105Z", "2025-02-04T09:23:07.986Z"]],
          duration_s: 8.9,
        },
        {
          id: 82037,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Vimeo to continue Sample Workflow 91.",
          attributes: [
            {
              name: "app.Vimeo.duration_s",
              value: 60.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00146_120.png",
                "demo_alpha_frame_00147_741.png",
                "demo_alpha_frame_00148_212.png",
                "demo_alpha_frame_00149_424.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:23:09.954Z", "2025-02-04T09:24:14.532Z"]],
          duration_s: 64.6,
        },
        {
          id: 82038,
          depth: 2,
          name: "review-content",
          goal: "Review and update Sample Enablement Guide 98 with fictional onboarding details in Vimeo.",
          attributes: [
            {
              name: "app.Vimeo.duration_s",
              value: 887.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00150_963.png",
                "demo_alpha_frame_00151_755.png",
                "demo_alpha_frame_00152_360.png",
                "demo_alpha_frame_00153_890.png",
                "demo_alpha_frame_00154_939.png",
                "demo_alpha_frame_00155_943.png",
                "demo_alpha_frame_00156_590.png",
                "demo_alpha_frame_00157_142.png",
                "demo_alpha_frame_00158_245.png",
                "demo_alpha_frame_00159_954.png",
                "demo_alpha_frame_00160_220.png",
                "demo_alpha_frame_00161_052.png",
                "demo_alpha_frame_00162_292.png",
                "demo_alpha_frame_00163_502.png",
                "demo_alpha_frame_00164_382.png",
                "demo_alpha_frame_00165_383.png",
                "demo_alpha_frame_00166_452.png",
                "demo_alpha_frame_00167_703.png",
                "demo_alpha_frame_00168_804.png",
                "demo_alpha_frame_00169_934.png",
                "demo_alpha_frame_00170_896.png",
                "demo_alpha_frame_00171_477.png",
                "demo_alpha_frame_00172_643.png",
                "demo_alpha_frame_00173_532.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 48",
              qualifier: "reviewed-content",
            },
          ],
          coverage: [["2025-02-04T09:24:17.124Z", "2025-02-04T09:39:04.543Z"]],
          duration_s: 887.4,
        },
        {
          id: 82039,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-16 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 331.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00174_405.png",
                "demo_alpha_frame_00175_546.png",
                "demo_alpha_frame_00176_684.png",
                "demo_alpha_frame_00177_331.png",
                "demo_alpha_frame_00178_741.png",
                "demo_alpha_frame_00179_262.png",
                "demo_alpha_frame_00180_506.png",
                "demo_alpha_frame_00181_479.png",
                "demo_alpha_frame_00182_019.png",
                "demo_alpha_frame_00183_857.png",
                "demo_alpha_frame_00184_654.png",
                "demo_alpha_frame_00185_217.png",
                "demo_alpha_frame_00186_469.png",
                "demo_alpha_frame_00187_634.png",
                "demo_alpha_frame_00188_483.png",
                "demo_alpha_frame_00189_353.png",
                "demo_alpha_frame_00190_667.png",
                "demo_alpha_frame_00191_795.png",
                "demo_alpha_frame_00192_613.png",
                "demo_alpha_frame_00193_132.png",
                "demo_alpha_frame_00194_146.png",
                "demo_alpha_frame_00195_685.png",
                "demo_alpha_frame_00196_908.png",
                "demo_alpha_frame_00197_845.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 59",
              qualifier: "messaged",
            },
            {
              object: "Demo Item 76",
              qualifier: "discussed",
            },
          ],
          coverage: [["2025-02-04T09:39:08.889Z", "2025-02-04T09:44:46.361Z"]],
          duration_s: 337.5,
        },
        {
          id: 82040,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-23 and post a sample status update using Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 23.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00198_183.png",
                "demo_alpha_frame_00199_931.png",
                "demo_alpha_frame_00200_163.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:44:48.926Z", "2025-02-04T09:45:13.397Z"]],
          duration_s: 24.5,
        },
        {
          id: 82041,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Slack to continue Sample Workflow 30.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 169.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00201_063.png",
                "demo_alpha_frame_00202_509.png",
                "demo_alpha_frame_00203_051.png",
                "demo_alpha_frame_00204_250.png",
                "demo_alpha_frame_00205_198.png",
                "demo_alpha_frame_00206_977.png",
                "demo_alpha_frame_00207_799.png",
                "demo_alpha_frame_00208_452.png",
                "demo_alpha_frame_00209_510.png",
                "demo_alpha_frame_00210_433.png",
                "demo_alpha_frame_00211_293.png",
                "demo_alpha_frame_00212_213.png",
                "demo_alpha_frame_00213_336.png",
                "demo_alpha_frame_00214_037.png",
                "demo_alpha_frame_00215_218.png",
                "demo_alpha_frame_00216_238.png",
                "demo_alpha_frame_00217_213.png",
                "demo_alpha_frame_00218_457.png",
                "demo_alpha_frame_00219_115.png",
                "demo_alpha_frame_00220_944.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:45:18.291Z", "2025-02-04T09:48:08.545Z"]],
          duration_s: 170.3,
        },
        {
          id: 82042,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Slack to continue Sample Workflow 37.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 5.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00221_845.png", "demo_alpha_frame_00222_062.png"],
            },
          ],
          coverage: [["2025-02-04T09:48:13.976Z", "2025-02-04T09:48:19.268Z"]],
          duration_s: 5.3,
        },
        {
          id: 82043,
          depth: 2,
          name: "research-company",
          goal: "Complete a fictional research-company task for Demo Account 44 using Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 137.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00223_512.png",
                "demo_alpha_frame_00224_998.png",
                "demo_alpha_frame_00225_237.png",
                "demo_alpha_frame_00226_591.png",
                "demo_alpha_frame_00227_416.png",
                "demo_alpha_frame_00228_958.png",
                "demo_alpha_frame_00229_615.png",
                "demo_alpha_frame_00230_713.png",
                "demo_alpha_frame_00231_920.png",
                "demo_alpha_frame_00232_436.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Account 06",
              qualifier: "researched",
            },
            {
              object: "Demo Account 23",
              qualifier: "researched",
            },
          ],
          coverage: [["2025-02-04T09:48:21.279Z", "2025-02-04T09:50:38.306Z"]],
          duration_s: 137.0,
        },
        {
          id: 82044,
          depth: 2,
          name: "review-document",
          goal: "Review and update Sample Enablement Guide 51 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 48.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00233_385.png",
                "demo_alpha_frame_00234_494.png",
                "demo_alpha_frame_00235_283.png",
                "demo_alpha_frame_00236_905.png",
                "demo_alpha_frame_00237_291.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 17",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T09:50:43.001Z", "2025-02-04T09:51:31.796Z"]],
          duration_s: 48.8,
        },
        {
          id: 82045,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-58 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 37.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00238_840.png",
                "demo_alpha_frame_00239_276.png",
                "demo_alpha_frame_00240_916.png",
                "demo_alpha_frame_00241_068.png",
                "demo_alpha_frame_00242_051.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:51:32.869Z", "2025-02-04T09:52:14.465Z"]],
          duration_s: 41.6,
        },
        {
          id: 82046,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Arc and Claude to continue Sample Workflow 65.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 2.5,
            },
            {
              name: "app.Claude.duration_s",
              value: 2.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00243_216.png"],
            },
          ],
          coverage: [["2025-02-04T09:52:17.736Z", "2025-02-04T09:52:24.771Z"]],
          duration_s: 7.0,
        },
        {
          id: 82047,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-72 and post a sample status update using Slack and Arc.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 18.4,
            },
            {
              name: "app.Arc.duration_s",
              value: 7.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00244_329.png", "demo_alpha_frame_00245_314.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 50",
              qualifier: "messaged",
            },
          ],
          coverage: [["2025-02-04T09:52:30.496Z", "2025-02-04T09:52:56.360Z"]],
          duration_s: 25.9,
        },
        {
          id: 82048,
          depth: 2,
          name: "review-content",
          goal: "Review and update Sample Enablement Guide 79 with fictional onboarding details in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 34.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00246_745.png",
                "demo_alpha_frame_00247_380.png",
                "demo_alpha_frame_00248_497.png",
                "demo_alpha_frame_00249_754.png",
                "demo_alpha_frame_00250_734.png",
                "demo_alpha_frame_00251_005.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:53:00.621Z", "2025-02-04T09:53:34.873Z"]],
          duration_s: 34.3,
        },
        {
          id: 82049,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-86 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00252_006.png"],
            },
          ],
          coverage: [["2025-02-04T09:53:38.863Z", "2025-02-04T09:53:48.240Z"]],
          duration_s: 9.4,
        },
        {
          id: 82050,
          depth: 2,
          name: "research-company",
          goal: "Complete a fictional research-company task for Demo Account 93 using Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 17.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00253_291.png",
                "demo_alpha_frame_00254_695.png",
                "demo_alpha_frame_00255_999.png",
                "demo_alpha_frame_00256_402.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Account 83",
              qualifier: "researched",
            },
          ],
          coverage: [["2025-02-04T09:53:51.435Z", "2025-02-04T09:54:09.019Z"]],
          duration_s: 17.6,
        },
        {
          id: 82051,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-11 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 45.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00257_238.png",
                "demo_alpha_frame_00258_674.png",
                "demo_alpha_frame_00259_122.png",
                "demo_alpha_frame_00260_365.png",
                "demo_alpha_frame_00261_166.png",
                "demo_alpha_frame_00262_969.png",
                "demo_alpha_frame_00263_226.png",
                "demo_alpha_frame_00264_977.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:54:10.782Z", "2025-02-04T09:54:56.049Z"]],
          duration_s: 45.3,
        },
        {
          id: 82052,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-18 and post a sample status update using Slack and Claude.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 9.3,
            },
            {
              name: "app.Claude.duration_s",
              value: 6.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00265_217.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Account 08",
              qualifier: "researched",
            },
            {
              object: "Demo Account 25",
              qualifier: "researched",
            },
          ],
          coverage: [["2025-02-04T09:54:59.408Z", "2025-02-04T09:55:15.384Z"]],
          duration_s: 16.0,
        },
        {
          id: 82053,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-25 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 46.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00266_305.png",
                "demo_alpha_frame_00267_648.png",
                "demo_alpha_frame_00268_661.png",
                "demo_alpha_frame_00269_509.png",
                "demo_alpha_frame_00270_236.png",
                "demo_alpha_frame_00271_250.png",
                "demo_alpha_frame_00272_748.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:55:17.668Z", "2025-02-04T09:56:04.163Z"]],
          duration_s: 46.5,
        },
        {
          id: 82054,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-32 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 66.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00273_813.png",
                "demo_alpha_frame_00274_102.png",
                "demo_alpha_frame_00275_713.png",
                "demo_alpha_frame_00276_298.png",
                "demo_alpha_frame_00277_461.png",
                "demo_alpha_frame_00278_271.png",
                "demo_alpha_frame_00279_790.png",
              ],
            },
          ],
          coverage: [["2025-02-04T09:56:09.775Z", "2025-02-04T09:57:16.490Z"]],
          duration_s: 66.7,
        },
        {
          id: 82056,
          depth: 2,
          name: "research-person",
          goal: "Complete a fictional research-person task for Demo Account 39 using Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 42.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00280_172.png",
                "demo_alpha_frame_00281_040.png",
                "demo_alpha_frame_00282_623.png",
                "demo_alpha_frame_00283_540.png",
                "demo_alpha_frame_00284_131.png",
                "demo_alpha_frame_00285_077.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Account 41",
              qualifier: "researched",
            },
            {
              object: "Sample Reference 58",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T09:57:23.392Z", "2025-02-04T09:58:05.379Z"]],
          duration_s: 42.0,
        },
        {
          id: 82057,
          depth: 2,
          name: "review-message",
          goal: "Review the fictional conversation in #demo-ops-46 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 155.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00286_561.png",
                "demo_alpha_frame_00287_588.png",
                "demo_alpha_frame_00288_939.png",
                "demo_alpha_frame_00289_331.png",
                "demo_alpha_frame_00290_742.png",
                "demo_alpha_frame_00291_397.png",
                "demo_alpha_frame_00292_375.png",
                "demo_alpha_frame_00293_737.png",
                "demo_alpha_frame_00294_262.png",
                "demo_alpha_frame_00295_085.png",
                "demo_alpha_frame_00296_475.png",
                "demo_alpha_frame_00297_721.png",
                "demo_alpha_frame_00298_546.png",
                "demo_alpha_frame_00299_262.png",
                "demo_alpha_frame_00300_018.png",
                "demo_alpha_frame_00301_632.png",
                "demo_alpha_frame_00302_527.png",
                "demo_alpha_frame_00303_300.png",
                "demo_alpha_frame_00304_824.png",
                "demo_alpha_frame_00305_420.png",
                "demo_alpha_frame_00306_356.png",
                "demo_alpha_frame_00307_173.png",
                "demo_alpha_frame_00308_667.png",
                "demo_alpha_frame_00309_404.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 52",
              qualifier: "reviewed-message",
            },
          ],
          coverage: [["2025-02-04T09:58:09.295Z", "2025-02-04T10:00:45.257Z"]],
          duration_s: 156.0,
        },
        {
          id: 82058,
          depth: 2,
          name: "navigate-channels",
          goal: "Move through Slack to continue Sample Workflow 53.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 18.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00310_263.png", "demo_alpha_frame_00311_625.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 63",
              qualifier: "referenced",
            },
            {
              object: "Demo Item 80",
              qualifier: "reviewed",
            },
            {
              object: "Demo Contact 97",
              qualifier: "mentioned",
            },
          ],
          coverage: [["2025-02-04T10:00:47.122Z", "2025-02-04T10:01:05.514Z"]],
          duration_s: 18.4,
        },
        {
          id: 82060,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Claude to continue Sample Workflow 60.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 10.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00312_632.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Account 74",
              qualifier: "researched",
            },
          ],
          coverage: [["2025-02-04T10:01:09.008Z", "2025-02-04T10:01:18.992Z"]],
          duration_s: 10.0,
        },
        {
          id: 82062,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-67 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00313_156.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 85",
              qualifier: "sent-connection-request",
            },
          ],
          coverage: [["2025-02-04T10:01:28.740Z", "2025-02-04T10:01:33.367Z"]],
          duration_s: 4.6,
        },
        {
          id: 82063,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-74 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 12.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00314_725.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 96",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T10:01:34.061Z", "2025-02-04T10:01:46.305Z"]],
          duration_s: 12.2,
        },
        {
          id: 82064,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Arc and lemlist to continue Sample Workflow 81.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 6.2,
            },
            {
              name: "app.lemlist.duration_s",
              value: 5.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00315_249.png"],
            },
          ],
          coverage: [["2025-02-04T10:01:50.114Z", "2025-02-04T10:02:02.149Z"]],
          duration_s: 12.0,
        },
        {
          id: 82065,
          depth: 2,
          name: "review-calendar",
          goal: "Review a sample calendar entry for Demo Account 88 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 34.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00316_585.png",
                "demo_alpha_frame_00317_492.png",
                "demo_alpha_frame_00318_251.png",
                "demo_alpha_frame_00319_940.png",
                "demo_alpha_frame_00320_635.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 21",
              qualifier: "reviewed",
            },
            {
              object: "Demo Item 38",
              qualifier: "reviewed",
            },
            {
              object: "Demo Item 55",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T10:02:05.348Z", "2025-02-04T10:02:39.904Z"]],
          duration_s: 34.6,
        },
        {
          id: 82066,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Arc to continue Sample Workflow 95.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00321_907.png", "demo_alpha_frame_00322_419.png"],
            },
          ],
          coverage: [["2025-02-04T10:02:43.233Z", "2025-02-04T10:02:53.151Z"]],
          duration_s: 9.9,
        },
        {
          id: 82067,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-13 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 13.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00323_544.png",
                "demo_alpha_frame_00324_572.png",
                "demo_alpha_frame_00325_798.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 43",
              qualifier: "messaged",
            },
          ],
          coverage: [["2025-02-04T10:02:57.821Z", "2025-02-04T10:03:11.766Z"]],
          duration_s: 13.9,
        },
        {
          id: 82068,
          depth: 2,
          name: "navigate-channels",
          goal: "Move through Slack to continue Sample Workflow 20.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 14.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00326_878.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 54",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T10:03:13.243Z", "2025-02-04T10:03:27.838Z"]],
          duration_s: 14.6,
        },
        {
          id: 82071,
          depth: 2,
          name: "navigate-channels",
          goal: "Move through Slack to continue Sample Workflow 27.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 27.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00327_462.png", "demo_alpha_frame_00328_217.png"],
            },
          ],
          coverage: [["2025-02-04T10:03:42.351Z", "2025-02-04T10:04:09.417Z"]],
          duration_s: 27.1,
        },
        {
          id: 82073,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-34 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 20.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00329_846.png", "demo_alpha_frame_00330_172.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 76",
              qualifier: "filtered",
            },
            {
              object: "Demo Contact 93",
              qualifier: "messaged",
            },
          ],
          coverage: [["2025-02-04T10:04:15.530Z", "2025-02-04T10:04:35.891Z"]],
          duration_s: 20.4,
        },
        {
          id: 82074,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Slack to continue Sample Workflow 41.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 404.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00331_180.png",
                "demo_alpha_frame_00332_715.png",
                "demo_alpha_frame_00333_389.png",
                "demo_alpha_frame_00334_192.png",
                "demo_alpha_frame_00335_578.png",
                "demo_alpha_frame_00336_766.png",
                "demo_alpha_frame_00337_520.png",
                "demo_alpha_frame_00338_398.png",
                "demo_alpha_frame_00339_078.png",
                "demo_alpha_frame_00340_667.png",
                "demo_alpha_frame_00341_052.png",
                "demo_alpha_frame_00342_823.png",
                "demo_alpha_frame_00343_830.png",
                "demo_alpha_frame_00344_047.png",
                "demo_alpha_frame_00345_404.png",
                "demo_alpha_frame_00346_763.png",
                "demo_alpha_frame_00347_162.png",
                "demo_alpha_frame_00348_125.png",
                "demo_alpha_frame_00349_675.png",
                "demo_alpha_frame_00350_444.png",
                "demo_alpha_frame_00351_662.png",
                "demo_alpha_frame_00352_970.png",
                "demo_alpha_frame_00353_574.png",
                "demo_alpha_frame_00354_854.png",
              ],
            },
          ],
          coverage: [["2025-02-04T10:04:39.853Z", "2025-02-04T10:11:24.563Z"]],
          duration_s: 404.7,
        },
        {
          id: 82075,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-48 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 91.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00355_663.png",
                "demo_alpha_frame_00356_364.png",
                "demo_alpha_frame_00357_683.png",
                "demo_alpha_frame_00358_364.png",
                "demo_alpha_frame_00359_636.png",
                "demo_alpha_frame_00360_771.png",
              ],
            },
          ],
          coverage: [["2025-02-04T10:11:28.001Z", "2025-02-04T10:12:59.189Z"]],
          duration_s: 91.2,
        },
        {
          id: 82076,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Gmail to continue Sample Workflow 55.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 11.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00361_686.png", "demo_alpha_frame_00362_622.png"],
            },
          ],
          coverage: [["2025-02-04T10:13:04.792Z", "2025-02-04T10:13:16.324Z"]],
          duration_s: 11.5,
        },
        {
          id: 82077,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-62 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 37.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00363_359.png",
                "demo_alpha_frame_00364_866.png",
                "demo_alpha_frame_00365_543.png",
                "demo_alpha_frame_00366_764.png",
                "demo_alpha_frame_00367_829.png",
              ],
            },
          ],
          coverage: [["2025-02-04T10:13:21.229Z", "2025-02-04T10:13:58.522Z"]],
          duration_s: 37.3,
        },
        {
          id: 82078,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Salesforce and Gmail to continue Sample Workflow 69.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 6.4,
            },
            {
              name: "app.Gmail.duration_s",
              value: 6.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00368_863.png"],
            },
          ],
          coverage: [["2025-02-04T10:14:02.351Z", "2025-02-04T10:14:15.589Z"]],
          duration_s: 13.2,
        },
        {
          id: 82079,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Arc to continue Sample Workflow 76.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 11.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00369_569.png",
                "demo_alpha_frame_00370_453.png",
                "demo_alpha_frame_00371_620.png",
              ],
            },
          ],
          coverage: [["2025-02-04T10:14:17.273Z", "2025-02-04T10:14:32.990Z"]],
          duration_s: 15.7,
        },
        {
          id: 82080,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 83 and update its demo availability in Arc and Gmail.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 107.2,
            },
            {
              name: "app.Gmail.duration_s",
              value: 28.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00372_339.png",
                "demo_alpha_frame_00373_917.png",
                "demo_alpha_frame_00374_228.png",
                "demo_alpha_frame_00375_059.png",
                "demo_alpha_frame_00376_453.png",
                "demo_alpha_frame_00377_053.png",
                "demo_alpha_frame_00378_205.png",
                "demo_alpha_frame_00379_537.png",
                "demo_alpha_frame_00380_842.png",
              ],
            },
          ],
          relationships: [
            {
              object: "#demo-ops-56",
              qualifier: "joined",
            },
          ],
          coverage: [["2025-02-04T10:14:35.109Z", "2025-02-04T10:16:50.488Z"]],
          duration_s: 135.4,
        },
        {
          id: 82081,
          depth: 2,
          name: "attend-call",
          goal: "Review Sample Session 90 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 12.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00381_179.png"],
            },
          ],
          coverage: [["2025-02-04T10:16:51.906Z", "2025-02-04T10:17:06.580Z"]],
          duration_s: 14.7,
        },
        {
          id: 82082,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Arc and Gmail to continue Sample Workflow 97.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 10.1,
            },
            {
              name: "app.Gmail.duration_s",
              value: 6.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00382_862.png", "demo_alpha_frame_00383_836.png"],
            },
          ],
          coverage: [["2025-02-04T10:17:08.956Z", "2025-02-04T10:17:24.916Z"]],
          duration_s: 16.0,
        },
        {
          id: 82083,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-15 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 72.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00384_705.png",
                "demo_alpha_frame_00385_195.png",
                "demo_alpha_frame_00386_342.png",
                "demo_alpha_frame_00387_804.png",
                "demo_alpha_frame_00388_858.png",
                "demo_alpha_frame_00389_650.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 89",
              qualifier: "messaged",
            },
          ],
          coverage: [["2025-02-04T10:32:25.317Z", "2025-02-04T10:33:40.861Z"]],
          duration_s: 75.5,
        },
        {
          id: 82084,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 22 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 244.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00390_955.png",
                "demo_alpha_frame_00391_242.png",
                "demo_alpha_frame_00392_804.png",
                "demo_alpha_frame_00393_555.png",
                "demo_alpha_frame_00394_654.png",
                "demo_alpha_frame_00395_993.png",
                "demo_alpha_frame_00396_637.png",
                "demo_alpha_frame_00397_280.png",
                "demo_alpha_frame_00398_050.png",
                "demo_alpha_frame_00399_367.png",
                "demo_alpha_frame_00400_770.png",
                "demo_alpha_frame_00401_629.png",
                "demo_alpha_frame_00402_586.png",
                "demo_alpha_frame_00403_368.png",
                "demo_alpha_frame_00404_021.png",
                "demo_alpha_frame_00405_393.png",
              ],
            },
          ],
          coverage: [["2025-02-04T10:33:44.392Z", "2025-02-04T10:37:49.254Z"]],
          duration_s: 244.9,
        },
        {
          id: 82085,
          depth: 2,
          name: "review-pipeline",
          goal: "Review the sample outreach workflow for Demo Account 29 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 668.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00406_883.png",
                "demo_alpha_frame_00407_548.png",
                "demo_alpha_frame_00408_776.png",
                "demo_alpha_frame_00409_641.png",
                "demo_alpha_frame_00410_446.png",
                "demo_alpha_frame_00411_575.png",
                "demo_alpha_frame_00412_546.png",
                "demo_alpha_frame_00413_559.png",
                "demo_alpha_frame_00414_112.png",
                "demo_alpha_frame_00415_578.png",
                "demo_alpha_frame_00416_525.png",
                "demo_alpha_frame_00417_896.png",
                "demo_alpha_frame_00418_904.png",
                "demo_alpha_frame_00419_724.png",
                "demo_alpha_frame_00420_226.png",
                "demo_alpha_frame_00421_887.png",
                "demo_alpha_frame_00422_047.png",
                "demo_alpha_frame_00423_901.png",
                "demo_alpha_frame_00424_369.png",
                "demo_alpha_frame_00425_565.png",
                "demo_alpha_frame_00426_243.png",
                "demo_alpha_frame_00427_434.png",
                "demo_alpha_frame_00428_609.png",
                "demo_alpha_frame_00429_937.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 14",
              qualifier: "reviewed",
            },
            {
              object: "Demo Item 31",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T10:37:54.698Z", "2025-02-04T10:52:19.458Z"]],
          duration_s: 864.8,
        },
        {
          id: 82086,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-36 and post a sample status update using Slack and lemlist.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 46.7,
            },
            {
              name: "app.lemlist.duration_s",
              value: 18.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00430_094.png",
                "demo_alpha_frame_00431_680.png",
                "demo_alpha_frame_00432_922.png",
                "demo_alpha_frame_00433_593.png",
                "demo_alpha_frame_00434_601.png",
                "demo_alpha_frame_00435_297.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 25",
              qualifier: "messaged",
            },
            {
              object: "Demo Contact 42",
              qualifier: "mentioned",
            },
          ],
          coverage: [["2025-02-04T10:52:25.004Z", "2025-02-04T10:53:37.935Z"]],
          duration_s: 72.9,
        },
        {
          id: 82087,
          depth: 2,
          name: "attend-call",
          goal: "Review Sample Session 43 and record a fictional outcome in Arc and Granola.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 30.0,
            },
            {
              name: "app.Granola.duration_s",
              value: 22.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00436_505.png",
                "demo_alpha_frame_00437_410.png",
                "demo_alpha_frame_00438_458.png",
                "demo_alpha_frame_00439_200.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Session 36",
              qualifier: "attended",
            },
          ],
          coverage: [["2025-02-04T10:53:40.589Z", "2025-02-04T10:54:33.365Z"]],
          duration_s: 52.8,
        },
        {
          id: 82088,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-50 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 11.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00440_028.png", "demo_alpha_frame_00441_945.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 47",
              qualifier: "archived",
            },
          ],
          coverage: [["2025-02-04T10:54:36.661Z", "2025-02-04T10:54:57.299Z"]],
          duration_s: 20.6,
        },
        {
          id: 82089,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 57 with fictional onboarding details in Arc and Shortcut.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 65.2,
            },
            {
              name: "app.Shortcut.duration_s",
              value: 64.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00442_592.png",
                "demo_alpha_frame_00443_904.png",
                "demo_alpha_frame_00444_363.png",
                "demo_alpha_frame_00445_733.png",
                "demo_alpha_frame_00446_526.png",
                "demo_alpha_frame_00447_338.png",
                "demo_alpha_frame_00448_241.png",
                "demo_alpha_frame_00449_057.png",
                "demo_alpha_frame_00450_520.png",
                "demo_alpha_frame_00451_883.png",
                "demo_alpha_frame_00452_806.png",
                "demo_alpha_frame_00453_207.png",
                "demo_alpha_frame_00454_861.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 58",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T10:55:02.723Z", "2025-02-04T10:57:38.286Z"]],
          duration_s: 155.6,
        },
        {
          id: 82090,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-64 and post a sample status update using Messages.",
          attributes: [
            {
              name: "app.Messages.duration_s",
              value: 52.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00455_561.png",
                "demo_alpha_frame_00456_174.png",
                "demo_alpha_frame_00457_315.png",
              ],
            },
          ],
          coverage: [["2025-02-04T10:57:41.834Z", "2025-02-04T10:58:35.943Z"]],
          duration_s: 54.1,
        },
        {
          id: 82091,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 71 and update its sample fields in lemlist.",
          attributes: [
            {
              name: "app.lemlist.duration_s",
              value: 98.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00458_198.png",
                "demo_alpha_frame_00459_344.png",
                "demo_alpha_frame_00460_930.png",
                "demo_alpha_frame_00461_126.png",
                "demo_alpha_frame_00462_194.png",
                "demo_alpha_frame_00463_128.png",
                "demo_alpha_frame_00464_874.png",
                "demo_alpha_frame_00465_389.png",
                "demo_alpha_frame_00466_979.png",
                "demo_alpha_frame_00467_923.png",
                "demo_alpha_frame_00468_074.png",
                "demo_alpha_frame_00469_770.png",
                "demo_alpha_frame_00470_834.png",
                "demo_alpha_frame_00471_508.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 80",
              qualifier: "reviewed",
            },
            {
              object: "Demo Item 97",
              qualifier: "imported-from",
            },
          ],
          coverage: [["2025-02-04T10:58:39.424Z", "2025-02-04T11:00:20.654Z"]],
          duration_s: 101.2,
        },
        {
          id: 82092,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 78 with fictional onboarding details in lemlist.",
          attributes: [
            {
              name: "app.lemlist.duration_s",
              value: 47.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00472_375.png",
                "demo_alpha_frame_00473_961.png",
                "demo_alpha_frame_00474_014.png",
                "demo_alpha_frame_00475_148.png",
                "demo_alpha_frame_00476_508.png",
                "demo_alpha_frame_00477_968.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:00:22.905Z", "2025-02-04T11:01:19.587Z"]],
          duration_s: 56.7,
        },
        {
          id: 82093,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 85 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 20.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00478_889.png",
                "demo_alpha_frame_00479_364.png",
                "demo_alpha_frame_00480_590.png",
                "demo_alpha_frame_00481_685.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 05",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T11:01:23.258Z", "2025-02-04T11:01:44.191Z"]],
          duration_s: 20.9,
        },
        {
          id: 82094,
          depth: 2,
          name: "research-reference",
          goal: "Review and update Sample Enablement Guide 92 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 69.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00482_800.png",
                "demo_alpha_frame_00483_933.png",
                "demo_alpha_frame_00484_938.png",
                "demo_alpha_frame_00485_946.png",
                "demo_alpha_frame_00486_140.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:01:48.876Z", "2025-02-04T11:02:58.119Z"]],
          duration_s: 69.2,
        },
        {
          id: 82095,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 10 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 74.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00487_699.png",
                "demo_alpha_frame_00488_163.png",
                "demo_alpha_frame_00489_275.png",
                "demo_alpha_frame_00490_338.png",
                "demo_alpha_frame_00491_606.png",
                "demo_alpha_frame_00492_526.png",
                "demo_alpha_frame_00493_661.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:03:00.492Z", "2025-02-04T11:04:14.984Z"]],
          duration_s: 74.5,
        },
        {
          id: 82096,
          depth: 2,
          name: "attend-call",
          goal: "Review Sample Session 17 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 8.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00494_888.png"],
            },
          ],
          coverage: [["2025-02-04T11:04:17.371Z", "2025-02-04T11:04:25.575Z"]],
          duration_s: 8.2,
        },
        {
          id: 82097,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 24 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 51.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00495_791.png",
                "demo_alpha_frame_00496_344.png",
                "demo_alpha_frame_00497_650.png",
                "demo_alpha_frame_00498_849.png",
                "demo_alpha_frame_00499_078.png",
                "demo_alpha_frame_00500_660.png",
                "demo_alpha_frame_00501_275.png",
                "demo_alpha_frame_00502_365.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:04:28.540Z", "2025-02-04T11:05:20.265Z"]],
          duration_s: 51.7,
        },
        {
          id: 82099,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 31 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 143.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00503_802.png",
                "demo_alpha_frame_00504_114.png",
                "demo_alpha_frame_00505_758.png",
                "demo_alpha_frame_00506_309.png",
                "demo_alpha_frame_00507_871.png",
                "demo_alpha_frame_00508_852.png",
                "demo_alpha_frame_00509_439.png",
                "demo_alpha_frame_00510_031.png",
                "demo_alpha_frame_00511_581.png",
                "demo_alpha_frame_00512_071.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 60",
              qualifier: "filtered",
            },
            {
              object: "Sample Calendar Item 77",
              qualifier: "filtered",
            },
          ],
          coverage: [["2025-02-04T11:05:27.320Z", "2025-02-04T11:07:50.278Z"]],
          duration_s: 143.0,
        },
        {
          id: 82100,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 38 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00513_162.png"],
            },
          ],
          coverage: [["2025-02-04T11:07:53.254Z", "2025-02-04T11:08:03.146Z"]],
          duration_s: 9.9,
        },
        {
          id: 82102,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 45 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 88.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00514_187.png",
                "demo_alpha_frame_00515_053.png",
                "demo_alpha_frame_00516_306.png",
                "demo_alpha_frame_00517_390.png",
                "demo_alpha_frame_00518_488.png",
                "demo_alpha_frame_00519_809.png",
                "demo_alpha_frame_00520_037.png",
                "demo_alpha_frame_00521_215.png",
                "demo_alpha_frame_00522_486.png",
                "demo_alpha_frame_00523_427.png",
                "demo_alpha_frame_00524_673.png",
                "demo_alpha_frame_00525_757.png",
                "demo_alpha_frame_00526_116.png",
                "demo_alpha_frame_00527_185.png",
                "demo_alpha_frame_00528_923.png",
                "demo_alpha_frame_00529_058.png",
                "demo_alpha_frame_00530_061.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:08:12.708Z", "2025-02-04T11:09:41.256Z"]],
          duration_s: 88.5,
        },
        {
          id: 82103,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 52 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 7.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00531_645.png", "demo_alpha_frame_00532_074.png"],
            },
          ],
          coverage: [["2025-02-04T11:09:42.894Z", "2025-02-04T11:09:50.292Z"]],
          duration_s: 7.4,
        },
        {
          id: 82105,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 59 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 15.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00533_116.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 07",
              qualifier: "accessed",
            },
          ],
          coverage: [["2025-02-04T11:09:56.360Z", "2025-02-04T11:10:11.688Z"]],
          duration_s: 15.3,
        },
        {
          id: 82106,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 66 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 7.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00534_719.png"],
            },
          ],
          coverage: [["2025-02-04T11:10:15.528Z", "2025-02-04T11:10:23.119Z"]],
          duration_s: 7.6,
        },
        {
          id: 82107,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 73 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 24.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00535_678.png",
                "demo_alpha_frame_00536_604.png",
                "demo_alpha_frame_00537_811.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:10:26.117Z", "2025-02-04T11:10:50.670Z"]],
          duration_s: 24.6,
        },
        {
          id: 82108,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 80 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00538_407.png"],
            },
          ],
          coverage: [["2025-02-04T11:10:51.533Z", "2025-02-04T11:10:56.908Z"]],
          duration_s: 5.4,
        },
        {
          id: 82110,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 87 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00539_896.png"],
            },
          ],
          coverage: [["2025-02-04T11:11:08.953Z", "2025-02-04T11:11:13.396Z"]],
          duration_s: 4.4,
        },
        {
          id: 82113,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 94 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00540_339.png", "demo_alpha_frame_00541_024.png"],
            },
          ],
          coverage: [["2025-02-04T11:11:26.345Z", "2025-02-04T11:11:35.642Z"]],
          duration_s: 9.3,
        },
        {
          id: 82117,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 12 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 96.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00542_274.png",
                "demo_alpha_frame_00543_412.png",
                "demo_alpha_frame_00544_384.png",
                "demo_alpha_frame_00545_192.png",
                "demo_alpha_frame_00546_957.png",
                "demo_alpha_frame_00547_803.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:11:54.973Z", "2025-02-04T11:13:30.933Z"]],
          duration_s: 96.0,
        },
        {
          id: 82119,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 19 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00548_029.png"],
            },
          ],
          coverage: [["2025-02-04T11:13:34.408Z", "2025-02-04T11:13:43.721Z"]],
          duration_s: 9.3,
        },
        {
          id: 82120,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 26 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 21.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00549_058.png", "demo_alpha_frame_00550_307.png"],
            },
          ],
          coverage: [["2025-02-04T11:13:47.084Z", "2025-02-04T11:14:08.611Z"]],
          duration_s: 21.5,
        },
        {
          id: 82121,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 33 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 8.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00551_174.png", "demo_alpha_frame_00552_067.png"],
            },
          ],
          coverage: [["2025-02-04T11:14:11.533Z", "2025-02-04T11:14:20.040Z"]],
          duration_s: 8.5,
        },
        {
          id: 82122,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 40 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00553_110.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 20",
              qualifier: "opened",
            },
          ],
          coverage: [["2025-02-04T11:14:23.507Z", "2025-02-04T11:14:28.127Z"]],
          duration_s: 4.6,
        },
        {
          id: 82124,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 47 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 150.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00554_588.png",
                "demo_alpha_frame_00555_030.png",
                "demo_alpha_frame_00556_148.png",
                "demo_alpha_frame_00557_400.png",
                "demo_alpha_frame_00558_035.png",
                "demo_alpha_frame_00559_881.png",
                "demo_alpha_frame_00560_438.png",
                "demo_alpha_frame_00561_276.png",
                "demo_alpha_frame_00562_805.png",
                "demo_alpha_frame_00563_774.png",
                "demo_alpha_frame_00564_912.png",
                "demo_alpha_frame_00565_497.png",
                "demo_alpha_frame_00566_061.png",
                "demo_alpha_frame_00567_019.png",
                "demo_alpha_frame_00568_876.png",
                "demo_alpha_frame_00569_623.png",
                "demo_alpha_frame_00570_498.png",
                "demo_alpha_frame_00571_611.png",
                "demo_alpha_frame_00572_332.png",
                "demo_alpha_frame_00573_775.png",
                "demo_alpha_frame_00574_213.png",
                "demo_alpha_frame_00575_915.png",
                "demo_alpha_frame_00576_008.png",
                "demo_alpha_frame_00577_887.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:14:37.596Z", "2025-02-04T11:17:07.594Z"]],
          duration_s: 150.0,
        },
        {
          id: 82125,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 54 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00578_512.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 42",
              qualifier: "filtered",
            },
          ],
          coverage: [["2025-02-04T11:17:09.822Z", "2025-02-04T11:17:18.816Z"]],
          duration_s: 9.0,
        },
        {
          id: 82126,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 61 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 6.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00579_198.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 53",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T11:17:21.698Z", "2025-02-04T11:17:27.796Z"]],
          duration_s: 6.1,
        },
        {
          id: 82127,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 68 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 49.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00580_085.png",
                "demo_alpha_frame_00581_641.png",
                "demo_alpha_frame_00582_382.png",
                "demo_alpha_frame_00583_811.png",
                "demo_alpha_frame_00584_924.png",
                "demo_alpha_frame_00585_737.png",
                "demo_alpha_frame_00586_647.png",
                "demo_alpha_frame_00587_101.png",
                "demo_alpha_frame_00588_468.png",
                "demo_alpha_frame_00589_643.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 64",
              qualifier: "filtered",
            },
          ],
          coverage: [["2025-02-04T11:17:29.052Z", "2025-02-04T11:18:18.659Z"]],
          duration_s: 49.6,
        },
        {
          id: 82128,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 75 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 35.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00590_886.png",
                "demo_alpha_frame_00591_064.png",
                "demo_alpha_frame_00592_825.png",
                "demo_alpha_frame_00593_667.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 75",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T11:18:20.244Z", "2025-02-04T11:18:55.750Z"]],
          duration_s: 35.5,
        },
        {
          id: 82129,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 82 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 50.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00594_727.png",
                "demo_alpha_frame_00595_470.png",
                "demo_alpha_frame_00596_279.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:18:59.541Z", "2025-02-04T11:19:50.272Z"]],
          duration_s: 50.7,
        },
        {
          id: 82130,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 89 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 81.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00597_084.png",
                "demo_alpha_frame_00598_115.png",
                "demo_alpha_frame_00599_875.png",
                "demo_alpha_frame_00600_434.png",
                "demo_alpha_frame_00601_885.png",
                "demo_alpha_frame_00602_167.png",
                "demo_alpha_frame_00603_717.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:19:53.455Z", "2025-02-04T11:21:14.868Z"]],
          duration_s: 81.4,
        },
        {
          id: 82131,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 96 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 28.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00604_364.png",
                "demo_alpha_frame_00605_073.png",
                "demo_alpha_frame_00606_989.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:21:16.258Z", "2025-02-04T11:21:45.158Z"]],
          duration_s: 28.9,
        },
        {
          id: 82132,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 14 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 21.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00607_750.png"],
            },
          ],
          coverage: [["2025-02-04T11:21:48.659Z", "2025-02-04T11:22:10.503Z"]],
          duration_s: 21.8,
        },
        {
          id: 82133,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 21 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 72.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00608_146.png",
                "demo_alpha_frame_00609_372.png",
                "demo_alpha_frame_00610_475.png",
                "demo_alpha_frame_00611_590.png",
                "demo_alpha_frame_00612_495.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:22:14.218Z", "2025-02-04T11:23:26.459Z"]],
          duration_s: 72.2,
        },
        {
          id: 82134,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 28 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 50.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00613_122.png",
                "demo_alpha_frame_00614_307.png",
                "demo_alpha_frame_00615_464.png",
                "demo_alpha_frame_00616_424.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:23:31.675Z", "2025-02-04T11:24:22.087Z"]],
          duration_s: 50.4,
        },
        {
          id: 82135,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 35 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 51.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00617_373.png",
                "demo_alpha_frame_00618_713.png",
                "demo_alpha_frame_00619_200.png",
                "demo_alpha_frame_00620_854.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 55",
              qualifier: "accessed",
            },
          ],
          coverage: [["2025-02-04T11:24:24.062Z", "2025-02-04T11:25:15.375Z"]],
          duration_s: 51.3,
        },
        {
          id: 82136,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 42 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 38.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00621_391.png",
                "demo_alpha_frame_00622_464.png",
                "demo_alpha_frame_00623_608.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:25:16.437Z", "2025-02-04T11:25:54.977Z"]],
          duration_s: 38.5,
        },
        {
          id: 82137,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 49 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 28.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00624_228.png",
                "demo_alpha_frame_00625_548.png",
                "demo_alpha_frame_00626_073.png",
                "demo_alpha_frame_00627_875.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 77",
              qualifier: "opened",
            },
          ],
          coverage: [["2025-02-04T11:25:56.406Z", "2025-02-04T11:26:25.177Z"]],
          duration_s: 28.8,
        },
        {
          id: 82138,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 56 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 78.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00628_058.png",
                "demo_alpha_frame_00629_823.png",
                "demo_alpha_frame_00630_059.png",
                "demo_alpha_frame_00631_742.png",
                "demo_alpha_frame_00632_826.png",
                "demo_alpha_frame_00633_733.png",
                "demo_alpha_frame_00634_562.png",
                "demo_alpha_frame_00635_061.png",
                "demo_alpha_frame_00636_583.png",
                "demo_alpha_frame_00637_476.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 88",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T11:26:25.768Z", "2025-02-04T11:27:43.862Z"]],
          duration_s: 78.1,
        },
        {
          id: 82139,
          depth: 2,
          name: "manage-contacts",
          goal: "Open the fictional record for Demo Account 63 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 24.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00638_845.png",
                "demo_alpha_frame_00639_573.png",
                "demo_alpha_frame_00640_335.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:27:45.188Z", "2025-02-04T11:28:09.630Z"]],
          duration_s: 24.4,
        },
        {
          id: 82140,
          depth: 2,
          name: "review-campaign-analytics",
          goal: "Review the sample outreach workflow for Demo Account 70 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 126.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00641_558.png",
                "demo_alpha_frame_00642_928.png",
                "demo_alpha_frame_00643_062.png",
                "demo_alpha_frame_00644_591.png",
                "demo_alpha_frame_00645_701.png",
                "demo_alpha_frame_00646_936.png",
                "demo_alpha_frame_00647_126.png",
                "demo_alpha_frame_00648_525.png",
                "demo_alpha_frame_00649_556.png",
                "demo_alpha_frame_00650_229.png",
                "demo_alpha_frame_00651_218.png",
                "demo_alpha_frame_00652_660.png",
                "demo_alpha_frame_00653_013.png",
                "demo_alpha_frame_00654_795.png",
                "demo_alpha_frame_00655_144.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 13",
              qualifier: "reviewed",
            },
            {
              object: "Sample Calendar Item 30",
              qualifier: "filtered-by",
            },
          ],
          coverage: [["2025-02-04T11:28:13.920Z", "2025-02-04T11:30:20.380Z"]],
          duration_s: 126.5,
        },
        {
          id: 82141,
          depth: 2,
          name: "configure-sequence",
          goal: "Review the sample outreach workflow for Demo Account 77 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 24.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00656_756.png",
                "demo_alpha_frame_00657_032.png",
                "demo_alpha_frame_00658_404.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 24",
              qualifier: "configured",
            },
          ],
          coverage: [["2025-02-04T11:30:25.588Z", "2025-02-04T11:30:50.036Z"]],
          duration_s: 24.4,
        },
        {
          id: 82142,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 84 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 64.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00659_295.png",
                "demo_alpha_frame_00660_346.png",
                "demo_alpha_frame_00661_482.png",
                "demo_alpha_frame_00662_261.png",
                "demo_alpha_frame_00663_941.png",
                "demo_alpha_frame_00664_460.png",
                "demo_alpha_frame_00665_989.png",
                "demo_alpha_frame_00666_888.png",
                "demo_alpha_frame_00667_076.png",
                "demo_alpha_frame_00668_797.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:30:55.252Z", "2025-02-04T11:32:00.061Z"]],
          duration_s: 64.8,
        },
        {
          id: 82143,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 91 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 8.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00669_081.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 46",
              qualifier: "filtered-by",
            },
          ],
          coverage: [["2025-02-04T11:32:01.041Z", "2025-02-04T11:32:09.715Z"]],
          duration_s: 8.7,
        },
        {
          id: 82145,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 98 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 11.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00670_144.png"],
            },
          ],
          coverage: [["2025-02-04T11:32:16.829Z", "2025-02-04T11:32:27.862Z"]],
          duration_s: 11.0,
        },
        {
          id: 82147,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 16 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 15.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00671_267.png", "demo_alpha_frame_00672_889.png"],
            },
          ],
          coverage: [["2025-02-04T11:32:36.637Z", "2025-02-04T11:32:52.400Z"]],
          duration_s: 15.8,
        },
        {
          id: 82148,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 23.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 8.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00673_551.png"],
            },
          ],
          coverage: [["2025-02-04T11:32:56.006Z", "2025-02-04T11:33:04.384Z"]],
          duration_s: 8.4,
        },
        {
          id: 82151,
          depth: 2,
          name: "import-contacts",
          goal: "Open the fictional record for Demo Account 30 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 158.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00674_496.png",
                "demo_alpha_frame_00675_141.png",
                "demo_alpha_frame_00676_578.png",
                "demo_alpha_frame_00677_550.png",
                "demo_alpha_frame_00678_535.png",
                "demo_alpha_frame_00679_838.png",
                "demo_alpha_frame_00680_915.png",
                "demo_alpha_frame_00681_076.png",
                "demo_alpha_frame_00682_687.png",
                "demo_alpha_frame_00683_835.png",
                "demo_alpha_frame_00684_671.png",
                "demo_alpha_frame_00685_660.png",
                "demo_alpha_frame_00686_885.png",
                "demo_alpha_frame_00687_161.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:33:24.683Z", "2025-02-04T11:36:03.390Z"]],
          duration_s: 158.7,
        },
        {
          id: 82152,
          depth: 2,
          name: "review-campaign",
          goal: "Review the sample outreach workflow for Demo Account 37 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 6.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00688_506.png", "demo_alpha_frame_00689_906.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 04",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T11:36:07.201Z", "2025-02-04T11:36:13.785Z"]],
          duration_s: 6.6,
        },
        {
          id: 82155,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 44.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00690_461.png"],
            },
          ],
          coverage: [["2025-02-04T11:36:29.963Z", "2025-02-04T11:36:35.911Z"]],
          duration_s: 5.9,
        },
        {
          id: 82156,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 51 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 19.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00691_779.png"],
            },
          ],
          coverage: [["2025-02-04T11:36:37.243Z", "2025-02-04T11:36:56.453Z"]],
          duration_s: 19.2,
        },
        {
          id: 82158,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 58 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 11.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00692_412.png"],
            },
          ],
          coverage: [["2025-02-04T11:37:10.364Z", "2025-02-04T11:37:21.862Z"]],
          duration_s: 11.5,
        },
        {
          id: 82159,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 65 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 52.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00693_534.png",
                "demo_alpha_frame_00694_760.png",
                "demo_alpha_frame_00695_668.png",
                "demo_alpha_frame_00696_237.png",
                "demo_alpha_frame_00697_369.png",
                "demo_alpha_frame_00698_392.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:37:25.643Z", "2025-02-04T11:38:18.446Z"]],
          duration_s: 52.8,
        },
        {
          id: 82160,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 72 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 26.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00699_742.png",
                "demo_alpha_frame_00700_927.png",
                "demo_alpha_frame_00701_247.png",
                "demo_alpha_frame_00702_180.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:38:23.810Z", "2025-02-04T11:38:49.928Z"]],
          duration_s: 26.1,
        },
        {
          id: 82162,
          depth: 2,
          name: "review-campaign",
          goal: "Review the sample outreach workflow for Demo Account 79 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 39.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00703_045.png",
                "demo_alpha_frame_00704_489.png",
                "demo_alpha_frame_00705_986.png",
                "demo_alpha_frame_00706_228.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 70",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T11:38:57.337Z", "2025-02-04T11:39:36.714Z"]],
          duration_s: 39.4,
        },
        {
          id: 82163,
          depth: 2,
          name: "configure-sequence",
          goal: "Review the sample outreach workflow for Demo Account 86 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 47.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00707_181.png",
                "demo_alpha_frame_00708_759.png",
                "demo_alpha_frame_00709_441.png",
                "demo_alpha_frame_00710_328.png",
                "demo_alpha_frame_00711_638.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:39:39.680Z", "2025-02-04T11:40:26.886Z"]],
          duration_s: 47.2,
        },
        {
          id: 82164,
          depth: 2,
          name: "import-contacts",
          goal: "Open the fictional record for Demo Account 93 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00712_906.png"],
            },
          ],
          coverage: [["2025-02-04T11:40:29.811Z", "2025-02-04T11:40:33.482Z"]],
          duration_s: 3.7,
        },
        {
          id: 82165,
          depth: 2,
          name: "import-contacts",
          goal: "Open the fictional record for Demo Account 11 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 20.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00713_451.png",
                "demo_alpha_frame_00714_675.png",
                "demo_alpha_frame_00715_585.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:40:34.605Z", "2025-02-04T11:40:55.525Z"]],
          duration_s: 20.9,
        },
        {
          id: 82166,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 18 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 46.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00716_731.png",
                "demo_alpha_frame_00717_889.png",
                "demo_alpha_frame_00718_075.png",
                "demo_alpha_frame_00719_329.png",
                "demo_alpha_frame_00720_670.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:51:50.089Z", "2025-02-04T11:52:36.904Z"]],
          duration_s: 46.8,
        },
        {
          id: 82167,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 25 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 58.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00721_739.png",
                "demo_alpha_frame_00722_376.png",
                "demo_alpha_frame_00723_711.png",
                "demo_alpha_frame_00724_256.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:52:42.603Z", "2025-02-04T11:53:41.035Z"]],
          duration_s: 58.4,
        },
        {
          id: 82168,
          depth: 2,
          name: "review-campaign-analytics",
          goal: "Review the sample outreach workflow for Demo Account 32 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 95.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00725_774.png",
                "demo_alpha_frame_00726_431.png",
                "demo_alpha_frame_00727_756.png",
                "demo_alpha_frame_00728_860.png",
                "demo_alpha_frame_00729_598.png",
                "demo_alpha_frame_00730_697.png",
                "demo_alpha_frame_00731_865.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 39",
              qualifier: "filtered-by",
            },
            {
              object: "Demo Item 56",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T11:53:42.077Z", "2025-02-04T11:55:17.789Z"]],
          duration_s: 95.7,
        },
        {
          id: 82169,
          depth: 2,
          name: "review-campaign-analytics",
          goal: "Review the sample outreach workflow for Demo Account 39 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00732_010.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 50",
              qualifier: "filtered-by",
            },
          ],
          coverage: [["2025-02-04T11:55:19.594Z", "2025-02-04T11:55:29.283Z"]],
          duration_s: 9.7,
        },
        {
          id: 82171,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-46 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 43.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00733_946.png",
                "demo_alpha_frame_00734_000.png",
                "demo_alpha_frame_00735_116.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:55:37.444Z", "2025-02-04T11:56:21.058Z"]],
          duration_s: 43.6,
        },
        {
          id: 82172,
          depth: 2,
          name: "delete-contact",
          goal: "Open the fictional record for Demo Account 53 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 10.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00736_782.png"],
            },
          ],
          coverage: [["2025-02-04T11:56:22.624Z", "2025-02-04T11:56:33.016Z"]],
          duration_s: 10.4,
        },
        {
          id: 82173,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 60 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 17.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00737_536.png", "demo_alpha_frame_00738_459.png"],
            },
          ],
          coverage: [["2025-02-04T11:56:37.332Z", "2025-02-04T11:56:54.302Z"]],
          duration_s: 17.0,
        },
        {
          id: 82174,
          depth: 2,
          name: "import-contacts",
          goal: "Open the fictional record for Demo Account 67 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 52.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00739_708.png",
                "demo_alpha_frame_00740_308.png",
                "demo_alpha_frame_00741_842.png",
                "demo_alpha_frame_00742_404.png",
                "demo_alpha_frame_00743_272.png",
                "demo_alpha_frame_00744_535.png",
                "demo_alpha_frame_00745_610.png",
                "demo_alpha_frame_00746_649.png",
                "demo_alpha_frame_00747_456.png",
              ],
            },
          ],
          coverage: [["2025-02-04T11:56:57.673Z", "2025-02-04T11:57:50.020Z"]],
          duration_s: 52.3,
        },
        {
          id: 82175,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 74.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 28.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00748_354.png", "demo_alpha_frame_00749_905.png"],
            },
          ],
          coverage: [["2025-02-04T11:57:54.645Z", "2025-02-04T11:58:23.122Z"]],
          duration_s: 28.5,
        },
        {
          id: 82176,
          depth: 2,
          name: "review-campaign",
          goal: "Review the sample outreach workflow for Demo Account 81 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 59.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00750_509.png",
                "demo_alpha_frame_00751_010.png",
                "demo_alpha_frame_00752_920.png",
                "demo_alpha_frame_00753_081.png",
                "demo_alpha_frame_00754_735.png",
                "demo_alpha_frame_00755_120.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 19",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T11:58:24.329Z", "2025-02-04T11:59:23.319Z"]],
          duration_s: 59.0,
        },
        {
          id: 82177,
          depth: 2,
          name: "import-contacts",
          goal: "Open the fictional record for Demo Account 88 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 40.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00756_920.png",
                "demo_alpha_frame_00757_257.png",
                "demo_alpha_frame_00758_782.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 30",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T11:59:26.887Z", "2025-02-04T12:00:07.707Z"]],
          duration_s: 40.8,
        },
        {
          id: 82178,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 95 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 104.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00759_531.png",
                "demo_alpha_frame_00760_699.png",
                "demo_alpha_frame_00761_217.png",
                "demo_alpha_frame_00762_319.png",
                "demo_alpha_frame_00763_892.png",
                "demo_alpha_frame_00764_993.png",
                "demo_alpha_frame_00765_527.png",
                "demo_alpha_frame_00766_230.png",
                "demo_alpha_frame_00767_002.png",
                "demo_alpha_frame_00768_675.png",
                "demo_alpha_frame_00769_967.png",
                "demo_alpha_frame_00770_292.png",
                "demo_alpha_frame_00771_346.png",
                "demo_alpha_frame_00772_690.png",
                "demo_alpha_frame_00773_935.png",
                "demo_alpha_frame_00774_989.png",
                "demo_alpha_frame_00775_809.png",
                "demo_alpha_frame_00776_348.png",
                "demo_alpha_frame_00777_551.png",
                "demo_alpha_frame_00778_631.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 41",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T12:00:11.485Z", "2025-02-04T12:01:55.960Z"]],
          duration_s: 104.5,
        },
        {
          id: 82179,
          depth: 2,
          name: "review-campaign-analytics",
          goal: "Review the sample outreach workflow for Demo Account 13 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 139.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00779_544.png",
                "demo_alpha_frame_00780_186.png",
                "demo_alpha_frame_00781_076.png",
                "demo_alpha_frame_00782_181.png",
                "demo_alpha_frame_00783_126.png",
                "demo_alpha_frame_00784_773.png",
                "demo_alpha_frame_00785_164.png",
                "demo_alpha_frame_00786_537.png",
                "demo_alpha_frame_00787_467.png",
                "demo_alpha_frame_00788_117.png",
                "demo_alpha_frame_00789_211.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 52",
              qualifier: "filtered-by",
            },
          ],
          coverage: [["2025-02-04T12:01:58.889Z", "2025-02-04T12:04:18.105Z"]],
          duration_s: 139.2,
        },
        {
          id: 82180,
          depth: 2,
          name: "review-campaign-analytics",
          goal: "Review the sample outreach workflow for Demo Account 20 and update its demo status in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 96.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00790_669.png",
                "demo_alpha_frame_00791_186.png",
                "demo_alpha_frame_00792_122.png",
                "demo_alpha_frame_00793_289.png",
                "demo_alpha_frame_00794_611.png",
                "demo_alpha_frame_00795_935.png",
                "demo_alpha_frame_00796_911.png",
                "demo_alpha_frame_00797_264.png",
                "demo_alpha_frame_00798_240.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Calendar Item 63",
              qualifier: "filtered-by",
            },
          ],
          coverage: [["2025-02-04T12:04:21.224Z", "2025-02-04T12:05:57.804Z"]],
          duration_s: 96.6,
        },
        {
          id: 82181,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 27 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00799_734.png", "demo_alpha_frame_00800_378.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 74",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T12:06:02.364Z", "2025-02-04T12:06:11.314Z"]],
          duration_s: 9.0,
        },
        {
          id: 82182,
          depth: 2,
          name: "review-activity-report",
          goal: "Complete a fictional review-activity-report task for Demo Account 34 using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 30.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00801_439.png",
                "demo_alpha_frame_00802_954.png",
                "demo_alpha_frame_00803_664.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:06:15.155Z", "2025-02-04T12:06:45.145Z"]],
          duration_s: 30.0,
        },
        {
          id: 82184,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 41 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 12.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00804_304.png", "demo_alpha_frame_00805_496.png"],
            },
          ],
          coverage: [["2025-02-04T12:06:52.332Z", "2025-02-04T12:07:04.922Z"]],
          duration_s: 12.6,
        },
        {
          id: 82185,
          depth: 2,
          name: "import-contacts",
          goal: "Open the fictional record for Demo Account 48 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 10.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00806_163.png"],
            },
          ],
          coverage: [["2025-02-04T12:07:08.891Z", "2025-02-04T12:07:19.623Z"]],
          duration_s: 10.7,
        },
        {
          id: 82186,
          depth: 2,
          name: "research-person",
          goal: "Complete a fictional research-person task for Demo Account 55 using Slack and Arc.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 5.9,
            },
            {
              name: "app.Arc.duration_s",
              value: 1.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00807_097.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 21",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T12:07:21.005Z", "2025-02-04T12:07:28.858Z"]],
          duration_s: 7.9,
        },
        {
          id: 82187,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-62 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 304.2,
            },
          ],
          relationships: [
            {
              object: "Demo Contact 32",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T12:07:32.361Z", "2025-02-04T12:12:36.583Z"]],
          duration_s: 304.2,
        },
        {
          id: 82188,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 69 and record a fictional outcome in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 9.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00808_910.png",
                "demo_alpha_frame_00809_304.png",
                "demo_alpha_frame_00810_768.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:12:38.535Z", "2025-02-04T12:12:48.452Z"]],
          duration_s: 9.9,
        },
        {
          id: 82189,
          depth: 2,
          name: "review-document",
          goal: "Review and update Sample Enablement Guide 76 with fictional onboarding details in QuickTime Player.",
          attributes: [
            {
              name: "app.QuickTime Player.duration_s",
              value: 56.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00811_522.png",
                "demo_alpha_frame_00812_842.png",
                "demo_alpha_frame_00813_163.png",
                "demo_alpha_frame_00814_899.png",
                "demo_alpha_frame_00815_377.png",
                "demo_alpha_frame_00816_832.png",
                "demo_alpha_frame_00817_618.png",
                "demo_alpha_frame_00818_229.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:12:50.572Z", "2025-02-04T12:13:49.803Z"]],
          duration_s: 59.2,
        },
        {
          id: 82190,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-83 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 31.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00819_628.png",
                "demo_alpha_frame_00820_820.png",
                "demo_alpha_frame_00821_442.png",
                "demo_alpha_frame_00822_519.png",
                "demo_alpha_frame_00823_767.png",
                "demo_alpha_frame_00824_012.png",
                "demo_alpha_frame_00825_670.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 65",
              qualifier: "viewed",
            },
            {
              object: "Demo Item 82",
              qualifier: "viewed",
            },
            {
              object: "Demo Item 02",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T12:13:52.447Z", "2025-02-04T12:14:29.155Z"]],
          duration_s: 36.7,
        },
        {
          id: 82191,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 90 and record a fictional outcome in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00826_627.png"],
            },
          ],
          coverage: [["2025-02-04T12:14:33.472Z", "2025-02-04T12:14:41.599Z"]],
          duration_s: 8.1,
        },
        {
          id: 82192,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 97.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 11.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00827_762.png"],
            },
          ],
          coverage: [["2025-02-04T12:14:42.456Z", "2025-02-04T12:14:56.575Z"]],
          duration_s: 14.1,
        },
        {
          id: 82193,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-15 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 16.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00828_198.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 01",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T12:15:01.518Z", "2025-02-04T12:15:17.831Z"]],
          duration_s: 16.3,
        },
        {
          id: 82194,
          depth: 2,
          name: "review-document",
          goal: "Review and update Sample Enablement Guide 22 with fictional onboarding details in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 10.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00829_580.png"],
            },
          ],
          coverage: [["2025-02-04T12:15:21.619Z", "2025-02-04T12:15:31.904Z"]],
          duration_s: 10.3,
        },
        {
          id: 82195,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 29 and update its sample fields in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 12.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00830_842.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 23",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T12:15:34.890Z", "2025-02-04T12:15:47.576Z"]],
          duration_s: 12.7,
        },
        {
          id: 82196,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Slack to continue Sample Workflow 36.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00831_978.png"],
            },
          ],
          coverage: [["2025-02-04T12:15:50.484Z", "2025-02-04T12:15:59.259Z"]],
          duration_s: 8.8,
        },
        {
          id: 82197,
          depth: 2,
          name: "review-document",
          goal: "Review and update Sample Enablement Guide 43 with fictional onboarding details in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 24.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00832_670.png",
                "demo_alpha_frame_00833_074.png",
                "demo_alpha_frame_00834_399.png",
                "demo_alpha_frame_00835_503.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:16:04.024Z", "2025-02-04T12:16:28.213Z"]],
          duration_s: 24.2,
        },
        {
          id: 82198,
          depth: 2,
          name: "review-document",
          goal: "Review and update Sample Enablement Guide 50 with fictional onboarding details in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 6.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00836_826.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 56",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T12:16:28.642Z", "2025-02-04T12:16:34.656Z"]],
          duration_s: 6.0,
        },
        {
          id: 82199,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-57 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00837_431.png", "demo_alpha_frame_00838_198.png"],
            },
          ],
          coverage: [["2025-02-04T12:16:38.506Z", "2025-02-04T12:16:46.974Z"]],
          duration_s: 8.5,
        },
        {
          id: 82200,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Slack to continue Sample Workflow 64.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00839_306.png"],
            },
          ],
          coverage: [["2025-02-04T12:16:51.922Z", "2025-02-04T12:17:00.539Z"]],
          duration_s: 8.6,
        },
        {
          id: 82201,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-71 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 28.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00840_361.png", "demo_alpha_frame_00841_771.png"],
            },
          ],
          coverage: [["2025-02-04T12:17:01.275Z", "2025-02-04T12:17:29.611Z"]],
          duration_s: 28.3,
        },
        {
          id: 82202,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-78 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 13.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00842_183.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 03",
              qualifier: "mentioned",
            },
            {
              object: "#demo-ops-20",
              qualifier: "posted-to",
            },
          ],
          coverage: [["2025-02-04T12:17:30.010Z", "2025-02-04T12:17:43.102Z"]],
          duration_s: 13.1,
        },
        {
          id: 82203,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Notion and Slack to continue Sample Workflow 85.",
          attributes: [
            {
              name: "app.Notion.duration_s",
              value: 4.3,
            },
            {
              name: "app.Slack.duration_s",
              value: 2.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00843_583.png"],
            },
          ],
          coverage: [["2025-02-04T12:17:44.935Z", "2025-02-04T12:17:51.763Z"]],
          duration_s: 6.8,
        },
        {
          id: 82204,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-92 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 108.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00844_067.png",
                "demo_alpha_frame_00845_576.png",
                "demo_alpha_frame_00846_850.png",
                "demo_alpha_frame_00847_436.png",
                "demo_alpha_frame_00848_759.png",
                "demo_alpha_frame_00849_914.png",
                "demo_alpha_frame_00850_380.png",
                "demo_alpha_frame_00851_765.png",
                "demo_alpha_frame_00852_591.png",
                "demo_alpha_frame_00853_258.png",
                "demo_alpha_frame_00854_174.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:17:52.231Z", "2025-02-04T12:19:54.740Z"]],
          duration_s: 122.5,
        },
        {
          id: 82205,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-10 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 23.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00855_859.png",
                "demo_alpha_frame_00856_584.png",
                "demo_alpha_frame_00857_776.png",
                "demo_alpha_frame_00858_028.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 36",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T12:19:59.588Z", "2025-02-04T12:20:22.838Z"]],
          duration_s: 23.3,
        },
        {
          id: 82206,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-17 and post a sample status update using Slack and Gmail.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 5.8,
            },
            {
              name: "app.Gmail.duration_s",
              value: 3.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00859_178.png"],
            },
          ],
          coverage: [["2025-02-04T12:20:27.396Z", "2025-02-04T12:20:36.809Z"]],
          duration_s: 9.4,
        },
        {
          id: 82207,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 24 and record a fictional outcome in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 16.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00860_483.png", "demo_alpha_frame_00861_125.png"],
            },
          ],
          coverage: [["2025-02-04T12:20:38.550Z", "2025-02-04T12:20:55.075Z"]],
          duration_s: 16.5,
        },
        {
          id: 82208,
          depth: 2,
          name: "share-content",
          goal: "Review and update Sample Enablement Guide 31 with fictional onboarding details in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 43.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00862_541.png",
                "demo_alpha_frame_00863_589.png",
                "demo_alpha_frame_00864_087.png",
                "demo_alpha_frame_00865_043.png",
                "demo_alpha_frame_00866_064.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:20:56.842Z", "2025-02-04T12:21:40.367Z"]],
          duration_s: 43.5,
        },
        {
          id: 82209,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc and Slack to continue Sample Workflow 38.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 6.5,
            },
            {
              name: "app.Slack.duration_s",
              value: 1.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00867_819.png"],
            },
          ],
          coverage: [["2025-02-04T12:21:45.224Z", "2025-02-04T12:21:52.720Z"]],
          duration_s: 7.5,
        },
        {
          id: 82210,
          depth: 2,
          name: "share-content",
          goal: "Review and update Sample Enablement Guide 45 with fictional onboarding details in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 45.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00868_849.png",
                "demo_alpha_frame_00869_141.png",
                "demo_alpha_frame_00870_786.png",
                "demo_alpha_frame_00871_122.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:21:57.322Z", "2025-02-04T12:22:43.226Z"]],
          duration_s: 45.9,
        },
        {
          id: 82211,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-52 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 32.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00872_636.png",
                "demo_alpha_frame_00873_260.png",
                "demo_alpha_frame_00874_234.png",
                "demo_alpha_frame_00875_433.png",
              ],
            },
          ],
          relationships: [
            {
              object: "#demo-ops-05",
              qualifier: "posted-to",
            },
          ],
          coverage: [["2025-02-04T12:22:47.704Z", "2025-02-04T12:23:20.105Z"]],
          duration_s: 32.4,
        },
        {
          id: 82212,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-59 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 22.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00876_676.png", "demo_alpha_frame_00877_629.png"],
            },
          ],
          coverage: [["2025-02-04T12:23:23.067Z", "2025-02-04T12:23:45.968Z"]],
          duration_s: 22.9,
        },
        {
          id: 82213,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-66 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 189.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00878_355.png",
                "demo_alpha_frame_00879_820.png",
                "demo_alpha_frame_00880_230.png",
                "demo_alpha_frame_00881_708.png",
                "demo_alpha_frame_00882_450.png",
                "demo_alpha_frame_00883_736.png",
                "demo_alpha_frame_00884_919.png",
                "demo_alpha_frame_00885_432.png",
                "demo_alpha_frame_00886_650.png",
                "demo_alpha_frame_00887_108.png",
                "demo_alpha_frame_00888_148.png",
                "demo_alpha_frame_00889_162.png",
                "demo_alpha_frame_00890_420.png",
                "demo_alpha_frame_00891_841.png",
                "demo_alpha_frame_00892_320.png",
              ],
            },
          ],
          relationships: [
            {
              object: "#demo-ops-27",
              qualifier: "posted-to",
            },
          ],
          coverage: [["2025-02-04T12:23:46.739Z", "2025-02-04T12:26:56.635Z"]],
          duration_s: 189.9,
        },
        {
          id: 82214,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-73 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 27.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00893_266.png",
                "demo_alpha_frame_00894_082.png",
                "demo_alpha_frame_00895_140.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 38",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T12:26:57.307Z", "2025-02-04T12:27:24.874Z"]],
          duration_s: 27.6,
        },
        {
          id: 82215,
          depth: 2,
          name: "review-document",
          goal: "Review and update Sample Enablement Guide 80 with fictional onboarding details in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 4.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00896_034.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 49",
              qualifier: "accessed",
            },
          ],
          coverage: [["2025-02-04T12:27:27.153Z", "2025-02-04T12:27:31.477Z"]],
          duration_s: 4.3,
        },
        {
          id: 82224,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-87 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 35.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00897_889.png",
                "demo_alpha_frame_00898_670.png",
                "demo_alpha_frame_00899_380.png",
                "demo_alpha_frame_00900_605.png",
                "demo_alpha_frame_00901_061.png",
                "demo_alpha_frame_00902_876.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:28:29Z", "2025-02-04T12:29:04.102Z"]],
          duration_s: 35.1,
        },
        {
          id: 82225,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-94 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 16.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00903_159.png"],
            },
          ],
          coverage: [["2025-02-04T12:29:07.089Z", "2025-02-04T12:29:23.573Z"]],
          duration_s: 16.5,
        },
        {
          id: 82226,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-12 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 14.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00904_671.png",
                "demo_alpha_frame_00905_697.png",
                "demo_alpha_frame_00906_823.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:29:25.952Z", "2025-02-04T12:29:39.971Z"]],
          duration_s: 14.0,
        },
        {
          id: 82227,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Slack to continue Sample Workflow 19.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 9.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00907_354.png"],
            },
          ],
          coverage: [["2025-02-04T12:29:45.720Z", "2025-02-04T12:29:55.499Z"]],
          duration_s: 9.8,
        },
        {
          id: 82229,
          depth: 2,
          name: "read-document",
          goal: "Review and update Sample Enablement Guide 26 with fictional onboarding details in Gmail.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 4.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00908_819.png", "demo_alpha_frame_00909_777.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 07",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T12:30:03.956Z", "2025-02-04T12:30:08.833Z"]],
          duration_s: 4.9,
        },
        {
          id: 82232,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 33 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 26.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00910_661.png",
                "demo_alpha_frame_00911_059.png",
                "demo_alpha_frame_00912_635.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:30:23.439Z", "2025-02-04T12:30:50.154Z"]],
          duration_s: 26.7,
        },
        {
          id: 82245,
          depth: 2,
          name: "share-content",
          goal: "Review and update Sample Enablement Guide 40 with fictional onboarding details in Granola and Slack.",
          attributes: [
            {
              name: "app.Granola.duration_s",
              value: 41.7,
            },
            {
              name: "app.Slack.duration_s",
              value: 12.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00913_004.png",
                "demo_alpha_frame_00914_775.png",
                "demo_alpha_frame_00915_874.png",
                "demo_alpha_frame_00916_281.png",
                "demo_alpha_frame_00917_673.png",
                "demo_alpha_frame_00918_568.png",
                "demo_alpha_frame_00919_841.png",
                "demo_alpha_frame_00920_255.png",
                "demo_alpha_frame_00921_691.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 29",
              qualifier: "corresponded-with",
            },
            {
              object: "Sample Reference 46",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T12:32:09.864Z", "2025-02-04T12:33:04.135Z"]],
          duration_s: 54.3,
        },
        {
          id: 82246,
          depth: 2,
          name: "react-message",
          goal: "Review the fictional conversation in #demo-ops-47 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 16.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00922_162.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 40",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T12:33:04.647Z", "2025-02-04T12:33:20.913Z"]],
          duration_s: 16.3,
        },
        {
          id: 82247,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Slack to continue Sample Workflow 54.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00923_313.png"],
            },
          ],
          coverage: [["2025-02-04T12:33:21.602Z", "2025-02-04T12:33:29.630Z"]],
          duration_s: 8.0,
        },
        {
          id: 82248,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 61 and update its sample fields in Arc and Gmail.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 16.2,
            },
            {
              name: "app.Gmail.duration_s",
              value: 9.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00924_923.png", "demo_alpha_frame_00925_976.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 62",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 79",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T12:33:30.988Z", "2025-02-04T12:33:59.093Z"]],
          duration_s: 28.1,
        },
        {
          id: 82249,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-68 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 8.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_00926_786.png", "demo_alpha_frame_00927_485.png"],
            },
          ],
          coverage: [["2025-02-04T12:49:37.749Z", "2025-02-04T12:49:49.515Z"]],
          duration_s: 11.8,
        },
        {
          id: 82250,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 75 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 27.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00928_572.png",
                "demo_alpha_frame_00929_046.png",
                "demo_alpha_frame_00930_623.png",
                "demo_alpha_frame_00931_968.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 84",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T12:49:55.110Z", "2025-02-04T12:50:22.753Z"]],
          duration_s: 27.6,
        },
        {
          id: 82251,
          depth: 2,
          name: "manage-contact",
          goal: "Open the fictional record for Demo Account 82 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 40.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00932_486.png",
                "demo_alpha_frame_00933_287.png",
                "demo_alpha_frame_00934_757.png",
                "demo_alpha_frame_00935_473.png",
                "demo_alpha_frame_00936_296.png",
                "demo_alpha_frame_00937_668.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:50:25.410Z", "2025-02-04T12:51:05.417Z"]],
          duration_s: 40.0,
        },
        {
          id: 82252,
          depth: 2,
          name: "search-reference",
          goal: "Review and update Sample Enablement Guide 89 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 1242.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00938_530.png",
                "demo_alpha_frame_00939_845.png",
                "demo_alpha_frame_00940_601.png",
                "demo_alpha_frame_00941_554.png",
                "demo_alpha_frame_00942_967.png",
                "demo_alpha_frame_00943_249.png",
                "demo_alpha_frame_00944_927.png",
                "demo_alpha_frame_00945_779.png",
                "demo_alpha_frame_00946_850.png",
                "demo_alpha_frame_00947_043.png",
                "demo_alpha_frame_00948_780.png",
                "demo_alpha_frame_00949_659.png",
                "demo_alpha_frame_00950_360.png",
                "demo_alpha_frame_00951_623.png",
                "demo_alpha_frame_00952_018.png",
                "demo_alpha_frame_00953_720.png",
                "demo_alpha_frame_00954_669.png",
                "demo_alpha_frame_00955_274.png",
                "demo_alpha_frame_00956_857.png",
                "demo_alpha_frame_00957_883.png",
                "demo_alpha_frame_00958_458.png",
                "demo_alpha_frame_00959_855.png",
                "demo_alpha_frame_00960_962.png",
                "demo_alpha_frame_00961_655.png",
              ],
            },
          ],
          coverage: [["2025-02-04T12:51:09.925Z", "2025-02-04T13:11:52.376Z"]],
          duration_s: 1242.5,
        },
        {
          id: 82253,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 96 and update its sample fields in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 48.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00962_208.png",
                "demo_alpha_frame_00963_575.png",
                "demo_alpha_frame_00964_078.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:11:56.701Z", "2025-02-04T13:12:45.124Z"]],
          duration_s: 48.4,
        },
        {
          id: 82255,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 14 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 43.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00965_268.png",
                "demo_alpha_frame_00966_150.png",
                "demo_alpha_frame_00967_046.png",
                "demo_alpha_frame_00968_881.png",
                "demo_alpha_frame_00969_667.png",
                "demo_alpha_frame_00970_013.png",
                "demo_alpha_frame_00971_410.png",
                "demo_alpha_frame_00972_709.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:12:57.399Z", "2025-02-04T13:13:43.524Z"]],
          duration_s: 46.1,
        },
        {
          id: 82256,
          depth: 2,
          name: "log-call-outcome",
          goal: "Review Sample Session 21 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 34.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00973_742.png",
                "demo_alpha_frame_00974_722.png",
                "demo_alpha_frame_00975_851.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:13:45.888Z", "2025-02-04T13:14:20.392Z"]],
          duration_s: 34.5,
        },
        {
          id: 82257,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Arc to continue Sample Workflow 28.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 51.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00976_895.png",
                "demo_alpha_frame_00977_260.png",
                "demo_alpha_frame_00978_067.png",
                "demo_alpha_frame_00979_806.png",
                "demo_alpha_frame_00980_499.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:14:24.885Z", "2025-02-04T13:15:18.498Z"]],
          duration_s: 53.6,
        },
        {
          id: 82258,
          depth: 2,
          name: "search-reference",
          goal: "Review and update Sample Enablement Guide 35 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 29.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00981_278.png",
                "demo_alpha_frame_00982_829.png",
                "demo_alpha_frame_00983_110.png",
                "demo_alpha_frame_00984_254.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:15:24.185Z", "2025-02-04T13:15:59.822Z"]],
          duration_s: 35.6,
        },
        {
          id: 82259,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Slack to continue Sample Workflow 42.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 83.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00985_906.png",
                "demo_alpha_frame_00986_480.png",
                "demo_alpha_frame_00987_225.png",
                "demo_alpha_frame_00988_887.png",
                "demo_alpha_frame_00989_448.png",
                "demo_alpha_frame_00990_555.png",
                "demo_alpha_frame_00991_651.png",
                "demo_alpha_frame_00992_035.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:16:05.051Z", "2025-02-04T13:17:39.111Z"]],
          duration_s: 94.1,
        },
        {
          id: 82260,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-49 and post a sample status update using Arc and LinkedIn.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 19.1,
            },
            {
              name: "app.LinkedIn.duration_s",
              value: 17.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00993_998.png",
                "demo_alpha_frame_00994_539.png",
                "demo_alpha_frame_00995_094.png",
                "demo_alpha_frame_00996_984.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:17:44.050Z", "2025-02-04T13:18:20.954Z"]],
          duration_s: 36.9,
        },
        {
          id: 82261,
          depth: 2,
          name: "log-call-outcome",
          goal: "Review Sample Session 56 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 88.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_00997_168.png",
                "demo_alpha_frame_00998_769.png",
                "demo_alpha_frame_00999_019.png",
                "demo_alpha_frame_01000_231.png",
                "demo_alpha_frame_01001_049.png",
                "demo_alpha_frame_01002_119.png",
                "demo_alpha_frame_01003_667.png",
                "demo_alpha_frame_01004_692.png",
                "demo_alpha_frame_01005_037.png",
                "demo_alpha_frame_01006_516.png",
                "demo_alpha_frame_01007_233.png",
                "demo_alpha_frame_01008_322.png",
                "demo_alpha_frame_01009_390.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 97",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T13:18:21.924Z", "2025-02-04T13:19:49.965Z"]],
          duration_s: 88.0,
        },
        {
          id: 82263,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 63 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 32.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01010_939.png",
                "demo_alpha_frame_01011_349.png",
                "demo_alpha_frame_01012_879.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 11",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T13:20:00.843Z", "2025-02-04T13:20:33.628Z"]],
          duration_s: 32.8,
        },
        {
          id: 82264,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 70 and update its sample fields in Slack and Arc.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 3.8,
            },
            {
              name: "app.Arc.duration_s",
              value: 3.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01013_554.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 22",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:20:36.859Z", "2025-02-04T13:20:44.157Z"]],
          duration_s: 7.3,
        },
        {
          id: 82265,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 77 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 24.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01014_244.png",
                "demo_alpha_frame_01015_283.png",
                "demo_alpha_frame_01016_329.png",
                "demo_alpha_frame_01017_788.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 33",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:20:45.714Z", "2025-02-04T13:21:12.925Z"]],
          duration_s: 27.2,
        },
        {
          id: 82266,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 84 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 7.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01018_390.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 44",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 61",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:21:13.803Z", "2025-02-04T13:21:23.341Z"]],
          duration_s: 9.5,
        },
        {
          id: 82267,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 91 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 28.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01019_149.png",
                "demo_alpha_frame_01020_721.png",
                "demo_alpha_frame_01021_743.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 55",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 72",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:21:28.713Z", "2025-02-04T13:21:56.813Z"]],
          duration_s: 28.1,
        },
        {
          id: 82268,
          depth: 2,
          name: "log-call-outcome",
          goal: "Review Sample Session 98 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 85.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01022_718.png",
                "demo_alpha_frame_01023_270.png",
                "demo_alpha_frame_01024_523.png",
                "demo_alpha_frame_01025_453.png",
                "demo_alpha_frame_01026_185.png",
                "demo_alpha_frame_01027_952.png",
                "demo_alpha_frame_01028_000.png",
                "demo_alpha_frame_01029_983.png",
                "demo_alpha_frame_01030_037.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 66",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T13:21:59.216Z", "2025-02-04T13:23:30.554Z"]],
          duration_s: 91.3,
        },
        {
          id: 82269,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 16 and update its sample fields in Gmail.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 43.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01031_169.png",
                "demo_alpha_frame_01032_951.png",
                "demo_alpha_frame_01033_042.png",
                "demo_alpha_frame_01034_512.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 77",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:23:32.798Z", "2025-02-04T13:24:23.755Z"]],
          duration_s: 51.0,
        },
        {
          id: 82270,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 23 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 12.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01035_806.png",
                "demo_alpha_frame_01036_396.png",
                "demo_alpha_frame_01037_503.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 88",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 08",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:24:25.184Z", "2025-02-04T13:24:41.444Z"]],
          duration_s: 16.3,
        },
        {
          id: 82271,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 30 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 8.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01038_188.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 02",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T13:24:45.202Z", "2025-02-04T13:24:54.876Z"]],
          duration_s: 9.7,
        },
        {
          id: 82272,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Arc to continue Sample Workflow 37.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 160.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01039_457.png",
                "demo_alpha_frame_01040_908.png",
                "demo_alpha_frame_01041_709.png",
                "demo_alpha_frame_01042_072.png",
                "demo_alpha_frame_01043_221.png",
                "demo_alpha_frame_01044_343.png",
                "demo_alpha_frame_01045_712.png",
                "demo_alpha_frame_01046_449.png",
                "demo_alpha_frame_01047_090.png",
                "demo_alpha_frame_01048_269.png",
                "demo_alpha_frame_01049_845.png",
                "demo_alpha_frame_01050_181.png",
                "demo_alpha_frame_01051_379.png",
                "demo_alpha_frame_01052_932.png",
                "demo_alpha_frame_01053_574.png",
                "demo_alpha_frame_01054_236.png",
                "demo_alpha_frame_01055_362.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:24:59.794Z", "2025-02-04T13:27:46.144Z"]],
          duration_s: 166.4,
        },
        {
          id: 82273,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 44 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 89.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01056_214.png",
                "demo_alpha_frame_01057_267.png",
                "demo_alpha_frame_01058_272.png",
                "demo_alpha_frame_01059_517.png",
                "demo_alpha_frame_01060_138.png",
                "demo_alpha_frame_01061_040.png",
                "demo_alpha_frame_01062_870.png",
                "demo_alpha_frame_01063_231.png",
                "demo_alpha_frame_01064_687.png",
                "demo_alpha_frame_01065_109.png",
                "demo_alpha_frame_01066_419.png",
                "demo_alpha_frame_01067_594.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:27:48.082Z", "2025-02-04T13:29:17.882Z"]],
          duration_s: 89.8,
        },
        {
          id: 82274,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 51 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 19.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01068_126.png", "demo_alpha_frame_01069_112.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 35",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T13:29:18.749Z", "2025-02-04T13:29:43.573Z"]],
          duration_s: 24.8,
        },
        {
          id: 82275,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 58 and update its sample fields in Arc and Gmail.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 25.6,
            },
            {
              name: "app.Gmail.duration_s",
              value: 24.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01070_151.png",
                "demo_alpha_frame_01071_420.png",
                "demo_alpha_frame_01072_133.png",
                "demo_alpha_frame_01073_477.png",
                "demo_alpha_frame_01074_819.png",
                "demo_alpha_frame_01075_759.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 46",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:29:46.838Z", "2025-02-04T13:30:36.399Z"]],
          duration_s: 49.6,
        },
        {
          id: 82276,
          depth: 2,
          name: "create-record",
          goal: "Open the fictional record for Demo Account 65 and update its sample fields in Arc and Salesforce.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 25.6,
            },
            {
              name: "app.Salesforce.duration_s",
              value: 20.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01076_780.png",
                "demo_alpha_frame_01077_984.png",
                "demo_alpha_frame_01078_304.png",
                "demo_alpha_frame_01079_903.png",
                "demo_alpha_frame_01080_901.png",
                "demo_alpha_frame_01081_345.png",
                "demo_alpha_frame_01082_548.png",
                "demo_alpha_frame_01083_159.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 57",
              qualifier: "referenced",
            },
            {
              object: "Demo Item 74",
              qualifier: "created",
            },
          ],
          coverage: [["2025-02-04T13:30:39.054Z", "2025-02-04T13:31:25.116Z"]],
          duration_s: 46.1,
        },
        {
          id: 82277,
          depth: 2,
          name: "create-record",
          goal: "Open the fictional record for Demo Account 72 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 6.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01084_100.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 68",
              qualifier: "created",
            },
          ],
          coverage: [["2025-02-04T13:31:30.840Z", "2025-02-04T13:31:42.296Z"]],
          duration_s: 11.5,
        },
        {
          id: 82278,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 79 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 12.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01085_968.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 79",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T13:31:47.299Z", "2025-02-04T13:31:59.932Z"]],
          duration_s: 12.6,
        },
        {
          id: 82280,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 86 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 26.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01086_528.png", "demo_alpha_frame_01087_150.png"],
            },
          ],
          coverage: [["2025-02-04T13:32:07.066Z", "2025-02-04T13:32:33.774Z"]],
          duration_s: 26.7,
        },
        {
          id: 82282,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 93 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01088_783.png"],
            },
          ],
          coverage: [["2025-02-04T13:32:45.257Z", "2025-02-04T13:32:51.187Z"]],
          duration_s: 5.9,
        },
        {
          id: 82283,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 11 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 11.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01089_588.png", "demo_alpha_frame_01090_328.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 15",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T13:32:53.258Z", "2025-02-04T13:33:05.125Z"]],
          duration_s: 11.9,
        },
        {
          id: 82284,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 18 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01091_139.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 26",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T13:33:09.504Z", "2025-02-04T13:33:15.163Z"]],
          duration_s: 5.7,
        },
        {
          id: 82286,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Salesforce to continue Sample Workflow 25.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 6.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01092_855.png", "demo_alpha_frame_01093_950.png"],
            },
          ],
          coverage: [["2025-02-04T13:33:20.806Z", "2025-02-04T13:33:27.109Z"]],
          duration_s: 6.3,
        },
        {
          id: 82287,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-32 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 15.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01094_473.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 48",
              qualifier: "corresponded-with",
            },
            {
              object: "Demo Contact 65",
              qualifier: "corresponded-with",
            },
            {
              object: "Demo Contact 82",
              qualifier: "corresponded-with",
            },
            {
              object: "Demo Contact 02",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T13:33:31.327Z", "2025-02-04T13:33:46.715Z"]],
          duration_s: 15.4,
        },
        {
          id: 82288,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Slack to continue Sample Workflow 39.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 74.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01095_733.png",
                "demo_alpha_frame_01096_893.png",
                "demo_alpha_frame_01097_739.png",
                "demo_alpha_frame_01098_753.png",
                "demo_alpha_frame_01099_614.png",
                "demo_alpha_frame_01100_558.png",
                "demo_alpha_frame_01101_172.png",
                "demo_alpha_frame_01102_196.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:33:52.285Z", "2025-02-04T13:35:07.034Z"]],
          duration_s: 74.7,
        },
        {
          id: 82290,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 46 and update its sample fields in Gmail and Arc.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 6.8,
            },
            {
              name: "app.Arc.duration_s",
              value: 5.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01103_420.png"],
            },
          ],
          coverage: [["2025-02-04T13:35:16.760Z", "2025-02-04T13:35:29.325Z"]],
          duration_s: 12.6,
        },
        {
          id: 82291,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 53 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 13.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01104_079.png", "demo_alpha_frame_01105_998.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 81",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:35:33.573Z", "2025-02-04T13:35:47.496Z"]],
          duration_s: 13.9,
        },
        {
          id: 82293,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 60 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 11.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01106_338.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 92",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:35:58.625Z", "2025-02-04T13:36:09.643Z"]],
          duration_s: 11.0,
        },
        {
          id: 82294,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 67 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 29.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01107_944.png", "demo_alpha_frame_01108_093.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 06",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 23",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:36:11.267Z", "2025-02-04T13:36:43.108Z"]],
          duration_s: 31.8,
        },
        {
          id: 82295,
          depth: 2,
          name: "log-call-outcome",
          goal: "Review Sample Session 74 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 11.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01109_610.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 17",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:36:47.947Z", "2025-02-04T13:37:03.740Z"]],
          duration_s: 15.8,
        },
        {
          id: 82296,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 81 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 10.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01110_984.png"],
            },
          ],
          coverage: [["2025-02-04T13:37:07.402Z", "2025-02-04T13:37:18.030Z"]],
          duration_s: 10.6,
        },
        {
          id: 82297,
          depth: 2,
          name: "react-message",
          goal: "Review the fictional conversation in #demo-ops-88 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 14.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01111_385.png"],
            },
          ],
          coverage: [["2025-02-04T13:37:20.740Z", "2025-02-04T13:37:36.161Z"]],
          duration_s: 15.4,
        },
        {
          id: 82298,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 95 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 11.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01112_033.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 50",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:37:36.566Z", "2025-02-04T13:37:52.328Z"]],
          duration_s: 15.8,
        },
        {
          id: 82299,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 13 and update its sample fields in Gmail.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 8.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01113_130.png", "demo_alpha_frame_01114_794.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 61",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:37:53.951Z", "2025-02-04T13:38:06.405Z"]],
          duration_s: 12.5,
        },
        {
          id: 82300,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 20 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 8.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01115_020.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 72",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 89",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:38:09.363Z", "2025-02-04T13:38:17.599Z"]],
          duration_s: 8.2,
        },
        {
          id: 82301,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 27 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01116_912.png"],
            },
          ],
          coverage: [["2025-02-04T13:38:23.257Z", "2025-02-04T13:38:32.089Z"]],
          duration_s: 8.8,
        },
        {
          id: 82302,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 34 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01117_791.png", "demo_alpha_frame_01118_243.png"],
            },
          ],
          coverage: [["2025-02-04T13:38:33.451Z", "2025-02-04T13:38:42.914Z"]],
          duration_s: 9.5,
        },
        {
          id: 82303,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 41 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 16.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01119_781.png",
                "demo_alpha_frame_01120_214.png",
                "demo_alpha_frame_01121_119.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:38:45.067Z", "2025-02-04T13:39:01.290Z"]],
          duration_s: 16.2,
        },
        {
          id: 82305,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-48 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 16.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01122_298.png", "demo_alpha_frame_01123_441.png"],
            },
          ],
          coverage: [["2025-02-04T13:39:09.865Z", "2025-02-04T13:39:26.587Z"]],
          duration_s: 16.7,
        },
        {
          id: 82306,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Gmail to continue Sample Workflow 55.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 28.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01124_329.png",
                "demo_alpha_frame_01125_016.png",
                "demo_alpha_frame_01126_623.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:39:31.488Z", "2025-02-04T13:40:01.978Z"]],
          duration_s: 30.5,
        },
        {
          id: 82307,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-62 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 11.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01127_943.png", "demo_alpha_frame_01128_388.png"],
            },
          ],
          coverage: [["2025-02-04T13:40:05.107Z", "2025-02-04T13:40:16.388Z"]],
          duration_s: 11.3,
        },
        {
          id: 82308,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Gmail to continue Sample Workflow 69.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 224.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01129_658.png",
                "demo_alpha_frame_01130_059.png",
                "demo_alpha_frame_01131_407.png",
                "demo_alpha_frame_01132_097.png",
                "demo_alpha_frame_01133_243.png",
                "demo_alpha_frame_01134_161.png",
                "demo_alpha_frame_01135_109.png",
                "demo_alpha_frame_01136_203.png",
                "demo_alpha_frame_01137_478.png",
                "demo_alpha_frame_01138_729.png",
                "demo_alpha_frame_01139_684.png",
                "demo_alpha_frame_01140_702.png",
                "demo_alpha_frame_01141_616.png",
                "demo_alpha_frame_01142_855.png",
                "demo_alpha_frame_01143_380.png",
                "demo_alpha_frame_01144_836.png",
                "demo_alpha_frame_01145_913.png",
                "demo_alpha_frame_01146_044.png",
                "demo_alpha_frame_01147_086.png",
                "demo_alpha_frame_01148_026.png",
                "demo_alpha_frame_01149_393.png",
                "demo_alpha_frame_01150_209.png",
                "demo_alpha_frame_01151_763.png",
                "demo_alpha_frame_01152_656.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:40:18.349Z", "2025-02-04T13:44:05.761Z"]],
          duration_s: 227.4,
        },
        {
          id: 82309,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 76 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 344.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01153_735.png",
                "demo_alpha_frame_01154_938.png",
                "demo_alpha_frame_01155_756.png",
                "demo_alpha_frame_01156_337.png",
                "demo_alpha_frame_01157_477.png",
                "demo_alpha_frame_01158_445.png",
                "demo_alpha_frame_01159_924.png",
                "demo_alpha_frame_01160_334.png",
                "demo_alpha_frame_01161_481.png",
                "demo_alpha_frame_01162_072.png",
                "demo_alpha_frame_01163_450.png",
                "demo_alpha_frame_01164_033.png",
                "demo_alpha_frame_01165_360.png",
                "demo_alpha_frame_01166_453.png",
                "demo_alpha_frame_01167_676.png",
                "demo_alpha_frame_01168_117.png",
                "demo_alpha_frame_01169_287.png",
                "demo_alpha_frame_01170_155.png",
                "demo_alpha_frame_01171_829.png",
                "demo_alpha_frame_01172_663.png",
                "demo_alpha_frame_01173_231.png",
                "demo_alpha_frame_01174_127.png",
                "demo_alpha_frame_01175_683.png",
                "demo_alpha_frame_01176_520.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 63",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:44:07.203Z", "2025-02-04T13:49:52.077Z"]],
          duration_s: 344.9,
        },
        {
          id: 82310,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Slack to continue Sample Workflow 83.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 223.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01177_892.png",
                "demo_alpha_frame_01178_252.png",
                "demo_alpha_frame_01179_695.png",
                "demo_alpha_frame_01180_720.png",
                "demo_alpha_frame_01181_686.png",
                "demo_alpha_frame_01182_761.png",
                "demo_alpha_frame_01183_907.png",
                "demo_alpha_frame_01184_279.png",
                "demo_alpha_frame_01185_817.png",
                "demo_alpha_frame_01186_261.png",
                "demo_alpha_frame_01187_640.png",
                "demo_alpha_frame_01188_858.png",
                "demo_alpha_frame_01189_306.png",
                "demo_alpha_frame_01190_052.png",
                "demo_alpha_frame_01191_240.png",
                "demo_alpha_frame_01192_078.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 74",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:49:57.293Z", "2025-02-04T13:53:40.453Z"]],
          duration_s: 223.2,
        },
        {
          id: 82311,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Arc to continue Sample Workflow 90.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 242.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01193_785.png",
                "demo_alpha_frame_01194_195.png",
                "demo_alpha_frame_01195_282.png",
                "demo_alpha_frame_01196_109.png",
                "demo_alpha_frame_01197_143.png",
                "demo_alpha_frame_01198_503.png",
                "demo_alpha_frame_01199_451.png",
                "demo_alpha_frame_01200_469.png",
                "demo_alpha_frame_01201_161.png",
                "demo_alpha_frame_01202_576.png",
                "demo_alpha_frame_01203_505.png",
                "demo_alpha_frame_01204_369.png",
                "demo_alpha_frame_01205_164.png",
                "demo_alpha_frame_01206_297.png",
                "demo_alpha_frame_01207_088.png",
                "demo_alpha_frame_01208_856.png",
                "demo_alpha_frame_01209_757.png",
                "demo_alpha_frame_01210_370.png",
                "demo_alpha_frame_01211_452.png",
                "demo_alpha_frame_01212_013.png",
                "demo_alpha_frame_01213_521.png",
                "demo_alpha_frame_01214_412.png",
                "demo_alpha_frame_01215_520.png",
                "demo_alpha_frame_01216_918.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:53:43.593Z", "2025-02-04T13:57:46.220Z"]],
          duration_s: 242.6,
        },
        {
          id: 82312,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Google Chrome to continue Sample Workflow 97.",
          attributes: [
            {
              name: "app.Google Chrome.duration_s",
              value: 1036.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01217_016.png",
                "demo_alpha_frame_01218_840.png",
                "demo_alpha_frame_01219_908.png",
                "demo_alpha_frame_01220_370.png",
                "demo_alpha_frame_01221_740.png",
                "demo_alpha_frame_01222_816.png",
                "demo_alpha_frame_01223_768.png",
                "demo_alpha_frame_01224_480.png",
                "demo_alpha_frame_01225_612.png",
                "demo_alpha_frame_01226_005.png",
                "demo_alpha_frame_01227_550.png",
                "demo_alpha_frame_01228_189.png",
                "demo_alpha_frame_01229_610.png",
                "demo_alpha_frame_01230_303.png",
                "demo_alpha_frame_01231_500.png",
                "demo_alpha_frame_01232_755.png",
                "demo_alpha_frame_01233_141.png",
                "demo_alpha_frame_01234_473.png",
                "demo_alpha_frame_01235_330.png",
                "demo_alpha_frame_01236_372.png",
                "demo_alpha_frame_01237_274.png",
                "demo_alpha_frame_01238_939.png",
                "demo_alpha_frame_01239_213.png",
                "demo_alpha_frame_01240_149.png",
              ],
            },
          ],
          coverage: [["2025-02-04T13:57:47.421Z", "2025-02-04T14:15:04.180Z"]],
          duration_s: 1036.8,
        },
        {
          id: 82315,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Slack to continue Sample Workflow 15.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01241_922.png", "demo_alpha_frame_01242_687.png"],
            },
          ],
          coverage: [["2025-02-04T14:15:21.159Z", "2025-02-04T14:15:29.819Z"]],
          duration_s: 8.7,
        },
        {
          id: 82316,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 22 and update its sample fields in Gmail.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 8.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01243_184.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 21",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:15:32.673Z", "2025-02-04T14:15:43.545Z"]],
          duration_s: 10.9,
        },
        {
          id: 82317,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Salesforce and Slack to continue Sample Workflow 29.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 27.9,
            },
            {
              name: "app.Slack.duration_s",
              value: 9.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01244_369.png",
                "demo_alpha_frame_01245_430.png",
                "demo_alpha_frame_01246_469.png",
              ],
            },
          ],
          coverage: [["2025-02-04T14:15:48.599Z", "2025-02-04T14:16:32.112Z"]],
          duration_s: 43.5,
        },
        {
          id: 82318,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-36 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 114.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01247_262.png",
                "demo_alpha_frame_01248_216.png",
                "demo_alpha_frame_01249_603.png",
                "demo_alpha_frame_01250_017.png",
                "demo_alpha_frame_01251_992.png",
                "demo_alpha_frame_01252_239.png",
                "demo_alpha_frame_01253_738.png",
                "demo_alpha_frame_01254_758.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 43",
              qualifier: "referenced",
            },
            {
              object: "Demo Contact 60",
              qualifier: "corresponded-with",
            },
            {
              object: "Demo Contact 77",
              qualifier: "corresponded-with",
            },
            {
              object: "Demo Contact 94",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T14:16:36.445Z", "2025-02-04T14:18:31.171Z"]],
          duration_s: 114.7,
        },
        {
          id: 82319,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-43 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 50.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01255_005.png",
                "demo_alpha_frame_01256_473.png",
                "demo_alpha_frame_01257_740.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 54",
              qualifier: "corresponded-with",
            },
            {
              object: "Sample Reference 71",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:18:34.703Z", "2025-02-04T14:19:25.240Z"]],
          duration_s: 50.5,
        },
        {
          id: 82320,
          depth: 2,
          name: "review-thread",
          goal: "Review the fictional conversation in #demo-ops-50 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01258_602.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 65",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 82",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:19:29.655Z", "2025-02-04T14:19:37.967Z"]],
          duration_s: 8.3,
        },
        {
          id: 82322,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 57 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 37.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01259_122.png",
                "demo_alpha_frame_01260_121.png",
                "demo_alpha_frame_01261_647.png",
                "demo_alpha_frame_01262_893.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 76",
              qualifier: "searched",
            },
          ],
          coverage: [["2025-02-04T14:19:48.543Z", "2025-02-04T14:20:26.469Z"]],
          duration_s: 37.9,
        },
        {
          id: 82323,
          depth: 2,
          name: "access-report",
          goal: "Verify the sample workspace configuration for Demo Contact 64 using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 32.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01263_622.png",
                "demo_alpha_frame_01264_724.png",
                "demo_alpha_frame_01265_971.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 87",
              qualifier: "downloaded",
            },
          ],
          coverage: [["2025-02-04T14:20:27.800Z", "2025-02-04T14:21:05.146Z"]],
          duration_s: 37.3,
        },
        {
          id: 82324,
          depth: 2,
          name: "read-document",
          goal: "Review and update Sample Enablement Guide 71 with fictional onboarding details in Arc and Notion.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.1,
            },
            {
              name: "app.Notion.duration_s",
              value: 2.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01266_901.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 01",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:21:09.973Z", "2025-02-04T14:21:16.015Z"]],
          duration_s: 6.0,
        },
        {
          id: 82325,
          depth: 2,
          name: "review-thread",
          goal: "Review the fictional conversation in #demo-ops-78 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 57.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01267_005.png",
                "demo_alpha_frame_01268_868.png",
                "demo_alpha_frame_01269_152.png",
                "demo_alpha_frame_01270_505.png",
                "demo_alpha_frame_01271_074.png",
                "demo_alpha_frame_01272_369.png",
                "demo_alpha_frame_01273_465.png",
                "demo_alpha_frame_01274_844.png",
                "demo_alpha_frame_01275_456.png",
                "demo_alpha_frame_01276_428.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 12",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 29",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:21:20.594Z", "2025-02-04T14:22:18.166Z"]],
          duration_s: 57.6,
        },
        {
          id: 82326,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 85 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 46.5,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01277_610.png",
                "demo_alpha_frame_01278_799.png",
                "demo_alpha_frame_01279_101.png",
                "demo_alpha_frame_01280_208.png",
                "demo_alpha_frame_01281_721.png",
                "demo_alpha_frame_01282_057.png",
              ],
            },
          ],
          coverage: [["2025-02-04T14:22:21.251Z", "2025-02-04T14:23:07.790Z"]],
          duration_s: 46.5,
        },
        {
          id: 82327,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Slack and Arc to continue Sample Workflow 92.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 2.5,
            },
            {
              name: "app.Arc.duration_s",
              value: 2.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01283_273.png"],
            },
          ],
          coverage: [["2025-02-04T14:23:11.247Z", "2025-02-04T14:23:16.254Z"]],
          duration_s: 5.0,
        },
        {
          id: 82329,
          depth: 2,
          name: "manage-team",
          goal: "Verify the sample workspace configuration for Demo Contact 10 using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 14.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01284_287.png", "demo_alpha_frame_01285_921.png"],
            },
          ],
          coverage: [["2025-02-04T14:23:29.100Z", "2025-02-04T14:23:44.951Z"]],
          duration_s: 15.9,
        },
        {
          id: 82330,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-17 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01286_281.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 56",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:23:48.402Z", "2025-02-04T14:23:59.692Z"]],
          duration_s: 11.3,
        },
        {
          id: 82331,
          depth: 2,
          name: "read-document",
          goal: "Review and update Sample Enablement Guide 24 with fictional onboarding details in Notion.",
          attributes: [
            {
              name: "app.Notion.duration_s",
              value: 3.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01287_880.png", "demo_alpha_frame_01288_712.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 67",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:24:03.021Z", "2025-02-04T14:24:06.584Z"]],
          duration_s: 3.6,
        },
        {
          id: 82332,
          depth: 2,
          name: "reply-thread",
          goal: "Review the fictional conversation in #demo-ops-31 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 6.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01289_183.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 78",
              qualifier: "referenced",
            },
            {
              object: "Demo Contact 95",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T14:37:54.248Z", "2025-02-04T14:38:00.668Z"]],
          duration_s: 6.4,
        },
        {
          id: 82333,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-38 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 32.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01290_395.png",
                "demo_alpha_frame_01291_642.png",
                "demo_alpha_frame_01292_477.png",
                "demo_alpha_frame_01293_735.png",
                "demo_alpha_frame_01294_707.png",
              ],
            },
          ],
          coverage: [["2025-02-04T14:38:06.092Z", "2025-02-04T14:38:38.477Z"]],
          duration_s: 32.4,
        },
        {
          id: 82334,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 45 and update its sample fields in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 7.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01295_372.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 03",
              qualifier: "searched",
            },
          ],
          coverage: [["2025-02-04T14:38:41.225Z", "2025-02-04T14:38:48.697Z"]],
          duration_s: 7.5,
        },
        {
          id: 82335,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-52 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 11.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01296_699.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 14",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:38:52.531Z", "2025-02-04T14:39:04.392Z"]],
          duration_s: 11.9,
        },
        {
          id: 82336,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Arc to continue Sample Workflow 59.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 10.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01297_572.png"],
            },
          ],
          coverage: [["2025-02-04T14:39:05.351Z", "2025-02-04T14:39:20.028Z"]],
          duration_s: 14.7,
        },
        {
          id: 82339,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 66 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 7.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01298_936.png", "demo_alpha_frame_01299_305.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 36",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 53",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:39:34.499Z", "2025-02-04T14:39:47.413Z"]],
          duration_s: 12.9,
        },
        {
          id: 82340,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 73 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 132.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01300_787.png",
                "demo_alpha_frame_01301_908.png",
                "demo_alpha_frame_01302_498.png",
                "demo_alpha_frame_01303_636.png",
                "demo_alpha_frame_01304_359.png",
                "demo_alpha_frame_01305_242.png",
                "demo_alpha_frame_01306_636.png",
                "demo_alpha_frame_01307_936.png",
                "demo_alpha_frame_01308_348.png",
                "demo_alpha_frame_01309_337.png",
                "demo_alpha_frame_01310_848.png",
                "demo_alpha_frame_01311_366.png",
                "demo_alpha_frame_01312_858.png",
                "demo_alpha_frame_01313_775.png",
                "demo_alpha_frame_01314_868.png",
                "demo_alpha_frame_01315_341.png",
                "demo_alpha_frame_01316_566.png",
                "demo_alpha_frame_01317_497.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 47",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:39:52.193Z", "2025-02-04T14:42:04.963Z"]],
          duration_s: 132.8,
        },
        {
          id: 82341,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 80 and update its demo availability in Google Chrome.",
          attributes: [
            {
              name: "app.Google Chrome.duration_s",
              value: 102.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01318_214.png",
                "demo_alpha_frame_01319_739.png",
                "demo_alpha_frame_01320_446.png",
                "demo_alpha_frame_01321_969.png",
                "demo_alpha_frame_01322_806.png",
                "demo_alpha_frame_01323_436.png",
                "demo_alpha_frame_01324_085.png",
                "demo_alpha_frame_01325_373.png",
                "demo_alpha_frame_01326_618.png",
                "demo_alpha_frame_01327_174.png",
                "demo_alpha_frame_01328_699.png",
                "demo_alpha_frame_01329_952.png",
              ],
            },
          ],
          coverage: [["2025-02-04T14:42:07.597Z", "2025-02-04T14:43:49.714Z"]],
          duration_s: 102.1,
        },
        {
          id: 82342,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-87 and post a sample status update using Salesforce and Arc.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 4.0,
            },
            {
              name: "app.Arc.duration_s",
              value: 2.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01330_608.png"],
            },
          ],
          coverage: [["2025-02-04T14:43:52.102Z", "2025-02-04T14:44:01.223Z"]],
          duration_s: 9.1,
        },
        {
          id: 82343,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Arc to continue Sample Workflow 94.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 8.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01331_230.png", "demo_alpha_frame_01332_183.png"],
            },
          ],
          coverage: [["2025-02-04T14:44:03.964Z", "2025-02-04T14:44:12.612Z"]],
          duration_s: 8.6,
        },
        {
          id: 82344,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-12 and post a sample status update using Arc and LinkedIn.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 11.6,
            },
            {
              name: "app.LinkedIn.duration_s",
              value: 10.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01333_458.png",
                "demo_alpha_frame_01334_301.png",
                "demo_alpha_frame_01335_701.png",
              ],
            },
          ],
          coverage: [["2025-02-04T14:44:14.466Z", "2025-02-04T14:44:36.261Z"]],
          duration_s: 21.8,
        },
        {
          id: 82345,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Arc to continue Sample Workflow 19.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 13.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01336_675.png"],
            },
          ],
          coverage: [["2025-02-04T14:44:38.925Z", "2025-02-04T14:44:52.027Z"]],
          duration_s: 13.1,
        },
        {
          id: 82346,
          depth: 2,
          name: "react-message",
          goal: "Review the fictional conversation in #demo-ops-26 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 74.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01337_580.png",
                "demo_alpha_frame_01338_034.png",
                "demo_alpha_frame_01339_132.png",
                "demo_alpha_frame_01340_755.png",
                "demo_alpha_frame_01341_101.png",
                "demo_alpha_frame_01342_359.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 16",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 33",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:44:53.477Z", "2025-02-04T14:46:08.270Z"]],
          duration_s: 74.8,
        },
        {
          id: 82348,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Arc to continue Sample Workflow 33.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 106.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01343_061.png",
                "demo_alpha_frame_01344_619.png",
                "demo_alpha_frame_01345_655.png",
                "demo_alpha_frame_01346_681.png",
                "demo_alpha_frame_01347_974.png",
                "demo_alpha_frame_01348_424.png",
                "demo_alpha_frame_01349_248.png",
                "demo_alpha_frame_01350_492.png",
                "demo_alpha_frame_01351_911.png",
                "demo_alpha_frame_01352_901.png",
                "demo_alpha_frame_01353_997.png",
                "demo_alpha_frame_01354_497.png",
              ],
            },
          ],
          coverage: [["2025-02-04T14:46:15.748Z", "2025-02-04T14:48:04.926Z"]],
          duration_s: 109.2,
        },
        {
          id: 82349,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 40 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 20.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01355_211.png",
                "demo_alpha_frame_01356_211.png",
                "demo_alpha_frame_01357_260.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 38",
              qualifier: "searched",
            },
          ],
          coverage: [["2025-02-04T14:48:08.287Z", "2025-02-04T14:48:28.861Z"]],
          duration_s: 20.6,
        },
        {
          id: 82350,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Salesforce to continue Sample Workflow 47.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 5.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01358_495.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 49",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:48:29.304Z", "2025-02-04T14:48:34.293Z"]],
          duration_s: 5.0,
        },
        {
          id: 82351,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 54 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 11.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01359_575.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 60",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 77",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:48:36.992Z", "2025-02-04T14:48:53.043Z"]],
          duration_s: 16.1,
        },
        {
          id: 82352,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 61 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 18.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01360_639.png", "demo_alpha_frame_01361_341.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 71",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T14:48:53.953Z", "2025-02-04T14:49:12.626Z"]],
          duration_s: 18.7,
        },
        {
          id: 82353,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 68 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 20.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01362_822.png",
                "demo_alpha_frame_01363_145.png",
                "demo_alpha_frame_01364_553.png",
                "demo_alpha_frame_01365_054.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 82",
              qualifier: "searched",
            },
            {
              object: "Sample Reference 02",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:49:15.407Z", "2025-02-04T14:49:37.018Z"]],
          duration_s: 21.6,
        },
        {
          id: 82354,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 75 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 34.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01366_364.png",
                "demo_alpha_frame_01367_459.png",
                "demo_alpha_frame_01368_939.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Session 93",
              qualifier: "called",
            },
            {
              object: "Sample Reference 13",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:49:39.353Z", "2025-02-04T14:50:19.121Z"]],
          duration_s: 39.8,
        },
        {
          id: 82355,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-82 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 85.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01369_802.png",
                "demo_alpha_frame_01370_165.png",
                "demo_alpha_frame_01371_912.png",
                "demo_alpha_frame_01372_268.png",
                "demo_alpha_frame_01373_305.png",
                "demo_alpha_frame_01374_594.png",
                "demo_alpha_frame_01375_747.png",
              ],
            },
          ],
          coverage: [["2025-02-04T14:50:23.340Z", "2025-02-04T14:51:58.062Z"]],
          duration_s: 94.7,
        },
        {
          id: 82357,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 89 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 25.7,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01376_228.png",
                "demo_alpha_frame_01377_030.png",
                "demo_alpha_frame_01378_106.png",
                "demo_alpha_frame_01379_788.png",
                "demo_alpha_frame_01380_693.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 18",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T14:52:06.617Z", "2025-02-04T14:52:32.357Z"]],
          duration_s: 25.7,
        },
        {
          id: 82359,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 96 and update its sample fields in Salesforce and Arc.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 3.4,
            },
            {
              name: "app.Arc.duration_s",
              value: 1.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01381_625.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 29",
              qualifier: "searched",
            },
          ],
          coverage: [["2025-02-04T14:52:44.870Z", "2025-02-04T14:52:49.223Z"]],
          duration_s: 4.4,
        },
        {
          id: 82360,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Salesforce to continue Sample Workflow 14.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 4.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01382_021.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 40",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:52:49.984Z", "2025-02-04T14:52:54.065Z"]],
          duration_s: 4.1,
        },
        {
          id: 82361,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 21 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 6.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01383_176.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 51",
              qualifier: "searched",
            },
            {
              object: "Sample Reference 68",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:52:55.913Z", "2025-02-04T14:53:02.348Z"]],
          duration_s: 6.4,
        },
        {
          id: 82362,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Arc to continue Sample Workflow 28.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01384_696.png"],
            },
          ],
          coverage: [["2025-02-04T14:53:03.832Z", "2025-02-04T14:53:08.478Z"]],
          duration_s: 4.6,
        },
        {
          id: 82363,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 35 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01385_098.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 73",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 90",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:53:10.997Z", "2025-02-04T14:53:16.155Z"]],
          duration_s: 5.2,
        },
        {
          id: 82364,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 42 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 7.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01386_196.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 84",
              qualifier: "searched",
            },
          ],
          coverage: [["2025-02-04T14:53:19.253Z", "2025-02-04T14:53:26.578Z"]],
          duration_s: 7.3,
        },
        {
          id: 82366,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 49 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 19.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01387_076.png", "demo_alpha_frame_01388_161.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 95",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 15",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:53:39.518Z", "2025-02-04T14:53:58.489Z"]],
          duration_s: 19.0,
        },
        {
          id: 82368,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Arc and Salesforce to continue Sample Workflow 56.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.5,
            },
            {
              name: "app.Salesforce.duration_s",
              value: 2.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01389_911.png"],
            },
          ],
          coverage: [["2025-02-04T14:54:05.887Z", "2025-02-04T14:54:14.155Z"]],
          duration_s: 8.3,
        },
        {
          id: 82369,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Slack to continue Sample Workflow 63.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 12.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01390_954.png",
                "demo_alpha_frame_01391_960.png",
                "demo_alpha_frame_01392_599.png",
              ],
            },
          ],
          coverage: [["2025-02-04T14:54:16.356Z", "2025-02-04T14:54:28.675Z"]],
          duration_s: 12.3,
        },
        {
          id: 82370,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Slack and lemlist to continue Sample Workflow 70.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 8.7,
            },
            {
              name: "app.lemlist.duration_s",
              value: 8.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01393_685.png", "demo_alpha_frame_01394_842.png"],
            },
          ],
          coverage: [["2025-02-04T14:54:32.381Z", "2025-02-04T14:54:49.734Z"]],
          duration_s: 17.4,
        },
        {
          id: 82371,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-77 and post a sample status update using lemlist.",
          attributes: [
            {
              name: "app.lemlist.duration_s",
              value: 15.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01395_344.png", "demo_alpha_frame_01396_421.png"],
            },
          ],
          coverage: [["2025-02-04T14:54:51.545Z", "2025-02-04T14:55:07.464Z"]],
          duration_s: 15.9,
        },
        {
          id: 82372,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-84 and post a sample status update using LinkedIn and lemlist.",
          attributes: [
            {
              name: "app.LinkedIn.duration_s",
              value: 5.8,
            },
            {
              name: "app.lemlist.duration_s",
              value: 1.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01397_106.png"],
            },
          ],
          coverage: [["2025-02-04T14:55:10.363Z", "2025-02-04T14:55:17.519Z"]],
          duration_s: 7.2,
        },
        {
          id: 82374,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 91 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 10.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01398_560.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 64",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:55:32.907Z", "2025-02-04T14:55:43.358Z"]],
          duration_s: 10.5,
        },
        {
          id: 82378,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 98 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 28.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01399_957.png",
                "demo_alpha_frame_01400_372.png",
                "demo_alpha_frame_01401_274.png",
                "demo_alpha_frame_01402_715.png",
                "demo_alpha_frame_01403_817.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 75",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:56:07.710Z", "2025-02-04T14:56:36.060Z"]],
          duration_s: 28.4,
        },
        {
          id: 82380,
          depth: 2,
          name: "review-recording",
          goal: "Review Sample Session 16 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01404_613.png"],
            },
          ],
          coverage: [["2025-02-04T14:56:46.657Z", "2025-02-04T14:56:51.992Z"]],
          duration_s: 5.3,
        },
        {
          id: 82381,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 23 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 22.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01405_826.png", "demo_alpha_frame_01406_820.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 97",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:56:55.174Z", "2025-02-04T14:57:17.231Z"]],
          duration_s: 22.1,
        },
        {
          id: 82382,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 30 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01407_607.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 11",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:57:20.916Z", "2025-02-04T14:57:30.556Z"]],
          duration_s: 9.6,
        },
        {
          id: 82383,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 37 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01408_973.png", "demo_alpha_frame_01409_112.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 22",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T14:57:34.011Z", "2025-02-04T14:57:43.056Z"]],
          duration_s: 9.0,
        },
        {
          id: 82384,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 44 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 10.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01410_715.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 33",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 50",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:57:47.458Z", "2025-02-04T14:57:57.835Z"]],
          duration_s: 10.4,
        },
        {
          id: 82385,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 51 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 21.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01411_721.png",
                "demo_alpha_frame_01412_413.png",
                "demo_alpha_frame_01413_072.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 44",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 61",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:58:00.735Z", "2025-02-04T14:58:21.943Z"]],
          duration_s: 21.2,
        },
        {
          id: 82386,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 58 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 18.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01414_095.png", "demo_alpha_frame_01415_767.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 55",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 72",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:58:24.933Z", "2025-02-04T14:58:42.941Z"]],
          duration_s: 18.0,
        },
        {
          id: 82387,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 65 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 18.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01416_356.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 66",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T14:58:44.262Z", "2025-02-04T14:59:02.983Z"]],
          duration_s: 18.7,
        },
        {
          id: 82388,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 72 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 14.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01417_697.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 77",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 94",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:59:03.421Z", "2025-02-04T14:59:17.859Z"]],
          duration_s: 14.4,
        },
        {
          id: 82391,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Arc to continue Sample Workflow 79.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 7.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01418_996.png", "demo_alpha_frame_01419_101.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 88",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:59:37.630Z", "2025-02-04T14:59:45.014Z"]],
          duration_s: 7.4,
        },
        {
          id: 82393,
          depth: 2,
          name: "research-company",
          goal: "Complete a fictional research-company task for Demo Account 86 using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 31.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01420_275.png",
                "demo_alpha_frame_01421_895.png",
                "demo_alpha_frame_01422_624.png",
                "demo_alpha_frame_01423_690.png",
                "demo_alpha_frame_01424_979.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Account 02",
              qualifier: "researched",
            },
          ],
          coverage: [["2025-02-04T14:59:51.322Z", "2025-02-04T15:00:22.388Z"]],
          duration_s: 31.1,
        },
        {
          id: 82394,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 93 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 14.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01425_399.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 13",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:00:25.970Z", "2025-02-04T15:00:40.625Z"]],
          duration_s: 14.7,
        },
        {
          id: 82395,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 11 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01426_732.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 24",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 41",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:00:41.536Z", "2025-02-04T15:00:46.988Z"]],
          duration_s: 5.5,
        },
        {
          id: 82396,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 18 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 8.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01427_143.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 35",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T15:00:52.077Z", "2025-02-04T15:01:00.446Z"]],
          duration_s: 8.4,
        },
        {
          id: 82397,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 25 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 20.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01428_414.png", "demo_alpha_frame_01429_869.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 46",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T15:01:05.496Z", "2025-02-04T15:01:25.586Z"]],
          duration_s: 20.1,
        },
        {
          id: 82398,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 32 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 6.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01430_462.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 57",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T15:01:28.455Z", "2025-02-04T15:01:34.764Z"]],
          duration_s: 6.3,
        },
        {
          id: 82399,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 39 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 134.9,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01431_021.png",
                "demo_alpha_frame_01432_435.png",
                "demo_alpha_frame_01433_650.png",
                "demo_alpha_frame_01434_067.png",
                "demo_alpha_frame_01435_169.png",
                "demo_alpha_frame_01436_172.png",
                "demo_alpha_frame_01437_562.png",
                "demo_alpha_frame_01438_091.png",
                "demo_alpha_frame_01439_546.png",
                "demo_alpha_frame_01440_116.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Session 68",
              qualifier: "called",
            },
          ],
          coverage: [["2025-02-04T15:01:38.936Z", "2025-02-04T15:03:53.881Z"]],
          duration_s: 134.9,
        },
        {
          id: 82401,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 46 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 19.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01441_614.png",
                "demo_alpha_frame_01442_814.png",
                "demo_alpha_frame_01443_371.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Demo Item 79",
              qualifier: "created",
            },
          ],
          coverage: [["2025-02-04T15:04:03.969Z", "2025-02-04T15:04:26.901Z"]],
          duration_s: 22.9,
        },
        {
          id: 82402,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 53 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 123.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01444_763.png",
                "demo_alpha_frame_01445_391.png",
                "demo_alpha_frame_01446_900.png",
                "demo_alpha_frame_01447_599.png",
                "demo_alpha_frame_01448_942.png",
                "demo_alpha_frame_01449_508.png",
                "demo_alpha_frame_01450_775.png",
                "demo_alpha_frame_01451_847.png",
                "demo_alpha_frame_01452_199.png",
                "demo_alpha_frame_01453_264.png",
                "demo_alpha_frame_01454_069.png",
                "demo_alpha_frame_01455_868.png",
                "demo_alpha_frame_01456_042.png",
                "demo_alpha_frame_01457_749.png",
                "demo_alpha_frame_01458_081.png",
                "demo_alpha_frame_01459_861.png",
                "demo_alpha_frame_01460_966.png",
                "demo_alpha_frame_01461_331.png",
                "demo_alpha_frame_01462_117.png",
                "demo_alpha_frame_01463_045.png",
                "demo_alpha_frame_01464_102.png",
                "demo_alpha_frame_01465_816.png",
                "demo_alpha_frame_01466_074.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 90",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:04:31.801Z", "2025-02-04T15:06:38.786Z"]],
          duration_s: 127.0,
        },
        {
          id: 82403,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 60 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 8.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01467_865.png", "demo_alpha_frame_01468_953.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 04",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 21",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:06:39.783Z", "2025-02-04T15:06:48.600Z"]],
          duration_s: 8.8,
        },
        {
          id: 82404,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 67 and update its demo availability in Arc and Salesforce.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 9.3,
            },
            {
              name: "app.Salesforce.duration_s",
              value: 5.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01469_197.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 15",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:06:50.580Z", "2025-02-04T15:07:07.951Z"]],
          duration_s: 17.4,
        },
        {
          id: 82405,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 74 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 21.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01470_278.png", "demo_alpha_frame_01471_600.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 26",
              qualifier: "finalized",
            },
          ],
          coverage: [["2025-02-04T15:07:13.491Z", "2025-02-04T15:07:34.764Z"]],
          duration_s: 21.3,
        },
        {
          id: 82406,
          depth: 2,
          name: "lookup-reference",
          goal: "Review and update Sample Enablement Guide 81 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 13.8,
            },
          ],
          coverage: [["2025-02-04T15:07:40.071Z", "2025-02-04T15:07:53.848Z"]],
          duration_s: 13.8,
        },
        {
          id: 82407,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 88 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 158.3,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01472_984.png",
                "demo_alpha_frame_01473_212.png",
                "demo_alpha_frame_01474_957.png",
                "demo_alpha_frame_01475_174.png",
                "demo_alpha_frame_01476_655.png",
                "demo_alpha_frame_01477_398.png",
                "demo_alpha_frame_01478_369.png",
                "demo_alpha_frame_01479_396.png",
                "demo_alpha_frame_01480_255.png",
                "demo_alpha_frame_01481_141.png",
                "demo_alpha_frame_01482_364.png",
                "demo_alpha_frame_01483_114.png",
                "demo_alpha_frame_01484_876.png",
                "demo_alpha_frame_01485_582.png",
                "demo_alpha_frame_01486_798.png",
                "demo_alpha_frame_01487_475.png",
                "demo_alpha_frame_01488_140.png",
                "demo_alpha_frame_01489_754.png",
                "demo_alpha_frame_01490_813.png",
                "demo_alpha_frame_01491_599.png",
                "demo_alpha_frame_01492_599.png",
                "demo_alpha_frame_01493_421.png",
                "demo_alpha_frame_01494_661.png",
                "demo_alpha_frame_01495_816.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 48",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 65",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:07:55.366Z", "2025-02-04T15:10:33.622Z"]],
          duration_s: 158.3,
        },
        {
          id: 82408,
          depth: 2,
          name: "log-call-outcome",
          goal: "Review Sample Session 95 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 6.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01496_250.png"],
            },
          ],
          coverage: [["2025-02-04T15:10:36.919Z", "2025-02-04T15:10:43.123Z"]],
          duration_s: 6.2,
        },
        {
          id: 82409,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 13 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 14.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01497_530.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 70",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 87",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:10:48.029Z", "2025-02-04T15:11:06.221Z"]],
          duration_s: 18.2,
        },
        {
          id: 82410,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 20 and update its sample fields in Arc and Salesforce.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.4,
            },
            {
              name: "app.Salesforce.duration_s",
              value: 1.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01498_381.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 81",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 01",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:11:08.271Z", "2025-02-04T15:11:13.582Z"]],
          duration_s: 5.3,
        },
        {
          id: 82411,
          depth: 2,
          name: "log-call-outcome",
          goal: "Review Sample Session 27 and record a fictional outcome in Arc and Salesforce.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.7,
            },
            {
              name: "app.Salesforce.duration_s",
              value: 2.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01499_482.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 92",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:11:15.583Z", "2025-02-04T15:11:22.076Z"]],
          duration_s: 6.5,
        },
        {
          id: 82412,
          depth: 2,
          name: "create-record",
          goal: "Open the fictional record for Demo Account 34 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 45.8,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01500_941.png",
                "demo_alpha_frame_01501_163.png",
                "demo_alpha_frame_01502_199.png",
                "demo_alpha_frame_01503_251.png",
                "demo_alpha_frame_01504_066.png",
                "demo_alpha_frame_01505_735.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 06",
              qualifier: "referenced",
            },
            {
              object: "Demo Item 23",
              qualifier: "created",
            },
            {
              object: "Demo Item 40",
              qualifier: "created",
            },
          ],
          coverage: [["2025-02-04T15:11:27.372Z", "2025-02-04T15:12:13.164Z"]],
          duration_s: 45.8,
        },
        {
          id: 82413,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 41 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 27.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01506_166.png",
                "demo_alpha_frame_01507_131.png",
                "demo_alpha_frame_01508_190.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 17",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:12:15.624Z", "2025-02-04T15:12:43.088Z"]],
          duration_s: 27.5,
        },
        {
          id: 82414,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 48 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01509_922.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 28",
              qualifier: "reviewed",
            },
            {
              object: "Sample Reference 45",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:12:45.150Z", "2025-02-04T15:12:52.402Z"]],
          duration_s: 7.3,
        },
        {
          id: 82415,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 55 and update its sample fields in Arc and Salesforce.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 10.7,
            },
            {
              name: "app.Salesforce.duration_s",
              value: 7.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01510_721.png", "demo_alpha_frame_01511_480.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 39",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T15:24:35.013Z", "2025-02-04T15:24:53.581Z"]],
          duration_s: 18.6,
        },
        {
          id: 82416,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-62 and post a sample status update using Gmail.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 63.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01512_404.png",
                "demo_alpha_frame_01513_878.png",
                "demo_alpha_frame_01514_378.png",
                "demo_alpha_frame_01515_809.png",
                "demo_alpha_frame_01516_304.png",
                "demo_alpha_frame_01517_515.png",
                "demo_alpha_frame_01518_305.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 50",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 67",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:24:58.859Z", "2025-02-04T15:26:02.092Z"]],
          duration_s: 63.2,
        },
        {
          id: 82417,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 69 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 24.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01519_474.png",
                "demo_alpha_frame_01520_936.png",
                "demo_alpha_frame_01521_690.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 61",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T15:26:04.470Z", "2025-02-04T15:26:28.661Z"]],
          duration_s: 24.2,
        },
        {
          id: 82418,
          depth: 2,
          name: "update-record",
          goal: "Open the fictional record for Demo Account 76 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 53.2,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01522_691.png",
                "demo_alpha_frame_01523_552.png",
                "demo_alpha_frame_01524_604.png",
                "demo_alpha_frame_01525_122.png",
                "demo_alpha_frame_01526_712.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 72",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T15:26:33.087Z", "2025-02-04T15:27:26.318Z"]],
          duration_s: 53.2,
        },
        {
          id: 82419,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 83 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 7.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01527_372.png"],
            },
          ],
          coverage: [["2025-02-04T15:27:27.180Z", "2025-02-04T15:27:34.522Z"]],
          duration_s: 7.3,
        },
        {
          id: 82420,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-90 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 40.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01528_404.png",
                "demo_alpha_frame_01529_474.png",
                "demo_alpha_frame_01530_421.png",
                "demo_alpha_frame_01531_236.png",
                "demo_alpha_frame_01532_036.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 94",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:27:37.656Z", "2025-02-04T15:28:18.262Z"]],
          duration_s: 40.6,
        },
        {
          id: 82421,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 97 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 31.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01533_755.png", "demo_alpha_frame_01534_192.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 08",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 25",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 42",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T15:28:19.795Z", "2025-02-04T15:28:53.999Z"]],
          duration_s: 34.2,
        },
        {
          id: 82422,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 15 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 24.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01535_251.png", "demo_alpha_frame_01536_523.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 19",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:28:58.565Z", "2025-02-04T15:29:22.957Z"]],
          duration_s: 24.4,
        },
        {
          id: 82423,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 22 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 21.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01537_444.png", "demo_alpha_frame_01538_283.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 30",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T15:29:24.514Z", "2025-02-04T15:29:45.826Z"]],
          duration_s: 21.3,
        },
        {
          id: 82424,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 29 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 16.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01539_713.png", "demo_alpha_frame_01540_672.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 41",
              qualifier: "reviewed",
            },
            {
              object: "Demo Item 58",
              qualifier: "reviewed",
            },
          ],
          coverage: [["2025-02-04T15:29:47.407Z", "2025-02-04T15:30:03.408Z"]],
          duration_s: 16.0,
        },
        {
          id: 82425,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-36 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 31.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01541_684.png",
                "demo_alpha_frame_01542_456.png",
                "demo_alpha_frame_01543_169.png",
              ],
            },
          ],
          coverage: [["2025-02-04T15:30:05.893Z", "2025-02-04T15:30:37.327Z"]],
          duration_s: 31.4,
        },
        {
          id: 82426,
          depth: 2,
          name: "react-message",
          goal: "Review the fictional conversation in #demo-ops-43 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 19.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01544_359.png"],
            },
          ],
          coverage: [["2025-02-04T15:30:40.212Z", "2025-02-04T15:31:01.555Z"]],
          duration_s: 21.3,
        },
        {
          id: 82427,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-50 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 30.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01545_951.png", "demo_alpha_frame_01546_804.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 74",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:31:03.682Z", "2025-02-04T15:31:33.924Z"]],
          duration_s: 30.2,
        },
        {
          id: 82428,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-57 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 48.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01547_790.png",
                "demo_alpha_frame_01548_821.png",
                "demo_alpha_frame_01549_319.png",
              ],
            },
          ],
          coverage: [["2025-02-04T15:31:34.291Z", "2025-02-04T15:32:22.392Z"]],
          duration_s: 48.1,
        },
        {
          id: 82429,
          depth: 2,
          name: "research-reference",
          goal: "Review and update Sample Enablement Guide 64 with fictional onboarding details in lemlist.",
          attributes: [
            {
              name: "app.lemlist.duration_s",
              value: 30.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01550_329.png", "demo_alpha_frame_01551_235.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 96",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:32:24.988Z", "2025-02-04T15:32:57.679Z"]],
          duration_s: 32.7,
        },
        {
          id: 82430,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 71 with fictional onboarding details in Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 24.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01552_117.png", "demo_alpha_frame_01553_769.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 10",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:32:58.602Z", "2025-02-04T15:33:23.312Z"]],
          duration_s: 24.7,
        },
        {
          id: 82431,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 78 with fictional onboarding details in Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 60.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01554_345.png",
                "demo_alpha_frame_01555_928.png",
                "demo_alpha_frame_01556_217.png",
                "demo_alpha_frame_01557_986.png",
                "demo_alpha_frame_01558_881.png",
                "demo_alpha_frame_01559_410.png",
                "demo_alpha_frame_01560_101.png",
                "demo_alpha_frame_01561_344.png",
                "demo_alpha_frame_01562_926.png",
              ],
            },
          ],
          coverage: [["2025-02-04T15:33:25.590Z", "2025-02-04T15:34:26.199Z"]],
          duration_s: 60.6,
        },
        {
          id: 82432,
          depth: 2,
          name: "research-reference",
          goal: "Review and update Sample Enablement Guide 85 with fictional onboarding details in lemlist.",
          attributes: [
            {
              name: "app.lemlist.duration_s",
              value: 10.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01563_195.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 32",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:34:28.352Z", "2025-02-04T15:34:39.277Z"]],
          duration_s: 10.9,
        },
        {
          id: 82433,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 92 with fictional onboarding details in Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 286.6,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01564_542.png",
                "demo_alpha_frame_01565_047.png",
                "demo_alpha_frame_01566_463.png",
                "demo_alpha_frame_01567_532.png",
                "demo_alpha_frame_01568_748.png",
                "demo_alpha_frame_01569_051.png",
                "demo_alpha_frame_01570_521.png",
                "demo_alpha_frame_01571_678.png",
                "demo_alpha_frame_01572_791.png",
                "demo_alpha_frame_01573_502.png",
                "demo_alpha_frame_01574_979.png",
                "demo_alpha_frame_01575_966.png",
                "demo_alpha_frame_01576_554.png",
                "demo_alpha_frame_01577_990.png",
                "demo_alpha_frame_01578_161.png",
                "demo_alpha_frame_01579_489.png",
                "demo_alpha_frame_01580_443.png",
                "demo_alpha_frame_01581_277.png",
                "demo_alpha_frame_01582_373.png",
                "demo_alpha_frame_01583_673.png",
                "demo_alpha_frame_01584_751.png",
                "demo_alpha_frame_01585_577.png",
                "demo_alpha_frame_01586_937.png",
                "demo_alpha_frame_01587_898.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 43",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:34:43.649Z", "2025-02-04T15:39:30.273Z"]],
          duration_s: 286.6,
        },
        {
          id: 82434,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 10 with fictional onboarding details in Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 101.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01588_654.png",
                "demo_alpha_frame_01589_505.png",
                "demo_alpha_frame_01590_943.png",
                "demo_alpha_frame_01591_990.png",
                "demo_alpha_frame_01592_223.png",
                "demo_alpha_frame_01593_999.png",
                "demo_alpha_frame_01594_404.png",
                "demo_alpha_frame_01595_490.png",
                "demo_alpha_frame_01596_085.png",
                "demo_alpha_frame_01597_796.png",
                "demo_alpha_frame_01598_583.png",
              ],
            },
          ],
          coverage: [["2025-02-04T15:39:32.342Z", "2025-02-04T15:41:13.451Z"]],
          duration_s: 101.1,
        },
        {
          id: 82435,
          depth: 2,
          name: "author-content",
          goal: "Review and update Sample Enablement Guide 17 with fictional onboarding details in Claude.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 68.4,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01599_665.png",
                "demo_alpha_frame_01600_888.png",
                "demo_alpha_frame_01601_014.png",
                "demo_alpha_frame_01602_140.png",
                "demo_alpha_frame_01603_944.png",
                "demo_alpha_frame_01604_603.png",
                "demo_alpha_frame_01605_399.png",
                "demo_alpha_frame_01606_383.png",
                "demo_alpha_frame_01607_631.png",
                "demo_alpha_frame_01608_485.png",
              ],
            },
          ],
          coverage: [["2025-02-04T15:41:15.323Z", "2025-02-04T15:42:23.726Z"]],
          duration_s: 68.4,
        },
        {
          id: 82436,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-24 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 62.1,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01609_407.png",
                "demo_alpha_frame_01610_464.png",
                "demo_alpha_frame_01611_627.png",
                "demo_alpha_frame_01612_769.png",
                "demo_alpha_frame_01613_830.png",
                "demo_alpha_frame_01614_871.png",
                "demo_alpha_frame_01615_799.png",
                "demo_alpha_frame_01616_379.png",
                "demo_alpha_frame_01617_360.png",
              ],
            },
          ],
          coverage: [["2025-02-04T15:42:26.659Z", "2025-02-04T15:43:28.709Z"]],
          duration_s: 62.1,
        },
        {
          id: 82437,
          depth: 2,
          name: "react-message",
          goal: "Review the fictional conversation in #demo-ops-31 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 27.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01618_791.png", "demo_alpha_frame_01619_165.png"],
            },
          ],
          coverage: [["2025-02-04T15:43:29.349Z", "2025-02-04T15:43:56.518Z"]],
          duration_s: 27.2,
        },
        {
          id: 82438,
          depth: 2,
          name: "reply-thread",
          goal: "Review the fictional conversation in #demo-ops-38 and post a sample status update using lemlist.",
          attributes: [
            {
              name: "app.lemlist.duration_s",
              value: 17.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01620_067.png", "demo_alpha_frame_01621_717.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 01",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T15:44:01.215Z", "2025-02-04T15:44:23.120Z"]],
          duration_s: 21.9,
        },
        {
          id: 82439,
          depth: 2,
          name: "research-reference",
          goal: "Review and update Sample Enablement Guide 45 with fictional onboarding details in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 13.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01622_943.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 12",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:44:27.019Z", "2025-02-04T15:44:42.553Z"]],
          duration_s: 15.5,
        },
        {
          id: 82440,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-52 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 42.0,
            },
            {
              name: "screenshots",
              value: [
                "demo_alpha_frame_01623_004.png",
                "demo_alpha_frame_01624_033.png",
                "demo_alpha_frame_01625_885.png",
              ],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 23",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T15:44:46.705Z", "2025-02-04T15:45:28.672Z"]],
          duration_s: 42.0,
        },
        {
          id: 87001,
          depth: 3,
          name: "Send Follow-up Email",
          goal: "Draft and send a sample follow-up to Demo Contact 59 using the workspace.",
          duration_s: 49.9,
          children: [82001, 82002],
        },
        {
          id: 87002,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 66 and update its demo availability in Arc.",
          duration_s: 30.0,
          children: [82003],
        },
        {
          id: 87003,
          depth: 3,
          name: "Message Teammate",
          goal: "Review the fictional conversation in #demo-ops-73 and post a sample status update using the workspace.",
          duration_s: 15.2,
          children: [82004],
        },
        {
          id: 87004,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Salesforce)",
          goal: "Review the sample outreach workflow for Demo Account 80 and update its demo status in Salesforce.",
          duration_s: 312.0,
          children: [82005],
        },
        {
          id: 87005,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 87.",
          duration_s: 20.6,
          children: [82006],
        },
        {
          id: 87006,
          depth: 3,
          name: "Create CRM Lead/Contact Record (Arc)",
          goal: "Open the fictional record for Demo Account 94 and update its sample fields in Arc.",
          duration_s: 56.7,
          children: [82007],
        },
        {
          id: 87007,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 12 and update its demo status in Arc.",
          duration_s: 28.3,
          children: [82008, 82009],
        },
        {
          id: 87009,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 19.",
          duration_s: 30.2,
          children: [82011],
        },
        {
          id: 87011,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 26.",
          duration_s: 119.2,
          children: [82013],
        },
        {
          id: 87012,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 33.",
          duration_s: 77.1,
          children: [82014],
        },
        {
          id: 87013,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Claude)",
          goal: "Review and update Sample Enablement Guide 40 with fictional onboarding details in Claude.",
          duration_s: 51.5,
          children: [82015],
        },
        {
          id: 87015,
          depth: 3,
          name: "Configure Onboarding Tools and Resources (Claude)",
          goal: "Review and update Sample Enablement Guide 47 with fictional onboarding details in Claude.",
          duration_s: 12.1,
          children: [82017],
        },
        {
          id: 87016,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-54 and post a sample status update using Slack.",
          duration_s: 53.4,
          children: [82018],
        },
        {
          id: 87017,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 61.",
          duration_s: 14.0,
          children: [82019],
        },
        {
          id: 87019,
          depth: 3,
          name: "Attend Internal Meeting (Vimeo)",
          goal: "Review a sample calendar entry for Demo Account 68 and update its demo availability in Vimeo.",
          duration_s: 789.8,
          children: [82021],
        },
        {
          id: 87020,
          depth: 3,
          name: "Message Teammate (Claude)",
          goal: "Review the fictional conversation in #demo-ops-75 and post a sample status update using Claude.",
          duration_s: 21.3,
          children: [82022],
        },
        {
          id: 87021,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 82.",
          duration_s: 39.2,
          children: [82023],
        },
        {
          id: 87022,
          depth: 3,
          name: "Lookup Reference (Claude)",
          goal: "Review and update Sample Enablement Guide 89 with fictional onboarding details in Claude.",
          duration_s: 9.1,
          children: [82024],
        },
        {
          id: 87023,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Claude)",
          goal: "Review and update Sample Enablement Guide 96 with fictional onboarding details in Claude.",
          duration_s: 44.1,
          children: [82025],
        },
        {
          id: 87024,
          depth: 3,
          name: "Configure Onboarding Tools and Resources (Claude)",
          goal: "Review and update Sample Enablement Guide 14 with fictional onboarding details in Claude.",
          duration_s: 6.1,
          children: [82026],
        },
        {
          id: 87025,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 21.",
          duration_s: 32.6,
          children: [82027, 82028, 82029, 82030, 82031],
        },
        {
          id: 87026,
          depth: 3,
          name: "Research Target Account (Arc)",
          goal: "Research Demo Account 28 and summarize its fictional business profile in Arc.",
          duration_s: 38.0,
          children: [82032],
        },
        {
          id: 87027,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 35.",
          duration_s: 154.5,
          children: [82033, 82034, 82035, 82036, 82037],
        },
        {
          id: 87028,
          depth: 3,
          name: "Review Recording (Vimeo)",
          goal: "Review Sample Session 42 and record a fictional outcome in Vimeo.",
          duration_s: 887.4,
          children: [82038],
        },
        {
          id: 87029,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-49 and post a sample status update using Slack.",
          duration_s: 337.5,
          children: [82039],
        },
        {
          id: 87030,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Claude)",
          goal: "Review and update Sample Enablement Guide 56 with fictional onboarding details in Claude.",
          duration_s: 24.5,
          children: [82040],
        },
        {
          id: 87031,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 63.",
          duration_s: 170.3,
          children: [82041],
        },
        {
          id: 87032,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 70.",
          duration_s: 5.3,
          children: [82042],
        },
        {
          id: 87033,
          depth: 3,
          name: "Research Target Account (Claude)",
          goal: "Research Demo Account 77 and summarize its fictional business profile in Claude.",
          duration_s: 137.0,
          children: [82043],
        },
        {
          id: 87034,
          depth: 3,
          name: "Review Recording (Arc)",
          goal: "Review Sample Session 84 and record a fictional outcome in Arc.",
          duration_s: 48.8,
          children: [82044],
        },
        {
          id: 87036,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 91.",
          duration_s: 7.0,
          children: [82046],
        },
        {
          id: 87037,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-98 and post a sample status update using Slack.",
          duration_s: 25.9,
          children: [82047],
        },
        {
          id: 87039,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-16 and post a sample status update using Slack.",
          duration_s: 9.4,
          children: [82049],
        },
        {
          id: 87040,
          depth: 3,
          name: "Research Target Account (Claude)",
          goal: "Research Demo Account 23 and summarize its fictional business profile in Claude.",
          duration_s: 17.6,
          children: [82050],
        },
        {
          id: 87042,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-30 and post a sample status update using Slack.",
          duration_s: 16.0,
          children: [82052],
        },
        {
          id: 87045,
          depth: 3,
          name: "Research Target Account (Claude)",
          goal: "Research Demo Account 37 and summarize its fictional business profile in Claude.",
          duration_s: 42.0,
          children: [82056],
        },
        {
          id: 87046,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-44 and post a sample status update using Slack.",
          duration_s: 156.0,
          children: [82057],
        },
        {
          id: 87047,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-51 and post a sample status update using Slack.",
          duration_s: 18.4,
          children: [82058],
        },
        {
          id: 87048,
          depth: 3,
          name: "Research Target Account (Claude)",
          goal: "Research Demo Account 58 and summarize its fictional business profile in Claude.",
          duration_s: 10.0,
          children: [82060],
        },
        {
          id: 87051,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 65.",
          duration_s: 12.0,
          children: [82064],
        },
        {
          id: 87052,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 72 and update its demo availability in Arc.",
          duration_s: 34.6,
          children: [82065],
        },
        {
          id: 87053,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 79.",
          duration_s: 9.9,
          children: [82066],
        },
        {
          id: 87054,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-86 and post a sample status update using Slack.",
          duration_s: 13.9,
          children: [82067],
        },
        {
          id: 87055,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 93.",
          duration_s: 14.6,
          children: [82068],
        },
        {
          id: 87056,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 11.",
          duration_s: 27.1,
          children: [82071],
        },
        {
          id: 87057,
          depth: 3,
          name: "Message Teammate (HeyReach)",
          goal: "Review the fictional conversation in #demo-ops-18 and post a sample status update using HeyReach.",
          duration_s: 20.4,
          children: [82073],
        },
        {
          id: 87058,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 25.",
          duration_s: 404.7,
          children: [82074],
        },
        {
          id: 87059,
          depth: 3,
          name: "Message Teammate (HeyReach)",
          goal: "Review the fictional conversation in #demo-ops-32 and post a sample status update using HeyReach.",
          duration_s: 91.2,
          children: [82075],
        },
        {
          id: 87060,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 39.",
          duration_s: 11.5,
          children: [82076],
        },
        {
          id: 87061,
          depth: 3,
          name: "Message Teammate (HeyReach)",
          goal: "Review the fictional conversation in #demo-ops-46 and post a sample status update using HeyReach.",
          duration_s: 37.3,
          children: [82077],
        },
        {
          id: 87062,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 53.",
          duration_s: 13.2,
          children: [82078],
        },
        {
          id: 87063,
          depth: 3,
          name: "Check Messages (Gmail)",
          goal: "Review the fictional conversation in #demo-ops-60 and post a sample status update using Gmail.",
          duration_s: 15.7,
          children: [82079],
        },
        {
          id: 87064,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 67 and update its demo availability in Arc.",
          duration_s: 135.4,
          children: [82080],
        },
        {
          id: 87065,
          depth: 3,
          name: "Attend Internal Meeting (Granola)",
          goal: "Review a sample calendar entry for Demo Account 74 and update its demo availability in Granola.",
          duration_s: 14.7,
          children: [82081],
        },
        {
          id: 87066,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 81.",
          duration_s: 16.0,
          children: [82082],
        },
        {
          id: 87067,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-88 and post a sample status update using Slack.",
          duration_s: 75.5,
          children: [82083],
        },
        {
          id: 87070,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-95 and post a sample status update using Slack.",
          duration_s: 72.9,
          children: [82086],
        },
        {
          id: 87071,
          depth: 3,
          name: "Attend Internal Meeting (Granola)",
          goal: "Review a sample calendar entry for Demo Account 13 and update its demo availability in Granola.",
          duration_s: 52.8,
          children: [82087],
        },
        {
          id: 87072,
          depth: 3,
          name: "Check Messages (Slack)",
          goal: "Review the fictional conversation in #demo-ops-20 and post a sample status update using Slack.",
          duration_s: 20.6,
          children: [82088],
        },
        {
          id: 87073,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 27 and record a fictional outcome in Arc.",
          duration_s: 155.6,
          children: [82089],
        },
        {
          id: 87075,
          depth: 3,
          name: "Build Prospect List (lemlist)",
          goal: "Review the sample outreach workflow for Demo Account 34 and update its demo status in lemlist.",
          duration_s: 101.2,
          children: [82091],
        },
        {
          id: 87076,
          depth: 3,
          name: "Create Training Video (lemlist)",
          goal: "Review Sample Session 41 and record a fictional outcome in lemlist.",
          duration_s: 56.7,
          children: [82092],
        },
        {
          id: 87077,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 48 and update its demo status in Arc.",
          duration_s: 20.9,
          children: [82093],
        },
        {
          id: 87078,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Arc)",
          goal: "Review and update Sample Enablement Guide 55 with fictional onboarding details in Arc.",
          duration_s: 69.2,
          children: [82094],
        },
        {
          id: 87079,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 62 and update its demo status in Arc.",
          duration_s: 74.5,
          children: [82095],
        },
        {
          id: 87081,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 69 and record a fictional outcome in Arc.",
          duration_s: 51.7,
          children: [82097],
        },
        {
          id: 87082,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 76 and update its demo status in Arc.",
          duration_s: 143.0,
          children: [82099],
        },
        {
          id: 87083,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 83 and record a fictional outcome in Arc.",
          duration_s: 9.9,
          children: [82100],
        },
        {
          id: 87084,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 90 and record a fictional outcome in Arc.",
          duration_s: 88.5,
          children: [82102],
        },
        {
          id: 87086,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 97 and update its demo status in Arc.",
          duration_s: 15.3,
          children: [82105],
        },
        {
          id: 87087,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 15 and record a fictional outcome in Arc.",
          duration_s: 7.6,
          children: [82106],
        },
        {
          id: 87089,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 22.",
          duration_s: 5.4,
          children: [82108],
        },
        {
          id: 87090,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 29 and record a fictional outcome in Arc.",
          duration_s: 4.4,
          children: [82110],
        },
        {
          id: 87092,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 36 and update its demo status in Arc.",
          duration_s: 96.0,
          children: [82117],
        },
        {
          id: 87093,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 43 and record a fictional outcome in Arc.",
          duration_s: 9.3,
          children: [82119],
        },
        {
          id: 87094,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 50.",
          duration_s: 21.5,
          children: [82120],
        },
        {
          id: 87095,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 57 and record a fictional outcome in Arc.",
          duration_s: 8.5,
          children: [82121],
        },
        {
          id: 87096,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 64 and update its demo status in Arc.",
          duration_s: 4.6,
          children: [82122],
        },
        {
          id: 87097,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 71 and record a fictional outcome in Arc.",
          duration_s: 150.0,
          children: [82124],
        },
        {
          id: 87098,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 78 and update its demo status in Arc.",
          duration_s: 9.0,
          children: [82125],
        },
        {
          id: 87099,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 85 and update its demo status in Arc.",
          duration_s: 6.1,
          children: [82126],
        },
        {
          id: 87100,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 92 and record a fictional outcome in Arc.",
          duration_s: 49.6,
          children: [82127],
        },
        {
          id: 87101,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 10 and record a fictional outcome in Arc.",
          duration_s: 35.5,
          children: [82128],
        },
        {
          id: 87102,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 17 and update its demo status in Arc.",
          duration_s: 50.7,
          children: [82129],
        },
        {
          id: 87103,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 24 and update its demo status in Arc.",
          duration_s: 81.4,
          children: [82130],
        },
        {
          id: 87104,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 31 and update its sample fields in Arc.",
          duration_s: 28.9,
          children: [82131],
        },
        {
          id: 87105,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 38 and record a fictional outcome in Arc.",
          duration_s: 21.8,
          children: [82132],
        },
        {
          id: 87106,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 45 and update its demo status in Arc.",
          duration_s: 72.2,
          children: [82133],
        },
        {
          id: 87107,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 52 and update its demo status in Arc.",
          duration_s: 50.4,
          children: [82134],
        },
        {
          id: 87108,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 59 and record a fictional outcome in Arc.",
          duration_s: 51.3,
          children: [82135],
        },
        {
          id: 87109,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 66 and update its demo status in Arc.",
          duration_s: 38.5,
          children: [82136],
        },
        {
          id: 87110,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 73 and record a fictional outcome in Arc.",
          duration_s: 28.8,
          children: [82137],
        },
        {
          id: 87111,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 80 and update its demo status in Arc.",
          duration_s: 78.1,
          children: [82138],
        },
        {
          id: 87112,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 87 and update its demo status in Arc.",
          duration_s: 24.4,
          children: [82139],
        },
        {
          id: 87113,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 94 and update its demo status in Arc.",
          duration_s: 126.5,
          children: [82140],
        },
        {
          id: 87114,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 12 and update its sample fields in Arc.",
          duration_s: 24.4,
          children: [82141],
        },
        {
          id: 87115,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 19 and record a fictional outcome in Arc.",
          duration_s: 64.8,
          children: [82142],
        },
        {
          id: 87116,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 26 and record a fictional outcome in Arc.",
          duration_s: 8.7,
          children: [82143],
        },
        {
          id: 87117,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 33 and update its demo availability in Arc.",
          duration_s: 11.0,
          children: [82145],
        },
        {
          id: 87118,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 40 and update its demo availability in Arc.",
          duration_s: 15.8,
          children: [82147],
        },
        {
          id: 87119,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 47.",
          duration_s: 8.4,
          children: [82148],
        },
        {
          id: 87120,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 54 and update its demo status in Arc.",
          duration_s: 158.7,
          children: [82151],
        },
        {
          id: 87121,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 61 and update its demo status in Arc.",
          duration_s: 6.6,
          children: [82152],
        },
        {
          id: 87122,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 68.",
          duration_s: 5.9,
          children: [82155],
        },
        {
          id: 87123,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 75 and record a fictional outcome in Arc.",
          duration_s: 19.2,
          children: [82156],
        },
        {
          id: 87124,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 82 and record a fictional outcome in Arc.",
          duration_s: 11.5,
          children: [82158],
        },
        {
          id: 87125,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 89 and record a fictional outcome in Arc.",
          duration_s: 52.8,
          children: [82159],
        },
        {
          id: 87126,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 96 and record a fictional outcome in Arc.",
          duration_s: 26.1,
          children: [82160],
        },
        {
          id: 87127,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 14 and update its demo status in Arc.",
          duration_s: 39.4,
          children: [82162],
        },
        {
          id: 87128,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 21 and update its sample fields in Arc.",
          duration_s: 47.2,
          children: [82163],
        },
        {
          id: 87129,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 28 and update its demo status in Arc.",
          duration_s: 3.7,
          children: [82164],
        },
        {
          id: 87130,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 35 and update its demo status in Arc.",
          duration_s: 20.9,
          children: [82165],
        },
        {
          id: 87131,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 42 and record a fictional outcome in Arc.",
          duration_s: 46.8,
          children: [82166],
        },
        {
          id: 87133,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 49 and update its demo status in Arc.",
          duration_s: 95.7,
          children: [82168],
        },
        {
          id: 87134,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 56 and update its demo status in Arc.",
          duration_s: 9.7,
          children: [82169],
        },
        {
          id: 87135,
          depth: 3,
          name: "Send Follow-up Email (Arc)",
          goal: "Draft and send a sample follow-up to Demo Contact 63 using Arc.",
          duration_s: 43.6,
          children: [82171],
        },
        {
          id: 87136,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 70 and update its demo status in Arc.",
          duration_s: 10.4,
          children: [82172],
        },
        {
          id: 87137,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 77 and record a fictional outcome in Arc.",
          duration_s: 17.0,
          children: [82173],
        },
        {
          id: 87138,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 84 and update its demo status in Arc.",
          duration_s: 52.3,
          children: [82174],
        },
        {
          id: 87139,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 91 and record a fictional outcome in Arc.",
          duration_s: 28.5,
          children: [82175],
        },
        {
          id: 87140,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 98 and update its demo status in Arc.",
          duration_s: 59.0,
          children: [82176],
        },
        {
          id: 87141,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 16 and update its demo status in Arc.",
          duration_s: 40.8,
          children: [82177],
        },
        {
          id: 87142,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 23 and record a fictional outcome in Arc.",
          duration_s: 104.5,
          children: [82178],
        },
        {
          id: 87143,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 30 and update its demo status in Arc.",
          duration_s: 139.2,
          children: [82179],
        },
        {
          id: 87144,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 37 and update its demo status in Arc.",
          duration_s: 96.6,
          children: [82180],
        },
        {
          id: 87147,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 44 and record a fictional outcome in Arc.",
          duration_s: 12.6,
          children: [82184],
        },
        {
          id: 87148,
          depth: 3,
          name: "Build Prospect List (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 51 and update its demo status in Arc.",
          duration_s: 10.7,
          children: [82185],
        },
        {
          id: 87149,
          depth: 3,
          name: "Research Target Account (Slack)",
          goal: "Research Demo Account 58 and summarize its fictional business profile in Slack.",
          duration_s: 7.9,
          children: [82186],
        },
        {
          id: 87150,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-65 and post a sample status update using Slack.",
          duration_s: 304.2,
          children: [82187],
        },
        {
          id: 87151,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 72.",
          duration_s: 9.9,
          children: [82188],
        },
        {
          id: 87152,
          depth: 3,
          name: "Review Recording (QuickTime Player)",
          goal: "Review Sample Session 79 and record a fictional outcome in QuickTime Player.",
          duration_s: 59.2,
          children: [82189],
        },
        {
          id: 87153,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 86.",
          duration_s: 36.7,
          children: [82190],
        },
        {
          id: 87154,
          depth: 3,
          name: "Review Recording (Slack)",
          goal: "Review Sample Session 93 and record a fictional outcome in Slack.",
          duration_s: 8.1,
          children: [82191],
        },
        {
          id: 87155,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 11.",
          duration_s: 14.1,
          children: [82192],
        },
        {
          id: 87156,
          depth: 3,
          name: "Review Recording (Slack)",
          goal: "Review Sample Session 18 and record a fictional outcome in Slack.",
          duration_s: 16.3,
          children: [82193],
        },
        {
          id: 87157,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 25.",
          duration_s: 10.3,
          children: [82194],
        },
        {
          id: 87158,
          depth: 3,
          name: "Update CRM Record (Slack)",
          goal: "Open the fictional record for Demo Account 32 and update its sample fields in Slack.",
          duration_s: 12.7,
          children: [82195],
        },
        {
          id: 87159,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 39.",
          duration_s: 8.8,
          children: [82196],
        },
        {
          id: 87160,
          depth: 3,
          name: "Review Recording (Slack)",
          goal: "Review Sample Session 46 and record a fictional outcome in Slack.",
          duration_s: 24.2,
          children: [82197],
        },
        {
          id: 87161,
          depth: 3,
          name: "Review Recording (Slack)",
          goal: "Review Sample Session 53 and record a fictional outcome in Slack.",
          duration_s: 6.0,
          children: [82198],
        },
        {
          id: 87162,
          depth: 3,
          name: "Check Messages (Slack)",
          goal: "Review the fictional conversation in #demo-ops-60 and post a sample status update using Slack.",
          duration_s: 8.5,
          children: [82199],
        },
        {
          id: 87163,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 67.",
          duration_s: 8.6,
          children: [82200],
        },
        {
          id: 87164,
          depth: 3,
          name: "Review Recording (Slack)",
          goal: "Review Sample Session 74 and record a fictional outcome in Slack.",
          duration_s: 28.3,
          children: [82201],
        },
        {
          id: 87166,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 81.",
          duration_s: 6.8,
          children: [82203],
        },
        {
          id: 87167,
          depth: 3,
          name: "Check Messages (Slack)",
          goal: "Review the fictional conversation in #demo-ops-88 and post a sample status update using Slack.",
          duration_s: 122.5,
          children: [82204],
        },
        {
          id: 87168,
          depth: 3,
          name: "Review Recording (Slack)",
          goal: "Review Sample Session 95 and record a fictional outcome in Slack.",
          duration_s: 23.3,
          children: [82205],
        },
        {
          id: 87169,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 13.",
          duration_s: 9.4,
          children: [82206],
        },
        {
          id: 87170,
          depth: 3,
          name: "Review Recording (Slack)",
          goal: "Review Sample Session 20 and record a fictional outcome in Slack.",
          duration_s: 16.5,
          children: [82207],
        },
        {
          id: 87172,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 27.",
          duration_s: 7.5,
          children: [82209],
        },
        {
          id: 87173,
          depth: 3,
          name: "Share Content (Slack)",
          goal: "Review and update Sample Enablement Guide 34 with fictional onboarding details in Slack.",
          duration_s: 45.9,
          children: [82210],
        },
        {
          id: 87174,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-41 and post a sample status update using Slack.",
          duration_s: 32.4,
          children: [82211],
        },
        {
          id: 87175,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-48 and post a sample status update using Slack.",
          duration_s: 22.9,
          children: [82212],
        },
        {
          id: 87176,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-55 and post a sample status update using Slack.",
          duration_s: 189.9,
          children: [82213],
        },
        {
          id: 87177,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-62 and post a sample status update using Slack.",
          duration_s: 27.6,
          children: [82214],
        },
        {
          id: 87178,
          depth: 3,
          name: "Review Recording (Slack)",
          goal: "Review Sample Session 69 and record a fictional outcome in Slack.",
          duration_s: 4.3,
          children: [82215],
        },
        {
          id: 87179,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-76 and post a sample status update using Slack.",
          duration_s: 35.1,
          children: [82224],
        },
        {
          id: 87180,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-83 and post a sample status update using Slack.",
          duration_s: 16.5,
          children: [82225],
        },
        {
          id: 87181,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 90.",
          duration_s: 14.0,
          children: [82226],
        },
        {
          id: 87182,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 97.",
          duration_s: 9.8,
          children: [82227],
        },
        {
          id: 87183,
          depth: 3,
          name: "Check Messages (Gmail)",
          goal: "Review the fictional conversation in #demo-ops-15 and post a sample status update using Gmail.",
          duration_s: 4.9,
          children: [82229],
        },
        {
          id: 87184,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 22 and update its demo availability in Arc.",
          duration_s: 26.7,
          children: [82232],
        },
        {
          id: 87185,
          depth: 3,
          name: "Share Content (Slack)",
          goal: "Review and update Sample Enablement Guide 29 with fictional onboarding details in Slack.",
          duration_s: 54.3,
          children: [82245],
        },
        {
          id: 87187,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 36.",
          duration_s: 8.0,
          children: [82247],
        },
        {
          id: 87188,
          depth: 3,
          name: "Check Messages (Gmail)",
          goal: "Review the fictional conversation in #demo-ops-43 and post a sample status update using Gmail.",
          duration_s: 28.1,
          children: [82248],
        },
        {
          id: 87189,
          depth: 3,
          name: "Check Messages (Arc)",
          goal: "Review the fictional conversation in #demo-ops-50 and post a sample status update using Arc.",
          duration_s: 11.8,
          children: [82249],
        },
        {
          id: 87190,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 57 and update its demo status in Arc.",
          duration_s: 27.6,
          children: [82250],
        },
        {
          id: 87193,
          depth: 3,
          name: "Update CRM Record (Slack)",
          goal: "Open the fictional record for Demo Account 64 and update its sample fields in Slack.",
          duration_s: 48.4,
          children: [82253],
        },
        {
          id: 87194,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 71 and update its demo status in Arc.",
          duration_s: 46.1,
          children: [82255],
        },
        {
          id: 87195,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 78 and record a fictional outcome in Arc.",
          duration_s: 34.5,
          children: [82256],
        },
        {
          id: 87196,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 85.",
          duration_s: 53.6,
          children: [82257],
        },
        {
          id: 87198,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 92.",
          duration_s: 94.1,
          children: [82259],
        },
        {
          id: 87199,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 10.",
          duration_s: 36.9,
          children: [82260],
        },
        {
          id: 87200,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 17 and record a fictional outcome in Arc.",
          duration_s: 88.0,
          children: [82261],
        },
        {
          id: 87201,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 24 and update its sample fields in Arc.",
          duration_s: 32.8,
          children: [82263],
        },
        {
          id: 87203,
          depth: 3,
          name: "Research Target Account (Salesforce)",
          goal: "Research Demo Account 31 and summarize its fictional business profile in Salesforce.",
          duration_s: 27.2,
          children: [82265],
        },
        {
          id: 87204,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 38 and update its sample fields in Arc.",
          duration_s: 9.5,
          children: [82266],
        },
        {
          id: 87205,
          depth: 3,
          name: "Enrich Contact Data (Salesforce)",
          goal: "Open the fictional record for Demo Account 45 and update its sample fields in Salesforce.",
          duration_s: 28.1,
          children: [82267],
        },
        {
          id: 87206,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 52 and record a fictional outcome in Arc.",
          duration_s: 91.3,
          children: [82268],
        },
        {
          id: 87207,
          depth: 3,
          name: "Research Target Account (Gmail)",
          goal: "Research Demo Account 59 and summarize its fictional business profile in Gmail.",
          duration_s: 51.0,
          children: [82269],
        },
        {
          id: 87208,
          depth: 3,
          name: "Enrich Contact Data (Salesforce)",
          goal: "Open the fictional record for Demo Account 66 and update its sample fields in Salesforce.",
          duration_s: 16.3,
          children: [82270],
        },
        {
          id: 87209,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 73 and record a fictional outcome in Arc.",
          duration_s: 9.7,
          children: [82271],
        },
        {
          id: 87210,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 80.",
          duration_s: 166.4,
          children: [82272],
        },
        {
          id: 87211,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 87 and update its demo availability in Arc.",
          duration_s: 89.8,
          children: [82273],
        },
        {
          id: 87212,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 94 and update its demo availability in Arc.",
          duration_s: 24.8,
          children: [82274],
        },
        {
          id: 87213,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 12 and update its demo status in Arc.",
          duration_s: 49.6,
          children: [82275],
        },
        {
          id: 87214,
          depth: 3,
          name: "Create CRM Lead/Contact Record (Arc)",
          goal: "Open the fictional record for Demo Account 19 and update its sample fields in Arc.",
          duration_s: 46.1,
          children: [82276],
        },
        {
          id: 87215,
          depth: 3,
          name: "Create CRM Lead/Contact Record (Salesforce)",
          goal: "Open the fictional record for Demo Account 26 and update its sample fields in Salesforce.",
          duration_s: 11.5,
          children: [82277],
        },
        {
          id: 87216,
          depth: 3,
          name: "Update CRM Record (Salesforce)",
          goal: "Open the fictional record for Demo Account 33 and update its sample fields in Salesforce.",
          duration_s: 12.6,
          children: [82278],
        },
        {
          id: 87217,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 40 and update its demo status in Arc.",
          duration_s: 26.7,
          children: [82280],
        },
        {
          id: 87218,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 47 and update its demo availability in Arc.",
          duration_s: 5.9,
          children: [82282],
        },
        {
          id: 87219,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 54 and update its demo availability in Arc.",
          duration_s: 11.9,
          children: [82283],
        },
        {
          id: 87220,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 61 and update its demo availability in Arc.",
          duration_s: 5.7,
          children: [82284],
        },
        {
          id: 87221,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 68.",
          duration_s: 6.3,
          children: [82286],
        },
        {
          id: 87222,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-75 and post a sample status update using Slack.",
          duration_s: 15.4,
          children: [82287],
        },
        {
          id: 87223,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 82.",
          duration_s: 74.7,
          children: [82288],
        },
        {
          id: 87224,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 89.",
          duration_s: 12.6,
          children: [82290],
        },
        {
          id: 87225,
          depth: 3,
          name: "Research Target Account (Salesforce)",
          goal: "Research Demo Account 96 and summarize its fictional business profile in Salesforce.",
          duration_s: 13.9,
          children: [82291],
        },
        {
          id: 87226,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 14 and update its sample fields in Arc.",
          duration_s: 11.0,
          children: [82293],
        },
        {
          id: 87227,
          depth: 3,
          name: "Enrich Contact Data (Salesforce)",
          goal: "Open the fictional record for Demo Account 21 and update its sample fields in Salesforce.",
          duration_s: 31.8,
          children: [82294],
        },
        {
          id: 87228,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 28 and record a fictional outcome in Arc.",
          duration_s: 15.8,
          children: [82295],
        },
        {
          id: 87229,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 35 and update its demo status in Arc.",
          duration_s: 10.6,
          children: [82296],
        },
        {
          id: 87231,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 42.",
          duration_s: 15.8,
          children: [82298],
        },
        {
          id: 87232,
          depth: 3,
          name: "Check Messages (Gmail)",
          goal: "Review the fictional conversation in #demo-ops-49 and post a sample status update using Gmail.",
          duration_s: 12.5,
          children: [82299],
        },
        {
          id: 87233,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 56 and update its demo availability in Arc.",
          duration_s: 8.2,
          children: [82300],
        },
        {
          id: 87234,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 63 and update its demo availability in Arc.",
          duration_s: 8.8,
          children: [82301],
        },
        {
          id: 87235,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 70 and update its demo availability in Arc.",
          duration_s: 9.5,
          children: [82302],
        },
        {
          id: 87236,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 77 and update its demo status in Arc.",
          duration_s: 16.2,
          children: [82303],
        },
        {
          id: 87238,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 84.",
          duration_s: 30.5,
          children: [82306],
        },
        {
          id: 87239,
          depth: 3,
          name: "Check Messages (Slack)",
          goal: "Review the fictional conversation in #demo-ops-91 and post a sample status update using Slack.",
          duration_s: 11.3,
          children: [82307],
        },
        {
          id: 87240,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 98.",
          duration_s: 227.4,
          children: [82308],
        },
        {
          id: 87241,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Salesforce)",
          goal: "Review the sample outreach workflow for Demo Account 16 and update its demo status in Salesforce.",
          duration_s: 344.9,
          children: [82309],
        },
        {
          id: 87242,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 23.",
          duration_s: 223.2,
          children: [82310],
        },
        {
          id: 87243,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 30.",
          duration_s: 242.6,
          children: [82311],
        },
        {
          id: 87244,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 37.",
          duration_s: 1036.8,
          children: [82312],
        },
        {
          id: 87245,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 44.",
          duration_s: 8.7,
          children: [82315],
        },
        {
          id: 87246,
          depth: 3,
          name: "Research Target Account (Gmail)",
          goal: "Research Demo Account 51 and summarize its fictional business profile in Gmail.",
          duration_s: 10.9,
          children: [82316],
        },
        {
          id: 87247,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 58.",
          duration_s: 43.5,
          children: [82317],
        },
        {
          id: 87248,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-65 and post a sample status update using Slack.",
          duration_s: 114.7,
          children: [82318],
        },
        {
          id: 87249,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-72 and post a sample status update using Slack.",
          duration_s: 50.5,
          children: [82319],
        },
        {
          id: 87250,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 79.",
          duration_s: 8.3,
          children: [82320],
        },
        {
          id: 87251,
          depth: 3,
          name: "Research Target Account (Salesforce)",
          goal: "Research Demo Account 86 and summarize its fictional business profile in Salesforce.",
          duration_s: 37.9,
          children: [82322],
        },
        {
          id: 87252,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 93 and update its demo status in Arc.",
          duration_s: 37.3,
          children: [82323],
        },
        {
          id: 87254,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 11.",
          duration_s: 57.6,
          children: [82325],
        },
        {
          id: 87256,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 18.",
          duration_s: 5.0,
          children: [82327],
        },
        {
          id: 87258,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-25 and post a sample status update using Slack.",
          duration_s: 11.3,
          children: [82330],
        },
        {
          id: 87261,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-32 and post a sample status update using Slack.",
          duration_s: 32.4,
          children: [82333],
        },
        {
          id: 87262,
          depth: 3,
          name: "Research Target Account (Slack)",
          goal: "Research Demo Account 39 and summarize its fictional business profile in Slack.",
          duration_s: 7.5,
          children: [82334],
        },
        {
          id: 87263,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 46.",
          duration_s: 11.9,
          children: [82335],
        },
        {
          id: 87264,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 53.",
          duration_s: 14.7,
          children: [82336],
        },
        {
          id: 87265,
          depth: 3,
          name: "Research Target Account (Salesforce)",
          goal: "Research Demo Account 60 and summarize its fictional business profile in Salesforce.",
          duration_s: 12.9,
          children: [82339],
        },
        {
          id: 87266,
          depth: 3,
          name: "Create Training Video (Arc)",
          goal: "Review Sample Session 67 and record a fictional outcome in Arc.",
          duration_s: 132.8,
          children: [82340],
        },
        {
          id: 87267,
          depth: 3,
          name: "Create Training Video (Chrome)",
          goal: "Review Sample Session 74 and record a fictional outcome in Chrome.",
          duration_s: 102.1,
          children: [82341],
        },
        {
          id: 87268,
          depth: 3,
          name: "Check Messages (Gmail)",
          goal: "Review the fictional conversation in #demo-ops-81 and post a sample status update using Gmail.",
          duration_s: 9.1,
          children: [82342],
        },
        {
          id: 87269,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 88.",
          duration_s: 8.6,
          children: [82343],
        },
        {
          id: 87270,
          depth: 3,
          name: "Check Messages (Gmail)",
          goal: "Review the fictional conversation in #demo-ops-95 and post a sample status update using Gmail.",
          duration_s: 21.8,
          children: [82344],
        },
        {
          id: 87271,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 13.",
          duration_s: 13.1,
          children: [82345],
        },
        {
          id: 87273,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 20.",
          duration_s: 109.2,
          children: [82348],
        },
        {
          id: 87274,
          depth: 3,
          name: "Research Target Account (Salesforce)",
          goal: "Research Demo Account 27 and summarize its fictional business profile in Salesforce.",
          duration_s: 20.6,
          children: [82349],
        },
        {
          id: 87275,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 34.",
          duration_s: 5.0,
          children: [82350],
        },
        {
          id: 87276,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 41 and update its sample fields in Arc.",
          duration_s: 16.1,
          children: [82351],
        },
        {
          id: 87277,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 48 and update its sample fields in Arc.",
          duration_s: 18.7,
          children: [82352],
        },
        {
          id: 87278,
          depth: 3,
          name: "Research Target Account (Salesforce)",
          goal: "Research Demo Account 55 and summarize its fictional business profile in Salesforce.",
          duration_s: 21.6,
          children: [82353],
        },
        {
          id: 87279,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 62 and record a fictional outcome in Arc.",
          duration_s: 39.8,
          children: [82354],
        },
        {
          id: 87280,
          depth: 3,
          name: "Check Messages (Gmail)",
          goal: "Review the fictional conversation in #demo-ops-69 and post a sample status update using Gmail.",
          duration_s: 94.7,
          children: [82355],
        },
        {
          id: 87281,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 76 and update its sample fields in Arc.",
          duration_s: 25.7,
          children: [82357],
        },
        {
          id: 87282,
          depth: 3,
          name: "Research Target Account (Salesforce)",
          goal: "Research Demo Account 83 and summarize its fictional business profile in Salesforce.",
          duration_s: 4.4,
          children: [82359],
        },
        {
          id: 87283,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 90.",
          duration_s: 4.1,
          children: [82360],
        },
        {
          id: 87284,
          depth: 3,
          name: "Research Target Account (Arc)",
          goal: "Research Demo Account 97 and summarize its fictional business profile in Arc.",
          duration_s: 6.4,
          children: [82361],
        },
        {
          id: 87285,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 15.",
          duration_s: 4.6,
          children: [82362],
        },
        {
          id: 87287,
          depth: 3,
          name: "Research Target Account (Salesforce)",
          goal: "Research Demo Account 22 and summarize its fictional business profile in Salesforce.",
          duration_s: 7.3,
          children: [82364],
        },
        {
          id: 87288,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Salesforce)",
          goal: "Review the sample outreach workflow for Demo Account 29 and update its demo status in Salesforce.",
          duration_s: 19.0,
          children: [82366],
        },
        {
          id: 87289,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 36.",
          duration_s: 8.3,
          children: [82368],
        },
        {
          id: 87290,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 43.",
          duration_s: 12.3,
          children: [82369],
        },
        {
          id: 87291,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 50.",
          duration_s: 17.4,
          children: [82370],
        },
        {
          id: 87293,
          depth: 3,
          name: "Check Messages (Gmail)",
          goal: "Review the fictional conversation in #demo-ops-57 and post a sample status update using Gmail.",
          duration_s: 7.2,
          children: [82372],
        },
        {
          id: 87294,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 64 and update its sample fields in Arc.",
          duration_s: 10.5,
          children: [82374],
        },
        {
          id: 87295,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 71 and update its demo status in Arc.",
          duration_s: 28.4,
          children: [82378],
        },
        {
          id: 87297,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 78 and update its sample fields in Arc.",
          duration_s: 22.1,
          children: [82381],
        },
        {
          id: 87298,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 85 and update its sample fields in Arc.",
          duration_s: 9.6,
          children: [82382],
        },
        {
          id: 87299,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 92 and update its sample fields in Arc.",
          duration_s: 9.0,
          children: [82383],
        },
        {
          id: 87300,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 10 and update its sample fields in Arc.",
          duration_s: 10.4,
          children: [82384],
        },
        {
          id: 87301,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 17 and update its sample fields in Arc.",
          duration_s: 21.2,
          children: [82385],
        },
        {
          id: 87302,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 24 and update its sample fields in Arc.",
          duration_s: 18.0,
          children: [82386],
        },
        {
          id: 87303,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 31 and update its sample fields in Arc.",
          duration_s: 18.7,
          children: [82387],
        },
        {
          id: 87304,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 38 and update its sample fields in Arc.",
          duration_s: 14.4,
          children: [82388],
        },
        {
          id: 87305,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 45.",
          duration_s: 7.4,
          children: [82391],
        },
        {
          id: 87306,
          depth: 3,
          name: "Research Target Account (Arc)",
          goal: "Research Demo Account 52 and summarize its fictional business profile in Arc.",
          duration_s: 31.1,
          children: [82393],
        },
        {
          id: 87307,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 59 and update its sample fields in Arc.",
          duration_s: 14.7,
          children: [82394],
        },
        {
          id: 87308,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 66 and update its sample fields in Arc.",
          duration_s: 5.5,
          children: [82395],
        },
        {
          id: 87309,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 73 and update its sample fields in Arc.",
          duration_s: 8.4,
          children: [82396],
        },
        {
          id: 87310,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 80 and update its sample fields in Arc.",
          duration_s: 20.1,
          children: [82397],
        },
        {
          id: 87311,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 87 and update its sample fields in Arc.",
          duration_s: 6.3,
          children: [82398],
        },
        {
          id: 87312,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 94 and record a fictional outcome in Arc.",
          duration_s: 134.9,
          children: [82399],
        },
        {
          id: 87313,
          depth: 3,
          name: "Schedule Meeting (Arc)",
          goal: "Review a sample calendar entry for Demo Account 12 and update its demo availability in Arc.",
          duration_s: 22.9,
          children: [82401],
        },
        {
          id: 87314,
          depth: 3,
          name: "Schedule Meeting (Arc)",
          goal: "Review a sample calendar entry for Demo Account 19 and update its demo availability in Arc.",
          duration_s: 127.0,
          children: [82402],
        },
        {
          id: 87315,
          depth: 3,
          name: "Schedule Meeting (Salesforce)",
          goal: "Review a sample calendar entry for Demo Account 26 and update its demo availability in Salesforce.",
          duration_s: 8.8,
          children: [82403],
        },
        {
          id: 87316,
          depth: 3,
          name: "Schedule Meeting (Arc)",
          goal: "Review a sample calendar entry for Demo Account 33 and update its demo availability in Arc.",
          duration_s: 17.4,
          children: [82404],
        },
        {
          id: 87317,
          depth: 3,
          name: "Schedule Meeting (Arc)",
          goal: "Review a sample calendar entry for Demo Account 40 and update its demo availability in Arc.",
          duration_s: 21.3,
          children: [82405],
        },
        {
          id: 87318,
          depth: 3,
          name: "Lookup Reference (Arc)",
          goal: "Review and update Sample Enablement Guide 47 with fictional onboarding details in Arc.",
          duration_s: 13.8,
          children: [82406],
        },
        {
          id: 87319,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 54 and update its demo availability in Arc.",
          duration_s: 158.3,
          children: [82407],
        },
        {
          id: 87320,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 61 and record a fictional outcome in Arc.",
          duration_s: 6.2,
          children: [82408],
        },
        {
          id: 87321,
          depth: 3,
          name: "Create CRM Lead/Contact Record (Arc)",
          goal: "Open the fictional record for Demo Account 68 and update its sample fields in Arc.",
          duration_s: 18.2,
          children: [82409],
        },
        {
          id: 87322,
          depth: 3,
          name: "Create CRM Lead/Contact Record (Arc)",
          goal: "Open the fictional record for Demo Account 75 and update its sample fields in Arc.",
          duration_s: 5.3,
          children: [82410],
        },
        {
          id: 87323,
          depth: 3,
          name: "Make Outbound Call / Log Call Outcome (Arc)",
          goal: "Review Sample Session 82 and record a fictional outcome in Arc.",
          duration_s: 6.5,
          children: [82411],
        },
        {
          id: 87324,
          depth: 3,
          name: "Create CRM Lead/Contact Record (Salesforce)",
          goal: "Open the fictional record for Demo Account 89 and update its sample fields in Salesforce.",
          duration_s: 45.8,
          children: [82412],
        },
        {
          id: 87325,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 96 and update its demo status in Arc.",
          duration_s: 27.5,
          children: [82413],
        },
        {
          id: 87327,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 14 and update its demo status in Arc.",
          duration_s: 18.6,
          children: [82415],
        },
        {
          id: 87328,
          depth: 3,
          name: "Check Messages (Gmail)",
          goal: "Review the fictional conversation in #demo-ops-21 and post a sample status update using Gmail.",
          duration_s: 63.2,
          children: [82416],
        },
        {
          id: 87329,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 28 and update its sample fields in Arc.",
          duration_s: 24.2,
          children: [82417],
        },
        {
          id: 87331,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 35 and update its demo status in Arc.",
          duration_s: 7.3,
          children: [82419],
        },
        {
          id: 87333,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 42 and update its demo availability in Arc.",
          duration_s: 34.2,
          children: [82421],
        },
        {
          id: 87336,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 49 and update its demo availability in Arc.",
          duration_s: 16.0,
          children: [82424],
        },
        {
          id: 87337,
          depth: 3,
          name: "Navigate workspace",
          goal: "Move through the workspace to continue Sample Workflow 56.",
          duration_s: 31.4,
          children: [82425],
        },
        {
          id: 87339,
          depth: 3,
          name: "Check Messages (Slack)",
          goal: "Review the fictional conversation in #demo-ops-63 and post a sample status update using Slack.",
          duration_s: 30.2,
          children: [82427],
        },
        {
          id: 87340,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-70 and post a sample status update using Slack.",
          duration_s: 48.1,
          children: [82428],
        },
        {
          id: 87341,
          depth: 3,
          name: "Author Onboarding or Reference Doc (lemlist)",
          goal: "Review and update Sample Enablement Guide 77 with fictional onboarding details in lemlist.",
          duration_s: 32.7,
          children: [82429],
        },
        {
          id: 87342,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Claude)",
          goal: "Review and update Sample Enablement Guide 84 with fictional onboarding details in Claude.",
          duration_s: 24.7,
          children: [82430],
        },
        {
          id: 87343,
          depth: 3,
          name: "Configure Onboarding Tools and Resources (Claude)",
          goal: "Review and update Sample Enablement Guide 91 with fictional onboarding details in Claude.",
          duration_s: 60.6,
          children: [82431],
        },
        {
          id: 87344,
          depth: 3,
          name: "Author Onboarding or Reference Doc (lemlist)",
          goal: "Review and update Sample Enablement Guide 98 with fictional onboarding details in lemlist.",
          duration_s: 10.9,
          children: [82432],
        },
        {
          id: 87345,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Claude)",
          goal: "Review and update Sample Enablement Guide 16 with fictional onboarding details in Claude.",
          duration_s: 286.6,
          children: [82433],
        },
        {
          id: 87346,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Claude)",
          goal: "Review and update Sample Enablement Guide 23 with fictional onboarding details in Claude.",
          duration_s: 101.1,
          children: [82434],
        },
        {
          id: 87347,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Claude)",
          goal: "Review and update Sample Enablement Guide 30 with fictional onboarding details in Claude.",
          duration_s: 68.4,
          children: [82435],
        },
        {
          id: 87348,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-37 and post a sample status update using Slack.",
          duration_s: 62.1,
          children: [82436],
        },
        {
          id: 87349,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-44 and post a sample status update using Slack.",
          duration_s: 27.2,
          children: [82437],
        },
        {
          id: 87350,
          depth: 3,
          name: "Send Follow-up Email (lemlist)",
          goal: "Draft and send a sample follow-up to Demo Contact 51 using lemlist.",
          duration_s: 21.9,
          children: [82438],
        },
        {
          id: 87352,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-58 and post a sample status update using Slack.",
          duration_s: 42.0,
          children: [82440],
        },
        {
          id: 91001,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 65 and update its demo status in the workspace.",
          duration_s: 115.4,
          children: [87001, 87135, 87350],
        },
        {
          id: 91002,
          depth: 4,
          name: "Navigate Workspace",
          goal: "Move through the workspace to continue Sample Workflow 72.",
          duration_s: 4298.1,
          children: [
            87002, 87005, 87009, 87011, 87012, 87017, 87025, 87027, 87031, 87032, 87036, 87051,
            87053, 87056, 87058, 87060, 87062, 87063, 87066, 87072, 87089, 87094, 87119, 87122,
            87151, 87153, 87155, 87157, 87159, 87162, 87163, 87166, 87167, 87169, 87172, 87181,
            87182, 87187, 87189, 87196, 87198, 87199, 87210, 87218, 87221, 87223, 87224, 87238,
            87239, 87240, 87242, 87243, 87244, 87245, 87247, 87250, 87254, 87256, 87258, 87261,
            87263, 87264, 87268, 87269, 87270, 87271, 87273, 87275, 87280, 87285, 87289, 87290,
            87291, 87305, 87310, 87337,
          ],
        },
        {
          id: 91003,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-79 and post a sample status update using the workspace.",
          duration_s: 1187.9,
          children: [
            87003, 87004, 87016, 87029, 87037, 87039, 87045, 87046, 87047, 87067, 87070, 87185,
            87222,
          ],
        },
        {
          id: 91004,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 86 and update its demo status in the workspace.",
          duration_s: 368.7,
          children: [87004, 87006],
        },
        {
          id: 91005,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-93 and post a sample status update using the workspace.",
          duration_s: 119.1,
          children: [87007, 87219, 87220, 87232, 87233, 87234, 87235, 87333],
        },
        {
          id: 91006,
          depth: 4,
          name: "Team Enablement & Onboarding",
          goal: "Review and update Sample Enablement Guide 11 with fictional onboarding details in the workspace.",
          duration_s: 971.5,
          children: [
            87013, 87015, 87023, 87024, 87030, 87033, 87040, 87042, 87045, 87048, 87078, 87342,
            87343, 87345, 87346, 87347,
          ],
        },
        {
          id: 91007,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 18 and update its demo status in the workspace.",
          duration_s: 186.3,
          children: [
            87015, 87294, 87297, 87298, 87299, 87300, 87301, 87302, 87303, 87304, 87308, 87309,
            87310, 87311,
          ],
        },
        {
          id: 91008,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 25 and update its demo status in the workspace.",
          duration_s: 2631.0,
          children: [
            87019, 87020, 87021, 87022, 87023, 87024, 87025, 87026, 87027, 87028, 87029, 87033,
            87034, 87040, 87042, 87045, 87048,
          ],
        },
        {
          id: 91009,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-32 and post a sample status update using the workspace.",
          duration_s: 563.1,
          children: [87047, 87055, 87174, 87175, 87176, 87177, 87223, 87248, 87249, 87316],
        },
        {
          id: 91010,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-39 and post a sample status update using the workspace.",
          duration_s: 237.5,
          children: [87052, 87064, 87065, 87071],
        },
        {
          id: 91011,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-46 and post a sample status update using the workspace.",
          duration_s: 206.2,
          children: [87052, 87073, 87336],
        },
        {
          id: 91012,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-53 and post a sample status update using the workspace.",
          duration_s: 332.7,
          children: [87054, 87055, 87150],
        },
        {
          id: 91013,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 60 and update its demo status in the workspace.",
          duration_s: 553.6,
          children: [87057, 87058, 87059, 87061],
        },
        {
          id: 91014,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-67 and post a sample status update using the workspace.",
          duration_s: 499.5,
          children: [
            87060, 87072, 87167, 87183, 87188, 87207, 87232, 87239, 87246, 87268, 87270, 87280,
            87293, 87328, 87339,
          ],
        },
        {
          id: 91015,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-74 and post a sample status update using the workspace.",
          duration_s: 223.8,
          children: [87070, 87082, 87149],
        },
        {
          id: 91016,
          depth: 4,
          name: "Team Enablement & Onboarding",
          goal: "Review and update Sample Enablement Guide 81 with fictional onboarding details in the workspace.",
          duration_s: 1207.3,
          children: [
            87073, 87076, 87083, 87084, 87087, 87093, 87095, 87097, 87100, 87101, 87108, 87110,
            87123, 87124, 87125, 87126, 87137, 87147, 87152, 87154, 87156, 87160, 87161, 87164,
            87168, 87170, 87266, 87267,
          ],
        },
        {
          id: 91017,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 88 and update its demo status in the workspace.",
          duration_s: 144.8,
          children: [87075, 87341, 87344],
        },
        {
          id: 91018,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 95 and update its demo status in the workspace.",
          duration_s: 832.9,
          children: [
            87075, 87077, 87079, 87086, 87102, 87103, 87107, 87109, 87111, 87112, 87120, 87129,
            87130, 87136, 87138, 87141, 87148,
          ],
        },
        {
          id: 91019,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 13 and update its demo status in the workspace.",
          duration_s: 840.8,
          children: [
            87077, 87096, 87098, 87099, 87100, 87101, 87111, 87113, 87114, 87121, 87127, 87140,
            87141, 87142, 87143, 87144,
          ],
        },
        {
          id: 91020,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 20 and update its demo status in the workspace.",
          duration_s: 187.8,
          children: [87079, 87108, 87119, 87196],
        },
        {
          id: 91021,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 27 and update its demo status in the workspace.",
          duration_s: 758.2,
          children: [
            87081, 87090, 87105, 87115, 87131, 87139, 87142, 87195, 87200, 87206, 87209, 87212,
            87279, 87312, 87320, 87323,
          ],
        },
        {
          id: 91022,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 34 and update its demo status in the workspace.",
          duration_s: 1073.3,
          children: [
            87082, 87092, 87106, 87113, 87116, 87127, 87133, 87134, 87143, 87144, 87190, 87194,
            87217, 87229, 87236, 87252, 87295, 87325, 87327, 87331,
          ],
        },
        {
          id: 91023,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 41 and update its demo status in the workspace.",
          duration_s: 771.3,
          children: [87082, 87092, 87113, 87116, 87133, 87134, 87143, 87144, 87295, 87325],
        },
        {
          id: 91024,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 48 and update its demo status in the workspace.",
          duration_s: 100.5,
          children: [87104, 87114, 87128],
        },
        {
          id: 91025,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-55 and post a sample status update using the workspace.",
          duration_s: 339.3,
          children: [87117, 87118, 87184, 87211, 87212, 87313, 87314, 87317],
        },
        {
          id: 91026,
          depth: 4,
          name: "Team Enablement & Onboarding",
          goal: "Review and update Sample Enablement Guide 62 with fictional onboarding details in the workspace.",
          duration_s: 435.7,
          children: [87158, 87173, 87174, 87175, 87176, 87177, 87178, 87179, 87180, 87193],
        },
        {
          id: 91027,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-69 and post a sample status update using the workspace.",
          duration_s: 96.2,
          children: [87183, 87188, 87328],
        },
        {
          id: 91028,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 76 and update its demo status in the workspace.",
          duration_s: 108.3,
          children: [87201, 87204, 87276, 87281, 87329],
        },
        {
          id: 91029,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 83 and update its demo status in the workspace.",
          duration_s: 214.5,
          children: [87203, 87205, 87225, 87227, 87251, 87265, 87274, 87278, 87282, 87287, 87315],
        },
        {
          id: 91030,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 90 and update its demo status in the workspace.",
          duration_s: 565.7,
          children: [87207, 87208, 87213, 87225, 87227, 87241, 87265, 87276, 87277, 87283, 87284],
        },
        {
          id: 91031,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 97 and update its demo status in the workspace.",
          duration_s: 123.3,
          children: [87208, 87209, 87212, 87225, 87226, 87227, 87228],
        },
        {
          id: 91032,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 15 and update its demo status in the workspace.",
          duration_s: 208.0,
          children: [
            87213, 87214, 87215, 87216, 87219, 87220, 87228, 87231, 87232, 87233, 87234, 87235,
          ],
        },
        {
          id: 91033,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 22 and update its demo status in the workspace.",
          duration_s: 116.0,
          children: [87214, 87215, 87216, 87324],
        },
        {
          id: 91034,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-29 and post a sample status update using the workspace.",
          duration_s: 137.6,
          children: [87222, 87248, 87262],
        },
        {
          id: 91035,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-36 and post a sample status update using the workspace.",
          duration_s: 130.1,
          children: [87222, 87248],
        },
        {
          id: 91036,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-43 and post a sample status update using the workspace.",
          duration_s: 360.7,
          children: [87231, 87241],
        },
        {
          id: 91037,
          depth: 4,
          name: "Team Enablement & Onboarding",
          goal: "Review and update Sample Enablement Guide 50 with fictional onboarding details in the workspace.",
          duration_s: 234.9,
          children: [87266, 87267],
        },
        {
          id: 91038,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 57 and update its demo status in the workspace.",
          duration_s: 672.7,
          children: [
            87282, 87283, 87284, 87287, 87288, 87306, 87307, 87308, 87312, 87313, 87314, 87315,
            87316, 87317, 87318, 87319, 87321, 87322, 87323, 87324,
          ],
        },
        {
          id: 91039,
          depth: 4,
          name: "Outbound Pipeline Generation",
          goal: "Review the sample outreach workflow for Demo Account 64 and update its demo status in the workspace.",
          duration_s: 168.7,
          children: [
            87294, 87297, 87298, 87299, 87300, 87301, 87302, 87303, 87304, 87309, 87310, 87311,
          ],
        },
        {
          id: 91040,
          depth: 4,
          name: "Internal Collaboration & Admin",
          goal: "Review the fictional conversation in #demo-ops-71 and post a sample status update using the workspace.",
          duration_s: 179.4,
          children: [87340, 87348, 87349, 87352],
        },
      ],
      orphans: [
        {
          id: 82055,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Slack to continue Sample Workflow 78.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 0.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01626_295.png", "demo_alpha_frame_01627_717.png"],
            },
          ],
          coverage: [["2025-02-04T09:57:20.508Z", "2025-02-04T09:57:20.821Z"]],
          duration_s: 0.3,
        },
        {
          id: 82059,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Slack to continue Sample Workflow 85.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 0.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01628_418.png", "demo_alpha_frame_01629_182.png"],
            },
          ],
          coverage: [["2025-02-04T10:01:08.258Z", "2025-02-04T10:01:08.654Z"]],
          duration_s: 0.4,
        },
        {
          id: 82061,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-92 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 1.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01630_725.png", "demo_alpha_frame_01631_081.png"],
            },
          ],
          coverage: [["2025-02-04T10:01:21.540Z", "2025-02-04T10:01:23.303Z"]],
          duration_s: 1.8,
        },
        {
          id: 82069,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Arc to continue Sample Workflow 10.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01632_023.png"],
            },
          ],
          coverage: [["2025-02-04T10:03:30.673Z", "2025-02-04T10:03:35.123Z"]],
          duration_s: 4.5,
        },
        {
          id: 82070,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Claude to continue Sample Workflow 17.",
          attributes: [
            {
              name: "app.Claude.duration_s",
              value: 3.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01633_130.png"],
            },
          ],
          coverage: [["2025-02-04T10:03:37.769Z", "2025-02-04T10:03:41.617Z"]],
          duration_s: 3.8,
        },
        {
          id: 82072,
          depth: 2,
          name: "navigate-apps",
          goal: "Move through Slack to continue Sample Workflow 24.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 0.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01634_936.png", "demo_alpha_frame_01635_046.png"],
            },
          ],
          coverage: [["2025-02-04T10:04:12.314Z", "2025-02-04T10:04:12.815Z"]],
          duration_s: 0.5,
        },
        {
          id: 82098,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 31 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01636_152.png", "demo_alpha_frame_01637_049.png"],
            },
          ],
          coverage: [["2025-02-04T11:05:23.399Z", "2025-02-04T11:05:26.506Z"]],
          duration_s: 3.1,
        },
        {
          id: 82101,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 38 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01638_539.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 37",
              qualifier: "accessed",
            },
          ],
          coverage: [["2025-02-04T11:08:05.169Z", "2025-02-04T11:08:08.320Z"]],
          duration_s: 3.2,
        },
        {
          id: 82104,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 45 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 1.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01639_410.png", "demo_alpha_frame_01640_964.png"],
            },
          ],
          coverage: [["2025-02-04T11:09:52.557Z", "2025-02-04T11:09:54.080Z"]],
          duration_s: 1.5,
        },
        {
          id: 82109,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 52 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01641_509.png"],
            },
          ],
          coverage: [["2025-02-04T11:11:02.159Z", "2025-02-04T11:11:06.017Z"]],
          duration_s: 3.9,
        },
        {
          id: 82111,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 59 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 1.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01642_189.png"],
            },
          ],
          coverage: [["2025-02-04T11:11:18.102Z", "2025-02-04T11:11:19.445Z"]],
          duration_s: 1.3,
        },
        {
          id: 82112,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 66 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 1.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01643_158.png", "demo_alpha_frame_01644_727.png"],
            },
          ],
          coverage: [["2025-02-04T11:11:21.201Z", "2025-02-04T11:11:22.198Z"]],
          duration_s: 1.0,
        },
        {
          id: 82114,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 73 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01645_020.png"],
            },
          ],
          coverage: [["2025-02-04T11:11:37.915Z", "2025-02-04T11:11:41.897Z"]],
          duration_s: 4.0,
        },
        {
          id: 82115,
          depth: 2,
          name: "review-tracker",
          goal: "Open the fictional record for Demo Account 80 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 0.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01646_042.png", "demo_alpha_frame_01647_609.png"],
            },
          ],
          coverage: [["2025-02-04T11:11:44.775Z", "2025-02-04T11:11:45.689Z"]],
          duration_s: 0.9,
        },
        {
          id: 82116,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 87 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01648_560.png"],
            },
          ],
          coverage: [["2025-02-04T11:11:48.589Z", "2025-02-04T11:11:52.688Z"]],
          duration_s: 4.1,
        },
        {
          id: 82118,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 94 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 1.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01649_161.png", "demo_alpha_frame_01650_080.png"],
            },
          ],
          coverage: [["2025-02-04T11:13:32.627Z", "2025-02-04T11:13:33.982Z"]],
          duration_s: 1.4,
        },
        {
          id: 82123,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-12 and post a sample status update using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 2.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01651_969.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 39",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T11:14:33.512Z", "2025-02-04T11:14:35.935Z"]],
          duration_s: 2.4,
        },
        {
          id: 82144,
          depth: 2,
          name: "review-activity-report",
          goal: "Complete a fictional review-activity-report task for Demo Account 19 using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01652_246.png"],
            },
          ],
          coverage: [["2025-02-04T11:32:11.513Z", "2025-02-04T11:32:15.808Z"]],
          duration_s: 4.3,
        },
        {
          id: 82146,
          depth: 2,
          name: "review-event-details",
          goal: "Review a sample calendar entry for Demo Account 26 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01653_618.png"],
            },
          ],
          coverage: [["2025-02-04T11:32:32.154Z", "2025-02-04T11:32:35.159Z"]],
          duration_s: 3.0,
        },
        {
          id: 82149,
          depth: 2,
          name: "delete-contact",
          goal: "Open the fictional record for Demo Account 33 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01654_899.png"],
            },
          ],
          coverage: [["2025-02-04T11:33:09.377Z", "2025-02-04T11:33:12.798Z"]],
          duration_s: 3.4,
        },
        {
          id: 82150,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 40 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01655_222.png"],
            },
          ],
          coverage: [["2025-02-04T11:33:15.512Z", "2025-02-04T11:33:21.144Z"]],
          duration_s: 5.6,
        },
        {
          id: 82153,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 47.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 2.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01656_967.png"],
            },
          ],
          coverage: [["2025-02-04T11:36:14.537Z", "2025-02-04T11:36:16.837Z"]],
          duration_s: 2.3,
        },
        {
          id: 82154,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 54 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 1.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01657_205.png", "demo_alpha_frame_01658_672.png"],
            },
          ],
          coverage: [["2025-02-04T11:36:22.526Z", "2025-02-04T11:36:24.422Z"]],
          duration_s: 1.9,
        },
        {
          id: 82157,
          depth: 2,
          name: "dial-contact",
          goal: "Open the fictional record for Demo Account 61 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 6.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01659_919.png"],
            },
          ],
          coverage: [["2025-02-04T11:37:00.326Z", "2025-02-04T11:37:07.139Z"]],
          duration_s: 6.8,
        },
        {
          id: 82161,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 68 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 0.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01660_934.png", "demo_alpha_frame_01661_283.png"],
            },
          ],
          coverage: [["2025-02-04T11:38:54.681Z", "2025-02-04T11:38:55.513Z"]],
          duration_s: 0.8,
        },
        {
          id: 82170,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 75 and record a fictional outcome in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01662_063.png", "demo_alpha_frame_01663_678.png"],
            },
          ],
          coverage: [["2025-02-04T11:55:32.004Z", "2025-02-04T11:55:35.481Z"]],
          duration_s: 3.5,
        },
        {
          id: 82183,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 82.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01664_777.png", "demo_alpha_frame_01665_606.png"],
            },
          ],
          coverage: [["2025-02-04T12:06:46.595Z", "2025-02-04T12:06:49.549Z"]],
          duration_s: 3.0,
        },
        {
          id: 82216,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Slack to continue Sample Workflow 89.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 4.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01666_056.png"],
            },
          ],
          coverage: [["2025-02-04T12:27:35.424Z", "2025-02-04T12:27:39.431Z"]],
          duration_s: 4.0,
        },
        {
          id: 82217,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Slack to continue Sample Workflow 96.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 1.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01667_989.png", "demo_alpha_frame_01668_369.png"],
            },
          ],
          coverage: [["2025-02-04T12:27:43.424Z", "2025-02-04T12:27:44.806Z"]],
          duration_s: 1.4,
        },
        {
          id: 82218,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Slack to continue Sample Workflow 14.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 1.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01669_427.png", "demo_alpha_frame_01670_401.png"],
            },
          ],
          coverage: [["2025-02-04T12:27:46.497Z", "2025-02-04T12:27:47.447Z"]],
          duration_s: 1.0,
        },
        {
          id: 82219,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Slack to continue Sample Workflow 21.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 2.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01671_893.png", "demo_alpha_frame_01672_290.png"],
            },
          ],
          coverage: [["2025-02-04T12:27:51.210Z", "2025-02-04T12:27:53.820Z"]],
          duration_s: 2.6,
        },
        {
          id: 82220,
          depth: 2,
          name: "review-document",
          goal: "Review and update Sample Enablement Guide 28 with fictional onboarding details in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 2.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01673_236.png", "demo_alpha_frame_01674_592.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 10",
              qualifier: "opened",
            },
          ],
          coverage: [["2025-02-04T12:27:58.722Z", "2025-02-04T12:28:00.831Z"]],
          duration_s: 2.1,
        },
        {
          id: 82221,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Slack to continue Sample Workflow 35.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 6.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01675_539.png"],
            },
          ],
          coverage: [["2025-02-04T12:28:04.263Z", "2025-02-04T12:28:10.790Z"]],
          duration_s: 6.5,
        },
        {
          id: 82222,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-42 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 1.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01676_036.png", "demo_alpha_frame_01677_278.png"],
            },
          ],
          coverage: [["2025-02-04T12:28:14.588Z", "2025-02-04T12:28:16.199Z"]],
          duration_s: 1.6,
        },
        {
          id: 82223,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-49 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 2.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01678_048.png"],
            },
          ],
          coverage: [["2025-02-04T12:28:21.617Z", "2025-02-04T12:28:23.836Z"]],
          duration_s: 2.2,
        },
        {
          id: 82228,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Gmail to continue Sample Workflow 56.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 1.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01679_221.png", "demo_alpha_frame_01680_217.png"],
            },
          ],
          coverage: [["2025-02-04T12:30:00.968Z", "2025-02-04T12:30:02.848Z"]],
          duration_s: 1.9,
        },
        {
          id: 82230,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Gmail to continue Sample Workflow 63.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 1.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01681_969.png", "demo_alpha_frame_01682_659.png"],
            },
          ],
          coverage: [["2025-02-04T12:30:11.258Z", "2025-02-04T12:30:12.965Z"]],
          duration_s: 1.7,
        },
        {
          id: 82231,
          depth: 2,
          name: "manage-calendar-event",
          goal: "Review a sample calendar entry for Demo Account 70 and update its demo availability in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 2.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01683_577.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 76",
              qualifier: "deleted",
            },
          ],
          coverage: [["2025-02-04T12:30:15.674Z", "2025-02-04T12:30:18.209Z"]],
          duration_s: 2.5,
        },
        {
          id: 82233,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 77.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 2.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01684_532.png", "demo_alpha_frame_01685_906.png"],
            },
          ],
          coverage: [["2025-02-04T12:30:51.667Z", "2025-02-04T12:30:53.728Z"]],
          duration_s: 2.1,
        },
        {
          id: 82234,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 84.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 1.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01686_907.png", "demo_alpha_frame_01687_897.png"],
            },
          ],
          coverage: [["2025-02-04T12:30:57.949Z", "2025-02-04T12:30:59.406Z"]],
          duration_s: 1.5,
        },
        {
          id: 82235,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Gmail to continue Sample Workflow 91.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 1.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01688_083.png", "demo_alpha_frame_01689_173.png"],
            },
          ],
          coverage: [["2025-02-04T12:31:04.158Z", "2025-02-04T12:31:05.393Z"]],
          duration_s: 1.2,
        },
        {
          id: 82236,
          depth: 2,
          name: "read-document",
          goal: "Review and update Sample Enablement Guide 98 with fictional onboarding details in Gmail.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 3.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01690_774.png", "demo_alpha_frame_01691_348.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 23",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T12:31:08.678Z", "2025-02-04T12:31:12.570Z"]],
          duration_s: 3.9,
        },
        {
          id: 82237,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 16.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01692_944.png", "demo_alpha_frame_01693_523.png"],
            },
          ],
          coverage: [["2025-02-04T12:31:17.663Z", "2025-02-04T12:31:22.660Z"]],
          duration_s: 5.0,
        },
        {
          id: 82238,
          depth: 2,
          name: "record-screen",
          goal: "Review Sample Session 23 and record a fictional outcome in Google Chrome.",
          attributes: [
            {
              name: "app.Google Chrome.duration_s",
              value: 4.2,
            },
          ],
          coverage: [["2025-02-04T12:31:23.692Z", "2025-02-04T12:31:27.870Z"]],
          duration_s: 4.2,
        },
        {
          id: 82239,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Google Chrome to continue Sample Workflow 30.",
          attributes: [
            {
              name: "app.Google Chrome.duration_s",
              value: 3.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01694_833.png", "demo_alpha_frame_01695_706.png"],
            },
          ],
          coverage: [["2025-02-04T12:31:31.686Z", "2025-02-04T12:31:35.114Z"]],
          duration_s: 3.4,
        },
        {
          id: 82240,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 37.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01696_972.png", "demo_alpha_frame_01697_192.png"],
            },
          ],
          coverage: [["2025-02-04T12:31:36.794Z", "2025-02-04T12:31:40.400Z"]],
          duration_s: 3.6,
        },
        {
          id: 82241,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 44.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.0,
            },
          ],
          coverage: [["2025-02-04T12:31:44.472Z", "2025-02-04T12:31:48.489Z"]],
          duration_s: 4.0,
        },
        {
          id: 82242,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Arc to continue Sample Workflow 51.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01698_241.png", "demo_alpha_frame_01699_242.png"],
            },
          ],
          coverage: [["2025-02-04T12:31:54.048Z", "2025-02-04T12:31:58.313Z"]],
          duration_s: 4.3,
        },
        {
          id: 82243,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-58 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 1.7,
            },
          ],
          relationships: [
            {
              object: "Demo Item 03",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T12:32:01.807Z", "2025-02-04T12:32:03.494Z"]],
          duration_s: 1.7,
        },
        {
          id: 82244,
          depth: 2,
          name: "navigate-dashboard",
          goal: "Move through Slack to continue Sample Workflow 65.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 5.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01700_192.png", "demo_alpha_frame_01701_690.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Item 14",
              qualifier: "viewed",
            },
          ],
          coverage: [["2025-02-04T12:32:03.950Z", "2025-02-04T12:32:09.116Z"]],
          duration_s: 5.2,
        },
        {
          id: 82254,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-72 and post a sample status update using Gmail.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 4.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01702_512.png"],
            },
          ],
          coverage: [["2025-02-04T13:12:49.535Z", "2025-02-04T13:12:54.106Z"]],
          duration_s: 4.6,
        },
        {
          id: 82262,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Arc and Slack to continue Sample Workflow 79.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.3,
            },
            {
              name: "app.Slack.duration_s",
              value: 2.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01703_344.png"],
            },
          ],
          coverage: [["2025-02-04T13:19:53.445Z", "2025-02-04T13:19:59.376Z"]],
          duration_s: 5.9,
        },
        {
          id: 82279,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Gmail to continue Sample Workflow 86.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 1.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01704_832.png", "demo_alpha_frame_01705_686.png"],
            },
          ],
          coverage: [["2025-02-04T13:32:04.115Z", "2025-02-04T13:32:05.926Z"]],
          duration_s: 1.8,
        },
        {
          id: 82281,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-93 and post a sample status update using Gmail.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 3.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01706_769.png"],
            },
          ],
          relationships: [
            {
              object: "Demo Contact 58",
              qualifier: "corresponded-with",
            },
          ],
          coverage: [["2025-02-04T13:32:37.470Z", "2025-02-04T13:32:41.210Z"]],
          duration_s: 3.7,
        },
        {
          id: 82285,
          depth: 2,
          name: "check-messages",
          goal: "Review the fictional conversation in #demo-ops-11 and post a sample status update using Gmail and Arc.",
          attributes: [
            {
              name: "app.Gmail.duration_s",
              value: 1.9,
            },
            {
              name: "app.Arc.duration_s",
              value: 0.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01707_127.png"],
            },
          ],
          coverage: [["2025-02-04T13:33:15.946Z", "2025-02-04T13:33:18.277Z"]],
          duration_s: 2.3,
        },
        {
          id: 82289,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Slack to continue Sample Workflow 18.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 3.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01708_785.png", "demo_alpha_frame_01709_122.png"],
            },
          ],
          coverage: [["2025-02-04T13:35:09.973Z", "2025-02-04T13:35:13.472Z"]],
          duration_s: 3.5,
        },
        {
          id: 82292,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 25 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 3.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01710_519.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 91",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T13:35:51.612Z", "2025-02-04T13:35:54.611Z"]],
          duration_s: 3.0,
        },
        {
          id: 82304,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Arc to continue Sample Workflow 32.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 1.9,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01711_359.png", "demo_alpha_frame_01712_916.png"],
            },
          ],
          coverage: [["2025-02-04T13:39:04.115Z", "2025-02-04T13:39:05.967Z"]],
          duration_s: 1.9,
        },
        {
          id: 82313,
          depth: 2,
          name: "browse-channels",
          goal: "Move through Arc to continue Sample Workflow 39.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01713_943.png"],
            },
          ],
          coverage: [["2025-02-04T14:15:05.747Z", "2025-02-04T14:15:08.867Z"]],
          duration_s: 3.1,
        },
        {
          id: 82314,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 46 and update its sample fields in Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 4.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01714_112.png", "demo_alpha_frame_01715_134.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 27",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:15:12.212Z", "2025-02-04T14:15:16.205Z"]],
          duration_s: 4.0,
        },
        {
          id: 82321,
          depth: 2,
          name: "review-recording",
          goal: "Review Sample Session 53 and record a fictional outcome in Google Chrome and Slack.",
          attributes: [
            {
              name: "app.Google Chrome.duration_s",
              value: 3.7,
            },
            {
              name: "app.Slack.duration_s",
              value: 0.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01716_031.png"],
            },
          ],
          coverage: [["2025-02-04T14:19:43.668Z", "2025-02-04T14:19:47.485Z"]],
          duration_s: 3.8,
        },
        {
          id: 82328,
          depth: 2,
          name: "send-message",
          goal: "Review the fictional conversation in #demo-ops-60 and post a sample status update using Slack.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 5.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01717_397.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 49",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 66",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:23:18.843Z", "2025-02-04T14:23:23.830Z"]],
          duration_s: 5.0,
        },
        {
          id: 82337,
          depth: 2,
          name: "read-document",
          goal: "Review and update Sample Enablement Guide 67 with fictional onboarding details in Notion.",
          attributes: [
            {
              name: "app.Notion.duration_s",
              value: 1.4,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01718_292.png", "demo_alpha_frame_01719_919.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 60",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:39:21.867Z", "2025-02-04T14:39:23.217Z"]],
          duration_s: 1.4,
        },
        {
          id: 82338,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Arc to continue Sample Workflow 74.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01720_401.png"],
            },
          ],
          coverage: [["2025-02-04T14:39:27.801Z", "2025-02-04T14:39:31.337Z"]],
          duration_s: 3.5,
        },
        {
          id: 82347,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Slack to continue Sample Workflow 81.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 3.5,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01721_853.png"],
            },
          ],
          coverage: [["2025-02-04T14:46:09.868Z", "2025-02-04T14:46:13.330Z"]],
          duration_s: 3.5,
        },
        {
          id: 82356,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 88 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 5.8,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01722_450.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 93",
              qualifier: "referenced",
            },
            {
              object: "Sample Reference 13",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:51:59.672Z", "2025-02-04T14:52:05.450Z"]],
          duration_s: 5.8,
        },
        {
          id: 82358,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 95 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 2.8,
            },
          ],
          coverage: [["2025-02-04T14:52:37.273Z", "2025-02-04T14:52:40.081Z"]],
          duration_s: 2.8,
        },
        {
          id: 82365,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 13 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 4.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01723_281.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 18",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:53:31.646Z", "2025-02-04T14:53:36.216Z"]],
          duration_s: 4.6,
        },
        {
          id: 82367,
          depth: 2,
          name: "review-record",
          goal: "Open the fictional record for Demo Account 20 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 2.1,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01724_775.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 29",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:54:00.372Z", "2025-02-04T14:54:02.435Z"]],
          duration_s: 2.1,
        },
        {
          id: 82373,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 27 and update its sample fields in Salesforce.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 5.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01725_301.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 40",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:55:22.519Z", "2025-02-04T14:55:27.535Z"]],
          duration_s: 5.0,
        },
        {
          id: 82375,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 34 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01726_430.png", "demo_alpha_frame_01727_359.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 51",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 68",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:55:46.084Z", "2025-02-04T14:55:49.773Z"]],
          duration_s: 3.7,
        },
        {
          id: 82376,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 41 and update its sample fields in Salesforce and Arc.",
          attributes: [
            {
              name: "app.Salesforce.duration_s",
              value: 3.9,
            },
            {
              name: "app.Arc.duration_s",
              value: 1.2,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01728_334.png", "demo_alpha_frame_01729_055.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 62",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:55:50.943Z", "2025-02-04T14:55:56.076Z"]],
          duration_s: 5.1,
        },
        {
          id: 82377,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 48 and update its sample fields in Arc and Salesforce.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 2.4,
            },
            {
              name: "app.Salesforce.duration_s",
              value: 1.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01730_525.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 73",
              qualifier: "edited",
            },
            {
              object: "Sample Reference 90",
              qualifier: "referenced",
            },
          ],
          coverage: [["2025-02-04T14:56:00.227Z", "2025-02-04T14:56:04.364Z"]],
          duration_s: 4.1,
        },
        {
          id: 82379,
          depth: 2,
          name: "search-record",
          goal: "Open the fictional record for Demo Account 55 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.3,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01731_017.png"],
            },
          ],
          coverage: [["2025-02-04T14:56:37.526Z", "2025-02-04T14:56:42.798Z"]],
          duration_s: 5.3,
        },
        {
          id: 82389,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 62 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 4.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01732_942.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 95",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T14:59:20.892Z", "2025-02-04T14:59:24.889Z"]],
          duration_s: 4.0,
        },
        {
          id: 82390,
          depth: 2,
          name: "enrich-data",
          goal: "Open the fictional record for Demo Account 69 and update its sample fields in Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 5.6,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01733_635.png"],
            },
          ],
          relationships: [
            {
              object: "Sample Reference 09",
              qualifier: "edited",
            },
          ],
          coverage: [["2025-02-04T14:59:29.095Z", "2025-02-04T14:59:34.690Z"]],
          duration_s: 5.6,
        },
        {
          id: 82392,
          depth: 2,
          name: "navigate-workspace",
          goal: "Move through Slack to continue Sample Workflow 76.",
          attributes: [
            {
              name: "app.Slack.duration_s",
              value: 3.0,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01734_510.png", "demo_alpha_frame_01735_351.png"],
            },
          ],
          coverage: [["2025-02-04T14:59:45.909Z", "2025-02-04T14:59:48.879Z"]],
          duration_s: 3.0,
        },
        {
          id: 82400,
          depth: 2,
          name: "research-person",
          goal: "Complete a fictional research-person task for Demo Account 83 using Arc.",
          attributes: [
            {
              name: "app.Arc.duration_s",
              value: 3.7,
            },
            {
              name: "screenshots",
              value: ["demo_alpha_frame_01736_589.png"],
            },
          ],
          coverage: [["2025-02-04T15:03:58.724Z", "2025-02-04T15:04:02.465Z"]],
          duration_s: 3.7,
        },
        {
          id: 87008,
          depth: 3,
          name: "Research Target Account (LinkedIn)",
          goal: "Research Demo Account 90 and summarize its fictional business profile in LinkedIn.",
          duration_s: 40.0,
          children: [82010],
        },
        {
          id: 87010,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 97 and update its sample fields in Arc.",
          duration_s: 13.6,
          children: [82012],
        },
        {
          id: 87014,
          depth: 3,
          name: "Research Target Account (LinkedIn)",
          goal: "Research Demo Account 15 and summarize its fictional business profile in LinkedIn.",
          duration_s: 7.0,
          children: [82016],
        },
        {
          id: 87018,
          depth: 3,
          name: "Review Recording (Arc)",
          goal: "Review Sample Session 22 and record a fictional outcome in Arc.",
          duration_s: 34.5,
          children: [82020],
        },
        {
          id: 87035,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-29 and post a sample status update using Slack.",
          duration_s: 41.6,
          children: [82045],
        },
        {
          id: 87038,
          depth: 3,
          name: "Review Recording (Slack)",
          goal: "Review Sample Session 36 and record a fictional outcome in Slack.",
          duration_s: 34.3,
          children: [82048],
        },
        {
          id: 87041,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-43 and post a sample status update using Slack.",
          duration_s: 45.3,
          children: [82051],
        },
        {
          id: 87043,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-50 and post a sample status update using Slack.",
          duration_s: 46.5,
          children: [82053],
        },
        {
          id: 87044,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-57 and post a sample status update using Slack.",
          duration_s: 66.7,
          children: [82054],
        },
        {
          id: 87049,
          depth: 3,
          name: "LinkedIn Outreach (LinkedIn)",
          goal: "Draft and send a sample follow-up to Demo Contact 64 using LinkedIn.",
          duration_s: 4.6,
          children: [82062],
        },
        {
          id: 87050,
          depth: 3,
          name: "Check Messages (LinkedIn)",
          goal: "Review the fictional conversation in #demo-ops-71 and post a sample status update using LinkedIn.",
          duration_s: 12.2,
          children: [82063],
        },
        {
          id: 87068,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 78 and update its demo availability in Arc.",
          duration_s: 244.9,
          children: [82084],
        },
        {
          id: 87069,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 85 and update its demo status in Arc.",
          duration_s: 864.8,
          children: [82085],
        },
        {
          id: 87074,
          depth: 3,
          name: "Resolve Tooling or Access Issue (Messages)",
          goal: "Review the fictional conversation in #demo-ops-92 and post a sample status update using Messages.",
          duration_s: 54.1,
          children: [82090],
        },
        {
          id: 87080,
          depth: 3,
          name: "Configure Onboarding Tools and Resources (Arc)",
          goal: "Review and update Sample Enablement Guide 10 with fictional onboarding details in Arc.",
          duration_s: 8.2,
          children: [82096],
        },
        {
          id: 87085,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 17 and update its demo status in Arc.",
          duration_s: 7.4,
          children: [82103],
        },
        {
          id: 87088,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 24 and update its demo status in Arc.",
          duration_s: 24.6,
          children: [82107],
        },
        {
          id: 87091,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 31 and update its demo status in Arc.",
          duration_s: 9.3,
          children: [82113],
        },
        {
          id: 87132,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 38 and update its sample fields in Arc.",
          duration_s: 58.4,
          children: [82167],
        },
        {
          id: 87145,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 45 and update its demo status in Arc.",
          duration_s: 9.0,
          children: [82181],
        },
        {
          id: 87146,
          depth: 3,
          name: "Review Sequence/Campaign Performance (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 52 and update its demo status in Arc.",
          duration_s: 30.0,
          children: [82182],
        },
        {
          id: 87165,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-59 and post a sample status update using Slack.",
          duration_s: 13.1,
          children: [82202],
        },
        {
          id: 87171,
          depth: 3,
          name: "Share Content (Slack)",
          goal: "Review and update Sample Enablement Guide 66 with fictional onboarding details in Slack.",
          duration_s: 43.5,
          children: [82208],
        },
        {
          id: 87186,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-73 and post a sample status update using Slack.",
          duration_s: 16.3,
          children: [82246],
        },
        {
          id: 87191,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 80 and update its sample fields in Arc.",
          duration_s: 40.0,
          children: [82251],
        },
        {
          id: 87192,
          depth: 3,
          name: "Lookup Reference (Arc)",
          goal: "Review and update Sample Enablement Guide 87 with fictional onboarding details in Arc.",
          duration_s: 1242.5,
          children: [82252],
        },
        {
          id: 87197,
          depth: 3,
          name: "Lookup Reference (Arc)",
          goal: "Review and update Sample Enablement Guide 94 with fictional onboarding details in Arc.",
          duration_s: 35.6,
          children: [82258],
        },
        {
          id: 87202,
          depth: 3,
          name: "Research Target Account (Slack)",
          goal: "Research Demo Account 12 and summarize its fictional business profile in Slack.",
          duration_s: 7.3,
          children: [82264],
        },
        {
          id: 87230,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-19 and post a sample status update using Slack.",
          duration_s: 15.4,
          children: [82297],
        },
        {
          id: 87237,
          depth: 3,
          name: "Check Messages (Slack)",
          goal: "Review the fictional conversation in #demo-ops-26 and post a sample status update using Slack.",
          duration_s: 16.7,
          children: [82305],
        },
        {
          id: 87253,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Notion)",
          goal: "Review and update Sample Enablement Guide 33 with fictional onboarding details in Notion.",
          duration_s: 6.0,
          children: [82324],
        },
        {
          id: 87255,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 40 and update its sample fields in Arc.",
          duration_s: 46.5,
          children: [82326],
        },
        {
          id: 87257,
          depth: 3,
          name: "Provision New Hire Access (Arc)",
          goal: "Verify the sample workspace configuration for Demo Contact 47 using Arc.",
          duration_s: 15.9,
          children: [82329],
        },
        {
          id: 87259,
          depth: 3,
          name: "Author Onboarding or Reference Doc (Notion)",
          goal: "Review and update Sample Enablement Guide 54 with fictional onboarding details in Notion.",
          duration_s: 3.6,
          children: [82331],
        },
        {
          id: 87260,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-61 and post a sample status update using Slack.",
          duration_s: 6.4,
          children: [82332],
        },
        {
          id: 87272,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-68 and post a sample status update using Slack.",
          duration_s: 74.8,
          children: [82346],
        },
        {
          id: 87286,
          depth: 3,
          name: "Enrich Contact Data (Arc)",
          goal: "Open the fictional record for Demo Account 75 and update its sample fields in Arc.",
          duration_s: 5.2,
          children: [82363],
        },
        {
          id: 87292,
          depth: 3,
          name: "Message Teammate (lemlist)",
          goal: "Review the fictional conversation in #demo-ops-82 and post a sample status update using lemlist.",
          duration_s: 15.9,
          children: [82371],
        },
        {
          id: 87296,
          depth: 3,
          name: "Review Recording (Arc)",
          goal: "Review Sample Session 89 and record a fictional outcome in Arc.",
          duration_s: 5.3,
          children: [82380],
        },
        {
          id: 87326,
          depth: 3,
          name: "Review Pipeline / Lead Queue (Arc)",
          goal: "Review the sample outreach workflow for Demo Account 96 and update its demo status in Arc.",
          duration_s: 7.3,
          children: [82414],
        },
        {
          id: 87330,
          depth: 3,
          name: "Update CRM Record (Arc)",
          goal: "Open the fictional record for Demo Account 14 and update its sample fields in Arc.",
          duration_s: 53.2,
          children: [82418],
        },
        {
          id: 87332,
          depth: 3,
          name: "Check Messages (Slack)",
          goal: "Review the fictional conversation in #demo-ops-21 and post a sample status update using Slack.",
          duration_s: 40.6,
          children: [82420],
        },
        {
          id: 87334,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 28 and update its demo availability in Arc.",
          duration_s: 24.4,
          children: [82422],
        },
        {
          id: 87335,
          depth: 3,
          name: "Manage Calendar and Availability (Arc)",
          goal: "Review a sample calendar entry for Demo Account 35 and update its demo availability in Arc.",
          duration_s: 21.3,
          children: [82423],
        },
        {
          id: 87338,
          depth: 3,
          name: "Message Teammate (Slack)",
          goal: "Review the fictional conversation in #demo-ops-42 and post a sample status update using Slack.",
          duration_s: 21.3,
          children: [82426],
        },
        {
          id: 87351,
          depth: 3,
          name: "Lookup Reference (Arc)",
          goal: "Review and update Sample Enablement Guide 49 with fictional onboarding details in Arc.",
          duration_s: 15.5,
          children: [82439],
        },
      ],
    },
  },
  include_in_processes: true,
};
